var _CUSTOM_COD_FORM_PROVINCES = {
  data: {
    AB: {
      "Alba Iulia": true,
      Cugir: true,
      Aiud: true,
      Sebes: true,
      Blaj: true,
      "Ocna Mures": true,
      Teius: true,
      Campeni: true,
      Abrud: true,
      Zlatna: true,
      Petresti: true,
      Unirea: true,
      "Baia de Aries": true,
      "Daia Romana": true,
      "Vintu de Jos": true,
      Vinerea: true,
      Mihalt: true,
      "Aiudul de Sus": true,
      "Bucerdea Granoasa": true,
      Barabant: true,
      "Lunca Muresului": true,
      Izvoarele: true,
      "Cetatea de Balta": true,
      "Craciunelu de Jos": true,
      "Galda de Jos": true,
      Sard: true,
      "Valea Lunga": true,
      Oarda: true,
      Tiur: true,
      Sancel: true,
      "Pianu de Sus": true,
      Bistra: true,
      Veza: true,
      "Rosia Montana": true,
      "Razboieni-Cetate": true,
      Sasciori: true,
      Ciumbrud: true,
      Lancram: true,
      Sanmiclaus: true,
      Garbova: true,
      Stremt: true,
      Micesti: true,
      "Uioara de Sus": true,
      Biia: true,
      Cut: true,
      "Abrud-Sat": true,
      "Uioara de Jos": true,
      Sibot: true,
      Sugag: true,
      Salistea: true,
      Jidvei: true,
      Telna: true,
      Calnic: true,
      Cricau: true,
      Ighiu: true,
      Fenes: true,
      Santimbru: true,
      "Pianu de Jos": true,
      "Lopadea Noua": true,
      Balcaciu: true,
      Cenade: true,
      Dobra: true,
      Sebesel: true,
      "Bucerdea Vanoasa": true,
      Ighiel: true,
      Veseus: true,
      "Cergau Mare": true,
      Feisa: true,
      Sancrai: true,
      Sona: true,
      Capalna: true,
      Miraslau: true,
      Rahau: true,
      "Capalna de Jos": true,
      "Geoagiu de Sus": true,
      "Almasu Mare": true,
      Oiejdea: true,
      Noslac: true,
      Manarade: true,
      "Rosia de Secas": true,
      Livezile: true,
      Obreja: true,
      Scarisoara: true,
      Tatarlaua: true,
      Lupsa: true,
      Coltesti: true,
      Ciuguzel: true,
      Tartaria: true,
      Rachita: true,
      "Valea Lupsii": true,
      Farau: true,
      Decea: true,
      Radesti: true,
      Panade: true,
      Ohaba: true,
      Ampoita: true,
      Ghirbom: true,
      Vingard: true,
      "Salciua de Jos": true,
      Paclisa: true,
      Blandiana: true,
      Cistei: true,
      Berghin: true,
      "Cisteiu de Mures": true,
      Rametea: true,
      "Balomiru de Camp": true,
      Tauti: true,
      Magina: true,
      "Salciua de Sus": true,
      Bagau: true,
      Dostat: true,
      Ciuruleasa: true,
      Loman: true,
      Spring: true,
      Seusa: true,
      Cunta: true,
      Trampoiele: true,
      Musca: true,
      Tau: true,
      Gambas: true,
      Drasov: true,
      Totoi: true,
      Cetea: true,
      Lunca: true,
      Beta: true,
      "Valea Vintului": true,
      "Gura Ariesului": true,
      "Posaga de Jos": true,
      Martinie: true,
      Albac: true,
      Ocolis: true,
      "Valea Mica": true,
      Deal: true,
      "Poiana Aiudului": true,
      Benic: true,
      Hapria: true,
      Acmariu: true,
      Henig: true,
      Tauni: true,
      Sartas: true,
      Silea: true,
      "Izvoru Ampoiului": true,
      Geomal: true,
      "Galda de Sus": true,
      Laz: true,
      Galati: true,
      "Garbova de Jos": true,
      Matisesti: true,
      "Presaca Ampoiului": true,
      Vurpar: true,
      "Lunca Tarnavei": true,
      Arti: true,
      Iclod: true,
      Metes: true,
      Tibru: true,
      Garde: true,
      "Garda de Sus": true,
      Ciugud: true,
      Mahaceni: true,
      "Ciugudu de Jos": true,
      Muncelu: true,
      "Lopadea Veche": true,
      "Tau Bistra": true,
      Patrangeni: true,
      Coslariu: true,
      Straja: true,
      Hoparta: true,
      Galtiu: true,
      Daroaia: true,
      Carpinis: true,
      Cib: true,
      Captalan: true,
      Dumbrava: true,
      Purcareti: true,
      Teleac: true,
      Heria: true,
      "Cergau Mic": true,
      "Valea Bistrii": true,
      Darlesti: true,
      Craiva: true,
      Lupu: true,
      Sanbenedic: true,
      Drambar: true,
      Boz: true,
      Capud: true,
      Hadarau: true,
      Turdas: true,
      Leorint: true,
      Corna: true,
      Tarsa: true,
      "Garbova de Sus": true,
      Sagagea: true,
      Lazuri: true,
      Ungurei: true,
      Santamarie: true,
      Secasel: true,
      "Poiana Ampoiului": true,
      Micoslaca: true,
      Gabud: true,
      Spalnaca: true,
      Bacainti: true,
      Hodisesti: true,
      "Dealu Capsei": true,
      Fata: true,
      Tonea: true,
      Petrisat: true,
      Brazesti: true,
      Ocoale: true,
      "Cioara de Sus": true,
      Barsana: true,
      "Ciugudu de Sus": true,
      Horea: true,
      "Gura Cornei": true,
      Limba: true,
      Valeni: true,
      Alecus: true,
      Ciuldesti: true,
      Petelca: true,
      Valisoara: true,
      Mescreac: true,
      Lodroman: true,
      Reciu: true,
      "Dealu Frumos": true,
      Glod: true,
      Inoc: true,
      "Posaga de Sus": true,
      "Dealu Muntelui": true,
      "Dealu Lamasoi": true,
      Medves: true,
      Soharu: true,
      Valtori: true,
      Cicau: true,
      Saracsau: true,
      "Craciunelu de Sus": true,
      "Salistea-Deal": true,
      Beldiu: true,
      Curaturi: true,
      "Vama Seaca": true,
      Cobles: true,
      "Almasu de Mijloc": true,
      "Parau Gruiului": true,
      Copand: true,
      Geogel: true,
      Asinip: true,
      "Vale In Jos": true,
      Carpen: true,
      Nadastia: true,
      Glogovet: true,
      Sohodol: true,
      Necsesti: true,
      Cretesti: true,
      Strungari: true,
      Stiuleti: true,
      "Valea Sesii": true,
      Silivas: true,
      "Stana de Mures": true,
      Mesentea: true,
      Necrilesti: true,
      "Fata Cristesei": true,
      Barasti: true,
      Pitiga: true,
      "Bucium-Sat": true,
      Fericet: true,
      Galbena: true,
      Runc: true,
      "Gura Sohodol": true,
      Costesti: true,
      Mereteu: true,
      Lipaia: true,
      Vartop: true,
      Moraresti: true,
      Bradeana: true,
      "Vadu Motilor": true,
      "Sub Piatra": true,
      Patrusesti: true,
      "Poiana Vadului": true,
      "Valea Larga": true,
      Varsi: true,
      "Lunca Ampoitei": true,
      Mihoesti: true,
      "Valea Morii": true,
      Negesti: true,
      "Poienile-Mogos": true,
      Pastesti: true,
      Floresti: true,
      "Dealu Bajului": true,
      "Avram Iancu": true,
      "Fagetu de Sus": true,
      "Dupa Plese": true,
      "Poiana Galdei": true,
      Tarina: true,
      Suseni: true,
      Vai: true,
      Stanesti: true,
      Boncesti: true,
      Pagida: true,
      Garbovita: true,
      Pirita: true,
      Bodesti: true,
      Orasti: true,
      "Poduri-Bricesti": true,
      "Fata Abrudului": true,
      Vidolm: true,
      Modolesti: true,
      Inuri: true,
      "Popestii de Sus": true,
      Botesti: true,
      Mogos: true,
      Ponor: true,
      "Valea Manastirii": true,
      Boglesti: true,
      Dric: true,
      "Lunca Merilor": true,
      Trisoresti: true,
      Mugesti: true,
      Poduri: true,
      Ganesti: true,
      Plai: true,
      Plesi: true,
      Barlesti: true,
      "Garda Seaca": true,
      "Valea Abruzel": true,
      Hudricesti: true,
      Bilanesti: true,
      "Fata Lapusului": true,
      Buninginea: true,
      Izlaz: true,
      Poieni: true,
      Borlesti: true,
      Bucuru: true,
      "Coasta Hentii": true,
      "Valea Caselor": true,
      "Campu Goblii": true,
      Cotorasti: true,
      Dumitra: true,
      Jidostina: true,
      Plescuta: true,
      "Valea Barnii": true,
      "Coasta Vascului": true,
      "Valea Negrilesii": true,
      "Dealu Caselor": true,
      Tomutesti: true,
      Ghioncani: true,
      "Lunca Metesului": true,
      Ormenis: true,
      "Parau lui Mihai": true,
      Cerbu: true,
      Ghetari: true,
      Duduieni: true,
      "Dupa Deal": true,
      "Lunca Larga": true,
      Biharia: true,
      Intregalde: true,
      Pantesti: true,
      "Dealu Bistrii": true,
      Calene: true,
      Luminesti: true,
      Ratitis: true,
      Snide: true,
      Bucium: true,
      Cionesti: true,
      "Fagetu de Jos": true,
      Feteni: true,
      Lespezea: true,
      Soal: true,
      Dolesti: true,
      "Fata-Lazesti": true,
      Lazesti: true,
      "Valea Alba": true,
      "Valea Inzelului": true,
      Dandut: true,
      Hanasesti: true,
      Ivanis: true,
      Poiana: true,
      Tifra: true,
      Budaiesti: true,
      Calugaresti: true,
      "Dealu Geoagiului": true,
      Rogoz: true,
      Vulcan: true,
      Dumesti: true,
      "Fata Pietrii": true,
      Huzaresti: true,
      "Valea Mlacii": true,
      "Popestii de Jos": true,
      Spatac: true,
      "Varsii Mici": true,
      "Dragoiesti-Lunca": true,
      "Valea Goblii": true,
      Haiducesti: true,
      Motorasti: true,
      Trifesti: true,
      "Garda-Barbulesti": true,
      Sfoartea: true,
      "Gura Rosiei": true,
      Vidrisoara: true,
      Arieseni: true,
      Giurgiut: true,
      "Valea Uzei": true,
      Blidesti: true,
      Ignatesti: true,
      Hoanca: true,
      Ghedulesti: true,
      Margineni: true,
      Preluca: true,
      Verdesti: true,
      Plaiuri: true,
      Soimus: true,
      Certege: true,
      Furduiesti: true,
      Petelei: true,
      "Coslariu Nou": true,
      Faget: true,
      Bubesti: true,
      Vladosesti: true,
      Cocesti: true,
      Colibi: true,
      "Valea Poienii": true,
      Mununa: true,
      Anghelesti: true,
      Culdesti: true,
      "Stei-Arieseni": true,
      "Valea Ciuciului": true,
      Cristesti: true,
      "Dealu Goiesti": true,
      Dos: true,
      "Valea Cerbului": true,
      Budeni: true,
      Butesti: true,
      "Ceru-Bacainti": true,
      Odverem: true,
      Potionci: true,
      Sfarcea: true,
      Bocsitura: true,
      Mancesti: true,
      Vinta: true,
      "Balesti-Catun": true,
      "Lunca Vesesti": true,
      Manastire: true,
      Nemesi: true,
      Tomusesti: true,
      Durasti: true,
      Patrahaitesti: true,
      Goiesti: true,
      Zanzesti: true,
      Posogani: true,
      Coleseni: true,
      Bobaresti: true,
      "Lunca Bisericii": true,
      Teiu: true,
      "Valea Bucurului": true,
      Lehesti: true,
      Oidesti: true,
      Puiuletesti: true,
      Sebisesti: true,
      "Lunca Goiesti": true,
      Orgesti: true,
      Sturu: true,
      Incesti: true,
      Peles: true,
      Izbita: true,
      Namas: true,
      Cojocani: true,
      Plesesti: true,
      Rusesti: true,
      Sucesti: true,
      Dambureni: true,
      Hodobana: true,
      Petreasa: true,
      Tecsesti: true,
      "Valea Tupilor": true,
      Burzonesti: true,
      Ciuculesti: true,
      Criseni: true,
      Cucuta: true,
      Matei: true,
      Simocesti: true,
      Stauini: true,
      Dobresti: true,
      Martesti: true,
      Poienita: true,
      Padurea: true,
      Rusi: true,
      Patrutesti: true,
      "Podu lui Paul": true,
      Rosesti: true,
      Vidra: true,
      Bogdanesti: true,
      "Valea Fagetului": true,
      Bazesti: true,
      "Casa de Piatra": true,
      Poiu: true,
      Ramet: true,
      Coroiesti: true,
      Ficaresti: true,
      Gojeiesti: true,
      Macaresti: true,
      Bradesti: true,
      Heleresti: true,
      "Peste Valea Bistrii": true,
      Bradet: true,
      Dilimani: true,
      Mamaligani: true,
      Oncesti: true,
      "Valea Giogesti": true,
      Bodresti: true,
      "Cheile Cibului": true,
      Mihaiesti: true,
      Munesti: true,
      Nicoresti: true,
      Valcaneasa: true,
      Avramesti: true,
      "Dosu Luncii": true,
      Dumacesti: true,
      Dumbravita: true,
      Magura: true,
      Tolacesti: true,
      Vartanesti: true,
      Curpeni: true,
      Iacobesti: true,
      Lupseni: true,
      Napaiesti: true,
      "Dealu Ferului": true,
      "Valea Utului": true,
      Vasesti: true,
      Novacesti: true,
      Ponorel: true,
      Stefanca: true,
      Surdesti: true,
      "Valea lui Mihai": true,
      Vladesti: true,
      Bulbuc: true,
      Cartulesti: true,
      Curmatura: true,
      Niculesti: true,
      Ocnisoara: true,
      Racatau: true,
      "Gura Cutului": true,
      Soicesti: true,
      Taranesti: true,
      Barbesti: true,
      Burzesti: true,
      "Dealu Roatei": true,
      Barzan: true,
      Hategana: true,
      Jojei: true,
      Lupaiesti: true,
      Salagesti: true,
      Totesti: true,
      "Valea Barlutesti": true,
      Grosi: true,
      Casoaia: true,
      Morcanesti: true,
      Raicani: true,
      Baba: true,
      Barzogani: true,
      Deoncesti: true,
      Fantanele: true,
      Feresti: true,
      Lupulesti: true,
      "Parau-Carbunari": true,
      Urdes: true,
      Valcea: true,
      Deve: true,
      Nelegesti: true,
      Segaj: true,
      Tamboresti: true,
      Padure: true,
      Pitarcesti: true,
      Trancesti: true,
      "Valea Mare": true,
      Balmosesti: true,
      Bunta: true,
      Olteni: true,
      Gligoresti: true,
      Rachis: true,
      Sicoiesti: true,
      "Valea Holhorii": true,
      Bisericani: true,
      "Valea Sasului": true,
      Balesti: true,
      Carasti: true,
      Plisti: true,
      "Valea Cocesti": true,
      Bidigesti: true,
      Bocesti: true,
      Goasele: true,
      Vanvucesti: true,
      Badai: true,
      Tomesti: true,
      "Barlesti-Catun": true,
      "Gura Izbitei": true,
      Sorlita: true,
      Helesti: true,
      Jeflesti: true,
      Ravicesti: true,
      Bai: true,
      Cornu: true,
      "Tarsa-Plai": true,
      "Varsi-Rontu": true,
      Cortesti: true,
      Iliesti: true,
      "Lunca de Jos": true,
      "Valea Verde": true,
      Achimetesti: true,
      Candesti: true,
      Cheleteni: true,
      Dobrot: true,
      Cocosesti: true,
      "Dealu Ordancusii": true,
      Marinesti: true,
      Scoarta: true,
      Stalnisoara: true,
      Bolovanesti: true,
      Remetea: true,
      Ciocasu: true,
      Panca: true,
      Sasa: true,
      "Dealu Dostatului": true,
      "Poiana Ursului": true,
      Gorgan: true,
      Holobani: true,
      Izbicioara: true,
      Matacina: true,
      Negresti: true,
      Bardesti: true,
      Dogaresti: true,
      Perjesti: true,
      Puselesti: true,
      Popesti: true,
      Robesti: true,
      Runcuri: true,
      Tomnatec: true,
      "Valea Maciului": true,
      "Varsii Mari": true,
      Joldisesti: true,
      Cheia: true,
      Viezuri: true,
      Isca: true,
      "Dosu Vasesti": true,
      Boldesti: true,
      Toci: true,
      Stertesti: true,
      Valcesti: true,
      Aronesti: true,
      "Bordestii Poieni": true,
      Maghierat: true,
      Zagris: true,
      "Capu Dealului": true,
      Muntari: true,
      Simulesti: true,
      Jurcuiesti: true,
      Margaia: true,
      Petreni: true,
      "Dealu Crisului": true,
      Harasti: true,
      Ibru: true,
      Botani: true,
      Cicard: true,
      Geamana: true,
      Medresti: true,
      "Deleni-Obarsie": true,
      "Carpenii de Sus": true,
      Flitesti: true,
      Doptau: true,
      Zaries: true,
    },
    AR: {
      Arad: true,
      Pecica: true,
      Santana: true,
      Ineu: true,
      Lipova: true,
      Nadlac: true,
      Curtici: true,
      "Chisineu-Cris": true,
      Pancota: true,
      Sebis: true,
      Vladimirescu: true,
      Siria: true,
      Vinga: true,
      Simand: true,
      Macea: true,
      Semlac: true,
      Sepreus: true,
      Seitin: true,
      Covasint: true,
      Sicula: true,
      Bocsig: true,
      Apateu: true,
      Felnac: true,
      Radna: true,
      Socodor: true,
      Horia: true,
      Buteni: true,
      Fantanele: true,
      Gurahont: true,
      Zabrani: true,
      Seleus: true,
      Secusigiu: true,
      Iratosu: true,
      Sagu: true,
      Zadareni: true,
      Beliu: true,
      Galsa: true,
      "Sanpetru German": true,
      Sofronea: true,
      Cermei: true,
      Tarnova: true,
      Ghioroc: true,
      Nadab: true,
      Dorobanti: true,
      "Andrei Saguna": true,
      Paulis: true,
      Sanmartin: true,
      Sambateni: true,
      Almas: true,
      Olari: true,
      Cuvin: true,
      Frumuseni: true,
      "Zimandu Nou": true,
      Zarand: true,
      Savarsin: true,
      Maderat: true,
      Sanleani: true,
      Tipar: true,
      Gurba: true,
      Livada: true,
      Graniceri: true,
      "Caporal Alexa": true,
      Cintei: true,
      Chesint: true,
      Zimandcuz: true,
      Halmagiu: true,
      Vanatori: true,
      Siclau: true,
      Misca: true,
      "Sintea Mare": true,
      Turnu: true,
      Chisindia: true,
      Manastur: true,
      Mailat: true,
      Chier: true,
      Mandruloc: true,
      Draut: true,
      Barsa: true,
      Barzava: true,
      "Peregu Mic": true,
      Masca: true,
      Cherelus: true,
      Nadas: true,
      Adea: true,
      Capalnas: true,
      Neudorf: true,
      "Agrisu Mare": true,
      Zerind: true,
      "Peregu Mare": true,
      "Satu Mare": true,
      Pilu: true,
      Berechiu: true,
      Somosches: true,
      Groseni: true,
      Dezna: true,
      Mocrea: true,
      Taut: true,
      Moneasa: true,
      Varfurile: true,
      "Tisa Noua": true,
      "Satu Nou": true,
      Cicir: true,
      Alunis: true,
      Cuied: true,
      "Avram Iancu": true,
      Dieci: true,
      Varsand: true,
      Rapsig: true,
      Carand: true,
      Soimos: true,
      "Varadia de Mures": true,
      Minis: true,
      Birchis: true,
      Halmagel: true,
      Moroda: true,
      Bontesti: true,
      Chislaca: true,
      Petris: true,
      "Iermata Neagra": true,
      Cil: true,
      Luncsoara: true,
      Craiva: true,
      Aldesti: true,
      Sanpaul: true,
      Prunisor: true,
      Cruceni: true,
      Brusturi: true,
      Selistea: true,
      Hasmas: true,
      Conop: true,
      Radesti: true,
      Paiuseni: true,
      Tagadau: true,
      Talagiu: true,
      Milova: true,
      Crocna: true,
      Dud: true,
      Lazuri: true,
      Munar: true,
      Ususau: true,
      Fiscut: true,
      Lalasint: true,
      Secas: true,
      Susag: true,
      "Vasile Goldis": true,
      Toc: true,
      Odvos: true,
      Silindia: true,
      Archis: true,
      Iermata: true,
      Bata: true,
      Julita: true,
      Araneag: true,
      Chelmac: true,
      Firiteaz: true,
      Zimbru: true,
      Manerau: true,
      "Variasu Mare": true,
      Motiori: true,
      "Rosia Noua": true,
      "Sintea Mica": true,
      Cladova: true,
      Belotint: true,
      Dumbravita: true,
      Caprioara: true,
      Tela: true,
      Hontisor: true,
      Vidra: true,
      Lupesti: true,
      Paulian: true,
      Magulicea: true,
      Pescari: true,
      Leasa: true,
      Maraus: true,
      Plescuta: true,
      Capruta: true,
      "Grosii Noi": true,
      Ilteu: true,
      Tisa: true,
      Siad: true,
      Madrigesti: true,
      Ranusa: true,
      "Nicolae Balcescu": true,
      Sistarovat: true,
      Zabalt: true,
      Baratca: true,
      Banesti: true,
      Aciuta: true,
      Tarmure: true,
      Monorostia: true,
      Susani: true,
      Iacobini: true,
      Sederhat: true,
      Minisel: true,
      Parnesti: true,
      Ignesti: true,
      Iosas: true,
      Poienari: true,
      "Valea Mare": true,
      "Zerindu Mic": true,
      Ostrov: true,
      "Urvisu de Beliu": true,
      Botfei: true,
      Troas: true,
      "Buceava-Soimus": true,
      Tarnavita: true,
      Berindia: true,
      Poiana: true,
      Corbesti: true,
      Calugareni: true,
      Dorgos: true,
      "Agrisu Mic": true,
      Ionesti: true,
      Mermesti: true,
      Nermis: true,
      Bodesti: true,
      Salajeni: true,
      "Bacau de Mijloc": true,
      Ciuntesti: true,
      "Slatina de Mures": true,
      "Hunedoara Timisana": true,
      "Slatina de Cris": true,
      Secaci: true,
      Hodis: true,
      "Gura Vaii": true,
      Stoinesti: true,
      "Joia Mare": true,
      "Bodrogu Nou": true,
      "Minisu de Sus": true,
      Buhani: true,
      Bruznic: true,
      Fenis: true,
      "Satu Mic": true,
      "Rogoz de Beliu": true,
      Coroi: true,
      Neagra: true,
      Sarbi: true,
      Barzesti: true,
      Donceni: true,
      Revetis: true,
      Stejar: true,
      Baia: true,
      Cociuba: true,
      Temesesti: true,
      Voivodeni: true,
      Obarsia: true,
      Bulci: true,
      Halalis: true,
      Luguzau: true,
      Rostoci: true,
      Nadalbesti: true,
      Tohesti: true,
      Minead: true,
      Vasoaia: true,
      Dumbrava: true,
      Grosi: true,
      Seliste: true,
      Comanesti: true,
      Cristesti: true,
      "Variasu Mic": true,
      Benesti: true,
      Brazii: true,
      Dulcele: true,
      Laz: true,
      Bochia: true,
      Patars: true,
      Mustesti: true,
      Camna: true,
      Clit: true,
      Batuta: true,
      Cuias: true,
      Lestioara: true,
      Talmaci: true,
      Rosia: true,
      Iercoseni: true,
      Virismort: true,
      Budesti: true,
      Cuvesdia: true,
      "Bodrogu Vechi": true,
      Labasint: true,
      Varnita: true,
    },
    AG: {
      Pitesti: true,
      Campulung: true,
      "Curtea de Arges": true,
      Mioveni: true,
      Costesti: true,
      Topoloveni: true,
      Rucar: true,
      Slobozia: true,
      Bascov: true,
      Bradu: true,
      Domnesti: true,
      "Valea Mare-Podgoria": true,
      "Bughea de Jos": true,
      Leresti: true,
      Izvoru: true,
      "Bughea de Sus": true,
      Stefanesti: true,
      Maracineni: true,
      "Stefanestii Noi": true,
      Vladesti: true,
      Dragoslavele: true,
      Berevoesti: true,
      "Albestii Ungureni": true,
      "Stefan cel Mare": true,
      Recea: true,
      Oarja: true,
      Lazaresti: true,
      Harsesti: true,
      Bogati: true,
      Vulturesti: true,
      Boteni: true,
      Calinesti: true,
      Arefu: true,
      Colibasi: true,
      Mirosi: true,
      "Valea Mare Pravat": true,
      Voinesti: true,
      Retevoiesti: true,
      Corbi: true,
      Mozaceni: true,
      Tutana: true,
      "Poiana Lacului": true,
      "Schitu Golesti": true,
      Teiu: true,
      "Valea Danului": true,
      Cetateni: true,
      Serboeni: true,
      "Albestii Pamanteni": true,
      Salatrucu: true,
      Racovita: true,
      Leordeni: true,
      Stalpeni: true,
      Albota: true,
      Stolnici: true,
      Badesti: true,
      Pietrosani: true,
      Argeselu: true,
      Poienari: true,
      Purcareni: true,
      Malureni: true,
      Contesti: true,
      Micesti: true,
      "Oestii Pamanteni": true,
      Suici: true,
      Livezeni: true,
      Jugur: true,
      Radesti: true,
      Titesti: true,
      Tigveni: true,
      Geamana: true,
      Strambeni: true,
      Bajesti: true,
      Albesti: true,
      Serbanesti: true,
      Vranesti: true,
      Surdulesti: true,
      Ciofrangeni: true,
      Barlogu: true,
      Stroesti: true,
      Draghici: true,
      Godeni: true,
      Barla: true,
      Mihaesti: true,
      Caldararu: true,
      "Mozacenii-Vale": true,
      "Capu Piscului": true,
      "Valea Popii": true,
      Negrasi: true,
      Cosesti: true,
      Slanic: true,
      Cornatel: true,
      Suseni: true,
      Matau: true,
      Cotenesti: true,
      Barasti: true,
      Aninoasa: true,
      Toplita: true,
      Gorganu: true,
      Dobresti: true,
      Ungheni: true,
      "Bucsenesti-Lotasi": true,
      Humele: true,
      Mares: true,
      Golesti: true,
      "Valeni-Podgoria": true,
      Patuleni: true,
      Bucsenesti: true,
      Mosoaia: true,
      Ciulnita: true,
      Darmanesti: true,
      Galasesti: true,
      Leicesti: true,
      Fagetu: true,
      Jupanesti: true,
      Dobrotu: true,
      Petresti: true,
      Vulpesti: true,
      Corbsori: true,
      Botesti: true,
      Zarnesti: true,
      "Gliganu de Sus": true,
      "Valea Stanii": true,
      "Barsestii de Jos": true,
      Laicai: true,
      Vedea: true,
      Rudeni: true,
      Hartiesti: true,
      Smeura: true,
      Zigoneni: true,
      "Oestii Ungureni": true,
      Babaroaga: true,
      Stanesti: true,
      Stoenesti: true,
      Cersani: true,
      Raca: true,
      Gamacesti: true,
      Ciocanesti: true,
      "Valea Nandrii": true,
      Cotesti: true,
      Cotmeana: true,
      Piscani: true,
      Poienita: true,
      "Paduroiu din Deal": true,
      Urlueni: true,
      "Valea Manastirii": true,
      Furesti: true,
      Burdea: true,
      Badeni: true,
      Glambocelu: true,
      Carstieni: true,
      Paraschivesti: true,
      "Lunca Corbului": true,
      "Paduroiu din Vale": true,
      "Costesti-Vaslan": true,
      Grosani: true,
      Furnicosi: true,
      Namaesti: true,
      Robaia: true,
      Gaujani: true,
      Urlucea: true,
      Izvorani: true,
      "Valea Silistii": true,
      Bunesti: true,
      Merisani: true,
      "Parvu Rosu": true,
      Babana: true,
      Ionesti: true,
      "Valea Corbului": true,
      "Valea Ursului": true,
      Lacurile: true,
      Gruiu: true,
      Dobrogostea: true,
      Barbatesti: true,
      Cerbu: true,
      Ganesti: true,
      "Gura Pravat": true,
      "Budeasa Mica": true,
      Pacioiu: true,
      Noaptes: true,
      "Valea Badenilor": true,
      Ciresu: true,
      Musatesti: true,
      Valeni: true,
      "Capatanenii Pamanteni": true,
      Cateasca: true,
      Cochinesti: true,
      Pauleasca: true,
      Calotesti: true,
      "Valea lui Enache": true,
      Beleti: true,
      Rotunda: true,
      "Capatanenii Ungureni": true,
      "Valea Mare-Bratia": true,
      Davidesti: true,
      Priboieni: true,
      Vernesti: true,
      Brosteni: true,
      Moraresti: true,
      Negreni: true,
      Rociu: true,
      Glambocu: true,
      Vacarea: true,
      "Valea Brazilor": true,
      "Valea Pechii": true,
      Barzesti: true,
      "Rajletu-Govora": true,
      "Gliganu de Jos": true,
      "Budeasa Mare": true,
      "Satu Nou": true,
      Ceausesti: true,
      "Draganu-Olteni": true,
      "Radu Negru": true,
      "Valea Cetatuia": true,
      Viisoara: true,
      "Deagu de Sus": true,
      Zgripcesti: true,
      Ciobanesti: true,
      "Podu Dambovitei": true,
      "Ceparii Pamanteni": true,
      "Glambocata-Deal": true,
      Coltu: true,
      Cerbureni: true,
      Mustatesti: true,
      Slatina: true,
      Furduesti: true,
      Carpenis: true,
      Catane: true,
      Lunca: true,
      Hintesti: true,
      Bradetu: true,
      Ciocanai: true,
      Piatra: true,
      Cicanesti: true,
      Crampotani: true,
      Popesti: true,
      "Valea Rumanestilor": true,
      Samara: true,
      Uiasca: true,
      "Podu Brosteni": true,
      "Rachitele de Jos": true,
      Buzoesti: true,
      Galesu: true,
      Scheau: true,
      "Udeni-Zavoi": true,
      Silistea: true,
      Borlesti: true,
      Pitoi: true,
      Mandra: true,
      Baiculesti: true,
      Dumbravesti: true,
      Mica: true,
      Sboghitesti: true,
      Voroveni: true,
      Enculesti: true,
      Urechesti: true,
      "Prislopu Mare": true,
      "Rachitele de Sus": true,
      Bratesti: true,
      Candesti: true,
      "Schitu Scoicesti": true,
      Ciocesti: true,
      Nucsoara: true,
      Banaresti: true,
      Glavacioc: true,
      Jgheaburi: true,
      Mozacu: true,
      Manicesti: true,
      Suslanesti: true,
      Corbeni: true,
      Varzaroaia: true,
      Bradulet: true,
      Pojorata: true,
      Valsanesti: true,
      Ratesti: true,
      Odaeni: true,
      Argesani: true,
      Ciobani: true,
      Balilesti: true,
      Padureti: true,
      Tutulesti: true,
      Dambovicioara: true,
      "Mosteni-Greci": true,
      Podeni: true,
      Martalogi: true,
      Bujoi: true,
      "Barsestii de Sus": true,
      Cuca: true,
      "Dealu Viilor": true,
      Izbasesti: true,
      "Malu Vanat": true,
      Sapunari: true,
      Grosi: true,
      Ianculesti: true,
      Varzaru: true,
      Salistea: true,
      Glambocata: true,
      "Valea Iasului": true,
      Braileni: true,
      Opresti: true,
      Ulita: true,
      Langesti: true,
      Selari: true,
      "Valea Hotarului": true,
      Malu: true,
      Ogrezea: true,
      Tomsanca: true,
      Albotele: true,
      "Ceparii Ungureni": true,
      Ungureni: true,
      Curteanca: true,
      Metofu: true,
      Priboaia: true,
      Dedulesti: true,
      Negresti: true,
      Catanele: true,
      Dinculesti: true,
      Dealu: true,
      Rancaciov: true,
      "Deagu de Jos": true,
      Burlusi: true,
      Poduri: true,
      Berindesti: true,
      Palanga: true,
      Sinesti: true,
      "Marghia de Jos": true,
      Podisoru: true,
      Chitesti: true,
      Coseri: true,
      Glodu: true,
      Bucov: true,
      Ciesti: true,
      Martesti: true,
      "Valea Marului": true,
      Tiganesti: true,
      Fratici: true,
      Urluiesti: true,
      Fata: true,
      Galesesti: true,
      "Gura Vaii": true,
      Nejlovelu: true,
      Slaatioarele: true,
      Chitani: true,
      "Ciupa-Manciulescu": true,
      Crintesti: true,
      Baila: true,
      Valcelele: true,
      Borobanesti: true,
      Samaila: true,
      Vlascuta: true,
      Crucisoara: true,
      Lentea: true,
      "Marghia de Sus": true,
      Lapusani: true,
      Teodoresti: true,
      Alunisu: true,
      Ioanicesti: true,
      Carcesti: true,
      Cotmenita: true,
      Rogojina: true,
      Catunasi: true,
      Barloi: true,
      Dogari: true,
      "Valea Rizii": true,
      Lesile: true,
      "Dealu Orasului": true,
      Loturi: true,
      Bacesti: true,
      Ceauresti: true,
      Lucieni: true,
      Balabani: true,
      Ursoaia: true,
      Lespezi: true,
      Cepari: true,
      Mancioiu: true,
      Budisteni: true,
      Vata: true,
      Zidurile: true,
      Botarcani: true,
      Afrimesti: true,
      "Izvoru de Sus": true,
      Anghinesti: true,
      Pietroasa: true,
      Starci: true,
      Luminile: true,
      "Valea Mare": true,
      Adunati: true,
      Clucereasa: true,
      Facaletesti: true,
      "Prislopu Mic": true,
      Buta: true,
      "Dealu Bradului": true,
      Gardinesti: true,
      Morasti: true,
      Uda: true,
      Borovinesti: true,
      Cungrea: true,
      Carciumaresti: true,
      Falfani: true,
      Bolculesti: true,
      Doblea: true,
      Mavrodolu: true,
      Balteni: true,
      Nigrisoara: true,
      Laceni: true,
      Cocenesti: true,
      Coteasca: true,
      Ciuresti: true,
      Huluba: true,
      Beculesti: true,
      Paltenu: true,
      "Valea Bradului": true,
      Priseaca: true,
      "Valea Indarat": true,
      Baranesti: true,
      Silisteni: true,
      Bujoreni: true,
      Goleasca: true,
      Selareasca: true,
      "Valea Uleiului": true,
      Miercani: true,
      Dincani: true,
      "Schitu-Matei": true,
      Batrani: true,
      "Launele de Sus": true,
      Cotu: true,
      Goranesti: true,
      Lungani: true,
      Padureni: true,
      Mioarele: true,
      Giuclani: true,
      Orodel: true,
      Burdesti: true,
      "Cotu Malului": true,
      Galcesti: true,
      Glambocel: true,
      Chiritesti: true,
      Gainusa: true,
      Goia: true,
      Sendrulesti: true,
      Pielesti: true,
      Bilcesti: true,
      Smei: true,
      Lupueni: true,
      Lipia: true,
      Pauleni: true,
      "Valea Faurului": true,
      Brabeti: true,
      Stejari: true,
      "Valea Nenii": true,
      Ciocanu: true,
      Romana: true,
      Banicesti: true,
      "Moara Mocanului": true,
      Colnic: true,
      "Dealu Padurii": true,
      Baloteasca: true,
      Cosaci: true,
      Galeteanu: true,
      Bascovele: true,
      Gorani: true,
      Poienarei: true,
      Blejani: true,
      Badicea: true,
      Bumbueni: true,
      Cocu: true,
      Putina: true,
      Uleni: true,
      Bratia: true,
      Varsesti: true,
      Ciolcesti: true,
      Turburea: true,
      "Valea Magurei": true,
      "Valea Muscelului": true,
      Barbalatesti: true,
      Slamnesti: true,
      Buretesti: true,
      Brateasca: true,
      "Izvoru de Jos": true,
      Satic: true,
      Draghicesti: true,
      Paunesti: true,
      Lintesti: true,
      Costita: true,
      Badislava: true,
      Fantanea: true,
      "Valea Calului": true,
      Chilii: true,
      Turcesti: true,
      "Valea lui Mas": true,
      Radutesti: true,
      Prodani: true,
      "Dealu Obejdeanului": true,
      Spiridoni: true,
      Otelu: true,
      Macai: true,
      Zamfiresti: true,
      Vladuta: true,
      Greabanu: true,
      "Valea Cucii": true,
      Fedelesoiu: true,
      Muscel: true,
      Ciomagesti: true,
      Crivatu: true,
      Branistea: true,
      Vetisoara: true,
      Blaju: true,
      Dumiresti: true,
      Cismea: true,
      Draghescu: true,
      Varloveni: true,
      Greaban: true,
      Badulesti: true,
      Fratesti: true,
      Bantau: true,
      Tomulesti: true,
      Zuvelcati: true,
      Negesti: true,
      Branzari: true,
      "Dealu Bisericii": true,
      Pitigaia: true,
      Mogosesti: true,
      Barbalani: true,
      Dragolesti: true,
      "Lunca Gartii": true,
      Florieni: true,
      Diconesti: true,
      Prosia: true,
      "Dealu Frumos": true,
      Lungulesti: true,
      "Dealu Tolcesii": true,
      Vonigeasa: true,
      Bajanesti: true,
      Manesti: true,
      Stanicei: true,
      Baltata: true,
      Ratoi: true,
      Sandulesti: true,
      Dumbrava: true,
      Redea: true,
      Burnesti: true,
      Ruginoasa: true,
      Bordeieni: true,
      Alunis: true,
      Bolovanesti: true,
      Badila: true,
      Zavoi: true,
    },
    BC: {
      Bacau: true,
      Onesti: true,
      Moinesti: true,
      Comanesti: true,
      Buhusi: true,
      "Targu Ocna": true,
      Darmanesti: true,
      Oituz: true,
      Faraoani: true,
      Cleja: true,
      Zemes: true,
      "Manastirea Casin": true,
      "Nicolae Balcescu": true,
      Frumoasa: true,
      Gioseni: true,
      "Luizi-Calugara": true,
      Pancesti: true,
      Dofteana: true,
      "Podu Turcului": true,
      "Valea Seaca": true,
      Margineni: true,
      Racaciuni: true,
      Berzunti: true,
      Casin: true,
      "Gura Vaii": true,
      Prajesti: true,
      Sascut: true,
      Poduri: true,
      Bijghir: true,
      Magura: true,
      Cucuieti: true,
      Dragugesti: true,
      Asau: true,
      Blagesti: true,
      Orbeni: true,
      "Sascut-Sat": true,
      Racova: true,
      Lespezi: true,
      Bratila: true,
      Pustiana: true,
      Buda: true,
      "Schitu Frumoasa": true,
      Osebiti: true,
      Ciughes: true,
      Bogdanesti: true,
      Dragomir: true,
      Vermesti: true,
      Scurta: true,
      Tuta: true,
      "Targu Trotus": true,
      "Slanic-Moldova": true,
      "Fundu Racaciuni": true,
      Deleni: true,
      "Letea Veche": true,
      Horgesti: true,
      Glavanesti: true,
      Bacioiu: true,
      Ciresoaia: true,
      Slobozia: true,
      Barsanesti: true,
      Urechesti: true,
      Sarata: true,
      "Satu Nou": true,
      Somusca: true,
      Lilieci: true,
      Rachitoasa: true,
      Solont: true,
      Faget: true,
      Garleni: true,
      "Garlenii de Sus": true,
      "Apa Asau": true,
      Ardeoani: true,
      Cerdac: true,
      Poiana: true,
      Frumuselu: true,
      Caiuti: true,
      Balcani: true,
      Sanduleni: true,
      Barati: true,
      Haghiac: true,
      Scorteni: true,
      Traian: true,
      Buciumi: true,
      Lapos: true,
      "Valea lui Ion": true,
      Cotumba: true,
      Beresti: true,
      Cernu: true,
      Saucesti: true,
      Magiresti: true,
      Brusturoasa: true,
      Arini: true,
      Straja: true,
      Hemeius: true,
      Galbeni: true,
      Dumbrava: true,
      Agas: true,
      Larga: true,
      Ghimes: true,
      "Valea Arinilor": true,
      "Beresti-Tazlau": true,
      Valcele: true,
      Buhoci: true,
      Bratesti: true,
      Holt: true,
      Bucsesti: true,
      Caraclau: true,
      Racauti: true,
      Pargaresti: true,
      Tamasi: true,
      Viisoara: true,
      "Valea Sosii": true,
      Carligi: true,
      Turluianu: true,
      Gasteni: true,
      Plopu: true,
      "Stefan Voda": true,
      Gazarie: true,
      Cotofanesti: true,
      "Dealu Morii": true,
      Bolovanis: true,
      "Gheorghe Doja": true,
      Secuieni: true,
      "Ferestrau-Oituz": true,
      Orasa: true,
      Versesti: true,
      Ludasi: true,
      Camenca: true,
      Bolatau: true,
      Prohozesti: true,
      Plopana: true,
      Helegiu: true,
      "Beresti-Bistrita": true,
      Gaiceana: true,
      Radoaia: true,
      Tarata: true,
      Rosiori: true,
      Dragusani: true,
      Vladnic: true,
      Goioasa: true,
      Coman: true,
      Parjol: true,
      Leontinesti: true,
      "Cornii de Sus": true,
      Balaneasa: true,
      Filipesti: true,
      Livezi: true,
      Nicoresti: true,
      Parava: true,
      Preluci: true,
      Negoiesti: true,
      "Tisa-Silvestri": true,
      Curita: true,
      Bahnaseni: true,
      Poieni: true,
      Blidari: true,
      Prajoaia: true,
      Scarisoara: true,
      Palanca: true,
      Ungureni: true,
      Parincea: true,
      Nanesti: true,
      Filipeni: true,
      Calugareni: true,
      Cabesti: true,
      Balca: true,
      Bogata: true,
      Enachesti: true,
      "Lunca Asau": true,
      Huruiesti: true,
      Pralea: true,
      "Stefan cel Mare": true,
      "Tardenii Mari": true,
      Popoiu: true,
      Bibiresti: true,
      Trebes: true,
      Malosu: true,
      Corbasca: true,
      Tarhausi: true,
      Buchila: true,
      Strugari: true,
      Chetris: true,
      Ciuturesti: true,
      Grigoreni: true,
      Borsani: true,
      Lupesti: true,
      Stanesti: true,
      Cucova: true,
      Tescani: true,
      Luncani: true,
      Sulta: true,
      Negri: true,
      Parvulesti: true,
      Negulesti: true,
      Cornatel: true,
      "Valea Mica": true,
      Popeni: true,
      Borzesti: true,
      Albele: true,
      Itesti: true,
      Marginea: true,
      Basasti: true,
      Contesti: true,
      Paltinis: true,
      Petresti: true,
      Campeni: true,
      Schineni: true,
      Lipova: true,
      Cosnea: true,
      Valeni: true,
      Sohodor: true,
      Radeana: true,
      Siretu: true,
      Colonesti: true,
      Dienet: true,
      Fundoaia: true,
      Floresti: true,
      Damienesti: true,
      Temelia: true,
      Paltinata: true,
      "Slobozia Noua": true,
      Harlesti: true,
      Bahna: true,
      Gutinas: true,
      Tarnita: true,
      Soci: true,
      Marvila: true,
      Craiesti: true,
      Ciobanus: true,
      Stanisesti: true,
      Bogdana: true,
      Tepoaia: true,
      Bazga: true,
      Prisaca: true,
      Cauia: true,
      Recea: true,
      Botesti: true,
      "Izvoru Berheciului": true,
      Romanesti: true,
      "Fundu Tutovei": true,
      Hanganesti: true,
      Barcana: true,
      Sarbi: true,
      Furnicari: true,
      Sendresti: true,
      Serbesti: true,
      Scariga: true,
      Ciucani: true,
      Zapodia: true,
      "Poiana Negustorului": true,
      Rachitisu: true,
      Petricica: true,
      Calcai: true,
      Podei: true,
      Oniscani: true,
      Viforeni: true,
      Podis: true,
      Dragesti: true,
      "Lunca Dochiei": true,
      Odobesti: true,
      Ocheni: true,
      Coteni: true,
      Hutu: true,
      Seaca: true,
      Heltiu: true,
      Crihan: true,
      Harja: true,
      Sohodol: true,
      Straminoasa: true,
      Fruntesti: true,
      Gherdana: true,
      Marasti: true,
      Sesuri: true,
      Bosoteni: true,
      Burdusaci: true,
      Rogoaza: true,
      Padureni: true,
      Tatarasti: true,
      Stufu: true,
      Budesti: true,
      Cornet: true,
      Benesti: true,
      Pagubeni: true,
      Fantanele: true,
      "Rusi-Ciutea": true,
      Calini: true,
      Cuchinis: true,
      Lehancea: true,
      "Poiana Sarata": true,
      Capotesti: true,
      "Valea Budului": true,
      "Valea Mare": true,
      Vranceni: true,
      Haineala: true,
      Fulgeris: true,
      Pradais: true,
      Darmaneasca: true,
      "Gura Craiesti": true,
      "Parau Boghii": true,
      Motoseni: true,
      Oprisesti: true,
      "Fundatura Rachitoasa": true,
      Nadisa: true,
      Tamasoaia: true,
      Beleghet: true,
      Cetatuia: true,
      Itcani: true,
      "Valea Caselor": true,
      "Valea Hogei": true,
      "Bogdan Voda": true,
      Oncesti: true,
      "Racatau-Razesi": true,
      "Fagetu de Sus": true,
      Muncelu: true,
      Balotesti: true,
      Teius: true,
      Capata: true,
      Larguta: true,
      Climesti: true,
      Obarsia: true,
      Halmacioaia: true,
      Rachitis: true,
      Brad: true,
      Bartasesti: true,
      Giurgeni: true,
      Barnesti: true,
      "Godinestii de Jos": true,
      "Dealu Perjului": true,
      Diaconesti: true,
      Razesu: true,
      Blaga: true,
      Buhocel: true,
      Magla: true,
      Cociu: true,
      Radomiresti: true,
      Buruienis: true,
      Lichitiseni: true,
      Popesti: true,
      Ghilavesti: true,
      Tochilea: true,
      Ciumasi: true,
      "Dealu-Mare": true,
      Spria: true,
      Antohesti: true,
      "Rusenii Razesi": true,
      Tomozia: true,
      Barboasa: true,
      "Valea Nacului": true,
      Barzulesti: true,
      "Rusenii de Sus": true,
      Galeri: true,
      Praja: true,
      Chetreni: true,
      Iaz: true,
      Tavadaresti: true,
      Boistea: true,
      Nazarioaia: true,
      Boanta: true,
      Fundeni: true,
      Iliesi: true,
      Glodisoarele: true,
      Putini: true,
      Perchiu: true,
      Chicerea: true,
      Zlatari: true,
      "Valea Botului": true,
      Belciuneasa: true,
      Chiticeni: true,
      Balanesti: true,
      "Hertioana de Jos": true,
      Vultureni: true,
      Cornesti: true,
      "Garla Anei": true,
      Berbinceni: true,
      Motocesti: true,
      Fundatura: true,
      "Cornii de Jos": true,
      Medeleni: true,
      "Milestii de Jos": true,
      Surina: true,
      Banca: true,
      Calinesti: true,
      "Racatau de Jos": true,
      Cadaresti: true,
      Dadesti: true,
      Dospinesti: true,
      Marcesti: true,
      Tiganesti: true,
      Balaia: true,
      "Fundu Vaii": true,
      Cornatelu: true,
      Motoc: true,
      Otelesti: true,
      Rotaria: true,
      Putredeni: true,
      Baclesti: true,
      Scutaru: true,
      "Buruienisu de Sus": true,
      Nastaseni: true,
      Danaila: true,
      Gorghesti: true,
      Magazia: true,
      Runcu: true,
      "Chilia Benei": true,
      Negreni: true,
      Fichitesti: true,
      Giurgioana: true,
      "Godinestii de Sus": true,
      Movilita: true,
      Dorneni: true,
      Ursoaia: true,
      Baimac: true,
      Baltata: true,
      "Milestii de Sus": true,
      Balusa: true,
      Bosia: true,
      Neguseni: true,
      Serpeni: true,
      Bodeasa: true,
      Stejaru: true,
      Taula: true,
      Calapodesti: true,
      Farcasa: true,
      Mateiesti: true,
      Rastoaca: true,
      "Hertioana-Razesi": true,
      "Oncestii Vechi": true,
      Racusana: true,
      "Valea Salciei": true,
      Poglet: true,
      Reprivat: true,
      "Valea Lupului": true,
      Bucsa: true,
      Salatruc: true,
      Hanta: true,
      "Cotu Grosului": true,
      Pajistea: true,
      "Valea Marului": true,
      Faghieni: true,
      "Valea Merilor": true,
      Barna: true,
      "Valea Mosneagului": true,
      Ghionoaia: true,
      Marascu: true,
      Misihanesti: true,
      Gradesti: true,
      "Boistea de Jos": true,
      Dorofei: true,
      Tisa: true,
      Fagetel: true,
      Bobos: true,
      Bostanesti: true,
      Bota: true,
      Costei: true,
      Hemieni: true,
      Tagara: true,
      "Valea Fanatului": true,
    },
    BH: {
      Oradea: true,
      Salonta: true,
      Marghita: true,
      Beius: true,
      "Valea lui Mihai": true,
      Stei: true,
      Alesd: true,
      Sacueni: true,
      Diosig: true,
      Tinca: true,
      Tileagd: true,
      Sanmartin: true,
      "Vadu Crisului": true,
      Biharia: true,
      Curtuiseni: true,
      "Suplacu de Barcau": true,
      Popesti: true,
      Salard: true,
      Simian: true,
      Santandrei: true,
      Tulca: true,
      Osorhei: true,
      Salacea: true,
      Rosia: true,
      Suncuius: true,
      "Avram Iancu": true,
      Voivozi: true,
      Dobresti: true,
      Vascau: true,
      Ineu: true,
      Ghiorac: true,
      Finis: true,
      Tarian: true,
      Ciumeghiu: true,
      Batar: true,
      Bratca: true,
      Talpos: true,
      Nucet: true,
      Budureasa: true,
      Beznea: true,
      Nojorid: true,
      Astileu: true,
      Petreu: true,
      Borod: true,
      "Lugasu de Jos": true,
      Brusturi: true,
      Pestis: true,
      Santion: true,
      Balc: true,
      Meziad: true,
      Cuzap: true,
      Saniob: true,
      Bogei: true,
      Cefa: true,
      Tasad: true,
      Calacea: true,
      "Livada de Bihor": true,
      Tarcaia: true,
      Varciorog: true,
      Gurbediu: true,
      Sarbi: true,
      "Girisu de Cris": true,
      "Sannicolau Roman": true,
      Cadea: true,
      Burzuc: true,
      Rosiori: true,
      "Mihai Bravu": true,
      Tamasda: true,
      Remeti: true,
      Luncsoara: true,
      Forau: true,
      Budoi: true,
      Tauteu: true,
      Bors: true,
      Cordau: true,
      Chet: true,
      Chesereu: true,
      Hotar: true,
      Bistra: true,
      Ianosda: true,
      Vasad: true,
      Luncasprie: true,
      Cubulcut: true,
      "Hidiselu de Sus": true,
      Albis: true,
      "Cociuba Mare": true,
      Derna: true,
      Balnaca: true,
      Lunca: true,
      Cabesti: true,
      Cheresig: true,
      "Padurea Neagra": true,
      Cetariu: true,
      Galospetreu: true,
      Ghighiseni: true,
      Viisoara: true,
      Pietroasa: true,
      Silindru: true,
      Gepiu: true,
      Misca: true,
      Buduslau: true,
      Alparea: true,
      Vintere: true,
      Bulz: true,
      Ciutelec: true,
      Campani: true,
      Toboliu: true,
      Grosi: true,
      Tarcea: true,
      Taut: true,
      Tamaseu: true,
      Calatea: true,
      Palota: true,
      "Sannicolau de Munte": true,
      Tilecus: true,
      Borumlaca: true,
      "Almasu Mare": true,
      Nimaiesti: true,
      Picleu: true,
      Urvind: true,
      Ceica: true,
      Sacadat: true,
      "Urvis de Beius": true,
      Madaras: true,
      Arpasel: true,
      Ciocaia: true,
      "Uileacu de Cris": true,
      Mierlau: true,
      Boiu: true,
      Inand: true,
      Fughiu: true,
      "Girisu Negru": true,
      Remetea: true,
      Hinchiris: true,
      Damis: true,
      "Husasau de Cris": true,
      Suncuis: true,
      Abram: true,
      Cihei: true,
      Adoni: true,
      "Lugasu de Sus": true,
      Ponoara: true,
      Calugari: true,
      Haieu: true,
      Balaia: true,
      Pestere: true,
      Chesa: true,
      Carasau: true,
      Cosdeni: true,
      Gurani: true,
      Cherechiu: true,
      Tinaud: true,
      "Topa de Sus": true,
      Ghenetea: true,
      Chiscau: true,
      Tetchea: true,
      Otomani: true,
      "Uileacu de Beius": true,
      Sacalasau: true,
      "Husasau de Tinca": true,
      Chiribis: true,
      "Poienii de Sus": true,
      Sabolciu: true,
      Homorog: true,
      Hidisel: true,
      Serani: true,
      Ceisoara: true,
      Fanate: true,
      Hodos: true,
      Pagaia: true,
      Bradet: true,
      Izbuc: true,
      Rapa: true,
      Petid: true,
      "Valani de Pomezeu": true,
      Rabagani: true,
      Dernisoara: true,
      "Calea Mare": true,
      Serghis: true,
      Seghiste: true,
      Botean: true,
      Munteni: true,
      Holod: true,
      "Saldabagiu Mic": true,
      Telechiu: true,
      Ioanis: true,
      Olcea: true,
      "Poienii de Jos": true,
      Orvisele: true,
      "Zece Hotare": true,
      Sinteu: true,
      Borozel: true,
      Sisterea: true,
      Gepis: true,
      Soimi: true,
      Lazareni: true,
      Poiana: true,
      "Boianu Mare": true,
      Chistag: true,
      Baita: true,
      Varviz: true,
      Chiraleu: true,
      Rieni: true,
      Ucuris: true,
      Roit: true,
      Dusesti: true,
      Margine: true,
      Subpiatra: true,
      Corbesti: true,
      Dobricionesti: true,
      Targusor: true,
      Cornitel: true,
      Santimreu: true,
      Ferice: true,
      Carpinet: true,
      "Valea de Jos": true,
      Chislaz: true,
      "Saldabagiu de Barcau": true,
      Cauaceu: true,
      Sitani: true,
      Fasca: true,
      Petrileni: true,
      "Dumbravita de Codru": true,
      Vaida: true,
      Cotiglet: true,
      Saucani: true,
      "Saliste de Vascau": true,
      Bicaci: true,
      Cusuius: true,
      Buntesti: true,
      "Saldabagiu de Munte": true,
      "Valea Crisului": true,
      Crancesti: true,
      Les: true,
      "Campani de Pomezeu": true,
      Dumbrava: true,
      Olosig: true,
      "Hidiselu de Jos": true,
      Sititelec: true,
      Lorau: true,
      Bucuroaia: true,
      "Uileacu de Munte": true,
      Beiusele: true,
      "Almasu Mic": true,
      Surduc: true,
      "Valea Mare de Cris": true,
      Lupoaia: true,
      Prisaca: true,
      Suiug: true,
      "Suplacu de Tinca": true,
      Cresuia: true,
      Spinus: true,
      Belfir: true,
      Dragoteni: true,
      Varaseni: true,
      Cheriu: true,
      Auseu: true,
      Sarand: true,
      Sustiu: true,
      Cauasd: true,
      Lelesti: true,
      Tria: true,
      Leheceni: true,
      "Topa de Cris": true,
      Parhida: true,
      Pocola: true,
      Cuiesd: true,
      Hidis: true,
      Lazuri: true,
      Feneris: true,
      Sumugiu: true,
      Incesti: true,
      Tarcaita: true,
      Ortiteag: true,
      Paleu: true,
      Betfia: true,
      Abramut: true,
      "Valea Tarnei": true,
      Gradinari: true,
      Osand: true,
      Burda: true,
      Capalna: true,
      Sambata: true,
      Curatele: true,
      Briheni: true,
      Hodisel: true,
      Crestur: true,
      Mizies: true,
      Ciuhoi: true,
      Sanlazar: true,
      Petreasa: true,
      "Cociuba Mica": true,
      Saud: true,
      "Cristioru de Jos": true,
      Josani: true,
      Paulesti: true,
      Ginta: true,
      "Valea Cerului": true,
      Tomnatic: true,
      Miersig: true,
      "Tiganestii de Cris": true,
      Copacel: true,
      Dragesti: true,
      Delani: true,
      Petrani: true,
      Draganesti: true,
      Sudrigiu: true,
      "Sacalasau Nou": true,
      Sighistel: true,
      "Valea de Sus": true,
      "Poclusa de Barcau": true,
      Birtin: true,
      Albesti: true,
      Rogoz: true,
      Cetea: true,
      Sarbesti: true,
      Harsesti: true,
      "Santaul Mic": true,
      "Lazuri de Beius": true,
      Sohodol: true,
      Pocioveliste: true,
      Camp: true,
      Butani: true,
      Rontau: true,
      Sauaieu: true,
      Varzari: true,
      Susturogi: true,
      Magura: true,
      Fegernic: true,
      Santelec: true,
      Fancica: true,
      Hotarel: true,
      "Tiganestii de Beius": true,
      "Cacuciu Nou": true,
      Posoloaca: true,
      Sebis: true,
      Iteu: true,
      Dijir: true,
      Felcheriu: true,
      Dumbravani: true,
      Galaseni: true,
      Stracos: true,
      Berechiu: true,
      Totoreni: true,
      Dumbravita: true,
      Cornisesti: true,
      Belejeni: true,
      Sarsig: true,
      "Valanii de Beius": true,
      Dicanesti: true,
      Saliste: true,
      Stancesti: true,
      "Spinus de Pomezeu": true,
      Hodis: true,
      "Varzarii de Jos": true,
      Chijic: true,
      Codru: true,
      Colesti: true,
      "Santaul Mare": true,
      Borz: true,
      Cenalos: true,
      Pausa: true,
      Talpe: true,
      Magesti: true,
      Sfarnas: true,
      Zavoiu: true,
      Izvoarele: true,
      "Satu Barba": true,
      Apateu: true,
      Chioag: true,
      Ianca: true,
      "Saliste de Beius": true,
      Bucium: true,
      Topesti: true,
      Ciulesti: true,
      Bicacel: true,
      Gheghie: true,
      Borsa: true,
      Mierag: true,
      Fizis: true,
      "Topa de Jos": true,
      Nadar: true,
      Valcelele: true,
      "Balnaca-Grosi": true,
      Baleni: true,
      "Satu Nou": true,
      Miheleu: true,
      "Sanmartin de Beius": true,
      Tautelec: true,
      Ursad: true,
      Forosig: true,
      Ogesti: true,
      Goila: true,
      "Cristioru de Sus": true,
      "Huta Voivozi": true,
      Gurbesti: true,
      Niuved: true,
      "Poiana Tasad": true,
      Saca: true,
      Ant: true,
      Teleac: true,
      Dolea: true,
      Ateas: true,
      Calatani: true,
      Foglas: true,
      Fonau: true,
      "Sannicolau de Beius": true,
      Rotaresti: true,
      Pomezeu: true,
      Carandeni: true,
      Martihaz: true,
      Ghida: true,
      "Cacuciu Vechi": true,
      Pantasesti: true,
      "Varzarii de Sus": true,
      "Iteu Nou": true,
      Giulesti: true,
      Rohani: true,
      Varasau: true,
      Copaceni: true,
      "Saliste de Pomezeu": true,
      Soimus: true,
      Gruilung: true,
      Loranta: true,
      Bratesti: true,
      "Camp-Moti": true,
      Cohani: true,
      "Baita-Plai": true,
      "Livada Beiusului": true,
      Chisirid: true,
      Caranzel: true,
      "Valea Mare de Codru": true,
      Socet: true,
      Racas: true,
      Motesti: true,
      "Poclusa de Beius": true,
      Sarcau: true,
      Poietari: true,
      Reghea: true,
      Cucuceni: true,
      Haucesti: true,
      Corboaia: true,
      "Lacu Sarat": true,
      Codrisoru: true,
      "Fegernicu Nou": true,
      Surducel: true,
      Huta: true,
      Rugea: true,
      Padureni: true,
      "Baile Felix": true,
      Pacalesti: true,
    },
    BN: {
      Bistrita: true,
      Nasaud: true,
      Beclean: true,
      "Sangeorz-Bai": true,
      Rodna: true,
      Feldru: true,
      Maieru: true,
      "Prundu Bargaului": true,
      Telciu: true,
      "Bistrita Bargaului": true,
      "Ilva Mica": true,
      Rebrisoara: true,
      "Lunca Ilvei": true,
      Salva: true,
      Rebra: true,
      Sant: true,
      Parva: true,
      Reteag: true,
      Lechinta: true,
      Dumitra: true,
      Tureac: true,
      Livezile: true,
      Teaca: true,
      Cosbuc: true,
      "Ilva Mare": true,
      "Josenii Bargaului": true,
      Nepos: true,
      "Magura Ilvei": true,
      Lesu: true,
      Ciresoaia: true,
      "Mijlocenii Bargaului": true,
      Spermezeu: true,
      "Muresenii Bargaului": true,
      "Runcu Salvei": true,
      "Poiana Ilvei": true,
      "Tiha Bargaului": true,
      Anies: true,
      "Budacu de Sus": true,
      "Caianu Mic": true,
      "Nimigea de Jos": true,
      "Susenii Bargaului": true,
      Romuli: true,
      Unirea: true,
      Negrilesti: true,
      Sieu: true,
      Bichigiu: true,
      Uriu: true,
      "Lunca Lesului": true,
      "Valea Borcutului": true,
      Telcisor: true,
      Branistea: true,
      Ocnita: true,
      Zagra: true,
      Tarlisua: true,
      Cociu: true,
      Breaza: true,
      "Cristestii Ciceului": true,
      Viisoara: true,
      Dobric: true,
      Monor: true,
      "Silivasu de Campie": true,
      "Ciceu-Giurgesti": true,
      Petris: true,
      Agries: true,
      "Sangeorzu Nou": true,
      Sebis: true,
      "Ciceu-Poieni": true,
      "Rusu Bargaului": true,
      "Gersa I": true,
      Nuseni: true,
      Urmenis: true,
      Pinticu: true,
      Sintereag: true,
      Tarpiu: true,
      Sarata: true,
      Ardan: true,
      "Poienile Zagrei": true,
      Suplai: true,
      "Viile Tecii": true,
      "Ciceu-Mihaiesti": true,
      Chiuza: true,
      Dumbraveni: true,
      "Budacu de Jos": true,
      Dipsa: true,
      Vermes: true,
      Sieut: true,
      Bata: true,
      "Sieu-Magherus": true,
      Corvinesti: true,
      Matei: true,
      "Sieu-Odorhei": true,
      Mititei: true,
      Dumbravita: true,
      Archiud: true,
      Bozies: true,
      "Liviu Rebreanu": true,
      Perisor: true,
      Crainimat: true,
      Mocod: true,
      "Sanmihaiu de Campie": true,
      Ilisua: true,
      Posmus: true,
      Cormaia: true,
      Sasarm: true,
      Coldau: true,
      Gledin: true,
      Milas: true,
      Tagu: true,
      "Caianu Mare": true,
      Cepari: true,
      Beudiu: true,
      "Satu Nou": true,
      Arcalia: true,
      Dumitrita: true,
      Fantanele: true,
      Budesti: true,
      Jelna: true,
      Cusma: true,
      Malut: true,
      Dobricel: true,
      "Galatii Bistritei": true,
      Domnesti: true,
      Rustior: true,
      Dorolea: true,
      "Orheiu Bistritei": true,
      Lusca: true,
      "Nimigea de Sus": true,
      Ghinda: true,
      Sigmir: true,
      Colibita: true,
      Jimbor: true,
      Ivaneasa: true,
      Slatinita: true,
      Budus: true,
      Santioana: true,
      Taure: true,
      Visuia: true,
      Borleasa: true,
      Piatra: true,
      Chintelnic: true,
      Fantanita: true,
      Malin: true,
      Chiochis: true,
      Arsita: true,
      Chirales: true,
      Orosfaia: true,
      Sopteriu: true,
      Figa: true,
      "Dealu Stefanitei": true,
      Mintiu: true,
      Tigau: true,
      "Blajenii de Sus": true,
      Herina: true,
      Saratel: true,
      Alunisul: true,
      Vita: true,
      "Sieu-Sfantu": true,
      Feleac: true,
      "Blajenii de Jos": true,
      Mariselu: true,
      "Cristur-Sieu": true,
      Sita: true,
      Lunca: true,
      "Budesti-Fanate": true,
      Barla: true,
      Fiad: true,
      "Micestii de Campie": true,
      Floresti: true,
      "Agrisu de Jos": true,
      Halmasau: true,
      Monariu: true,
      Chetiu: true,
      Tagsoru: true,
      Poderei: true,
      "Rusu de Jos": true,
      Caila: true,
      Zoreni: true,
      Ragla: true,
      Mogoseni: true,
      Sirioara: true,
      Moliset: true,
      "Hasmasu Ciceului": true,
      Manic: true,
      "Rusu de Sus": true,
      Delureni: true,
      Enciu: true,
      Apatiu: true,
      Racatesu: true,
      "Gersa Ii": true,
      Bidiu: true,
      Magurele: true,
      Stramba: true,
      Sendroaia: true,
      "Valea Mare": true,
      Agriesel: true,
      Bretea: true,
      Tonciu: true,
      Morut: true,
      Strugureni: true,
      Saniacob: true,
      Simionesti: true,
      "Piatra Fantanele": true,
      Ciosa: true,
      Fanate: true,
      "Ciceu-Corabia": true,
      "Valea Vinului": true,
      Coasta: true,
      Tentea: true,
      Lelesti: true,
      "Agrisu de Sus": true,
      Purcarete: true,
      Dumbrava: true,
      Oarzina: true,
      Comlod: true,
      Salcuta: true,
      Soimus: true,
      "Albestii Bistritei": true,
      Stupini: true,
      Sannicoara: true,
      Mires: true,
      Budurleni: true,
      Paltineasa: true,
      "Buza Catun": true,
      Camp: true,
      "Lunca Sateasca": true,
      "Valea Poenii": true,
      "Sesuri Spermezeu-Vale": true,
      Brateni: true,
      Jeica: true,
      "La Curte": true,
      "Sintereag-Gara": true,
      Ghemes: true,
      Cireasi: true,
      Podirei: true,
      "Fanatele Silivasului": true,
      "Valea Magherusului": true,
      Hirean: true,
      Coseriu: true,
      "Lunca Borlesei": true,
      "Dupa Deal": true,
      Bungard: true,
      Draga: true,
      Valea: true,
      Neteni: true,
      Scoabe: true,
      Podenii: true,
      Porumbenii: true,
    },
    BT: {
      Botosani: true,
      Dorohoi: true,
      Darabani: true,
      Saveni: true,
      Tudora: true,
      Flamanzi: true,
      Bucecea: true,
      Vorniceni: true,
      "Nicolae Balcescu": true,
      Corni: true,
      Dersca: true,
      Broscauti: true,
      Havarna: true,
      Trusesti: true,
      Calarasi: true,
      Copalau: true,
      Hudesti: true,
      Vorona: true,
      Roma: true,
      Ungureni: true,
      Ibanesti: true,
      Pomarla: true,
      Zlatunoaia: true,
      Sendriceni: true,
      Miorcani: true,
      Paltinis: true,
      Suharau: true,
      Ripiceni: true,
      "Varfu Campului": true,
      Cristesti: true,
      Draxini: true,
      Albesti: true,
      Poiana: true,
      Mileanca: true,
      Todireni: true,
      Bajura: true,
      Dumeni: true,
      Stiubieni: true,
      Cotusca: true,
      Oneaga: true,
      "Catamaresti-Deal": true,
      Lunca: true,
      Vlasinesti: true,
      Cordareni: true,
      Hlipiceni: true,
      "Vladeni-Deal": true,
      Cristinesti: true,
      Dumbravita: true,
      Dracsani: true,
      Alba: true,
      Sarafinesti: true,
      Draguseni: true,
      Brehuiesti: true,
      Romanesti: true,
      Dorobanti: true,
      Baluseni: true,
      Costesti: true,
      Avrameni: true,
      Mlenauti: true,
      Leorda: true,
      Victoria: true,
      Icuseni: true,
      "Tudor Vladimirescu": true,
      Rosiori: true,
      Braesti: true,
      Vladeni: true,
      Bobulesti: true,
      Cosula: true,
      Mitoc: true,
      Candesti: true,
      Stefanesti: true,
      Concesti: true,
      Mandresti: true,
      Sarbi: true,
      Sulita: true,
      Joldesti: true,
      Oroftiana: true,
      Hanesti: true,
      "Santa Mare": true,
      Stauceni: true,
      Rauseni: true,
      Gorbanesti: true,
      "Stefanesti-Sat": true,
      Adaseni: true,
      Unteni: true,
      Dimacheni: true,
      Durnesti: true,
      Ionaseni: true,
      Mihaileni: true,
      Vaculesti: true,
      Padureni: true,
      Rediu: true,
      Tocileni: true,
      Prajeni: true,
      Storesti: true,
      Iacobeni: true,
      Nicseni: true,
      Viisoara: true,
      Radeni: true,
      Supitca: true,
      "Oraseni-Deal": true,
      Lozna: true,
      Strateni: true,
      Stancesti: true,
      Stroiesti: true,
      Podriga: true,
      Drislea: true,
      Cerchejeni: true,
      Stanca: true,
      Tataraseni: true,
      "Hiliseu-Crisan": true,
      Horodistea: true,
      "Radauti-Prut": true,
      Saucenita: true,
      Rachiti: true,
      "Parau Negru": true,
      Liveni: true,
      Negreni: true,
      Lisna: true,
      "Hiliseu-Horia": true,
      Movileni: true,
      Cervicesti: true,
      Guranda: true,
      Mihalaseni: true,
      Blandesti: true,
      Cucuteni: true,
      Dobarceni: true,
      Dangeni: true,
      Baiceni: true,
      Socrujeni: true,
      Cucorani: true,
      Baranca: true,
      Luparia: true,
      "Plopenii Mari": true,
      Buimaceni: true,
      Corlateni: true,
      "Oraseni-Vale": true,
      Cerbu: true,
      Manastireni: true,
      Badiuti: true,
      Arborea: true,
      Brateni: true,
      Frumusica: true,
      Ghireni: true,
      Rogojesti: true,
      Petricani: true,
      Crasnaleuca: true,
      Sendreni: true,
      "Fundu Hertii": true,
      Carasa: true,
      "Vorona Mare": true,
      Buhaceni: true,
      Cotu: true,
      Putureni: true,
      Boscoteni: true,
      Cernesti: true,
      Smardan: true,
      Costiugeni: true,
      Hulub: true,
      Prisacani: true,
      Jijia: true,
      "Hiliseu-Closca": true,
      Calinesti: true,
      Catamaresti: true,
      Campeni: true,
      Burlesti: true,
      Manoleasa: true,
      Dragalina: true,
      "Vorona-Teodoru": true,
      "Cuza Voda": true,
      Plesani: true,
      Ipotesti: true,
      "Viisoara Mica": true,
      Chitoveni: true,
      Borzesti: true,
      Horia: true,
      Zaicesti: true,
      Lismanita: true,
      Chiscareni: true,
      "Aurel Vlaicu": true,
      "Manastirea Doamnei": true,
      Nichiteni: true,
      Grivita: true,
      Miletin: true,
      Zahoreni: true,
      Curtesti: true,
      Vanatori: true,
      "Cotu Miculinti": true,
      Doina: true,
      Dolina: true,
      "Schit-Oraseni": true,
      Iezer: true,
      Damideni: true,
      Codreni: true,
      Hutani: true,
      Vicoleni: true,
      Libertatea: true,
      Sadoveni: true,
      "Mihai Viteazu": true,
      Flondora: true,
      Soldanesti: true,
      Talpa: true,
      Babiceni: true,
      Corjauti: true,
      Podeni: true,
      Buzeni: true,
      Balinti: true,
      Cotargaci: true,
      Popeni: true,
      Iuresti: true,
      Strahotin: true,
      "Plopenii Mici": true,
      Agafton: true,
      "Sarata-Basarab": true,
      Cismanesti: true,
      Murguta: true,
      "Calugarenii Noi": true,
      "Miron Costin": true,
      Cismea: true,
      Bodeasa: true,
      Mascateni: true,
      Bogdanesti: true,
      Selistea: true,
      Ranghilesti: true,
      Horlaceni: true,
      Zoitani: true,
      Borolea: true,
      Calugareni: true,
      Timus: true,
      Garbeni: true,
      "George Cosbuc": true,
      Mesteacan: true,
      Esanca: true,
      Siliscani: true,
      "Dealu Mare": true,
      Vitcani: true,
      "Balta Arsa": true,
      "Loturi Enescu": true,
      Sarata: true,
      Racovat: true,
      Scutari: true,
      "Balusenii Noi": true,
      "Dealu Crucii": true,
      Silistea: true,
      Mateieni: true,
      Negresti: true,
      Bozieni: true,
      Progresul: true,
      Brosteni: true,
      Buda: true,
      Chelis: true,
      Costinesti: true,
      Paun: true,
      Cosuleni: true,
      Batranesti: true,
      Hulubesti: true,
      "Ranghilesti-Deal": true,
      "Slobozia Siliscani": true,
      Nastase: true,
      "George Enescu": true,
      Stolniceni: true,
      "Mihail Kogalniceanu": true,
      Berza: true,
      Plevna: true,
      Loturi: true,
      Barsanesti: true,
      Iliseni: true,
      Caraiman: true,
      Soroceni: true,
      Bivolari: true,
      Panaitoaia: true,
      Hriscani: true,
      Pogorasti: true,
      Ichimeni: true,
      Cuzlau: true,
      Manolesti: true,
      "Dimitrie Cantemir": true,
      Bohoghina: true,
      Dacia: true,
      "Sarata-Draguseni": true,
      Unguroaia: true,
      Garbesti: true,
      Ibaneasa: true,
      "Sat Nou": true,
      "Manoleasa-Prut": true,
      Burla: true,
      "Recia-Verbia": true,
      Slobozia: true,
      Badarai: true,
      Iorga: true,
      Davidoaia: true,
      "Slobozia Hanesti": true,
      Izvoare: true,
      Pasateni: true,
      Galbeni: true,
      "Avram Iancu": true,
      "Moara Jorii": true,
      Baisa: true,
      Hudum: true,
      Gorovei: true,
      Valcelele: true,
      Niculcea: true,
      Floresti: true,
      Belcea: true,
      "Mihai Eminescu": true,
      Viforeni: true,
      Ciritei: true,
      "Cervicesti-Deal": true,
      Baseu: true,
      Bold: true,
      Cinghiniia: true,
      Damileni: true,
      "Dobrinauti-Hapai": true,
      Lehnesti: true,
      Livada: true,
      Maghera: true,
      "Movila Rupta": true,
      Popoaia: true,
      Pustoaia: true,
      Rasca: true,
      "Ripicenii Vechi": true,
      "Romanesti-Vale": true,
      Serpenita: true,
      Tautesti: true,
      "Valea Grajdului": true,
      Vatra: true,
      Vultureni: true,
    },
    BR: {
      Braila: true,
      Ianca: true,
      Insuratei: true,
      Tufesti: true,
      Sutesti: true,
      Faurei: true,
      Viziru: true,
      Chiscani: true,
      Gropeni: true,
      Tichilesti: true,
      Baraganul: true,
      Ulmu: true,
      Jirlau: true,
      "Movila Miresii": true,
      Cazasu: true,
      Zavoaia: true,
      "Mircea Voda": true,
      Vadeni: true,
      Lanurile: true,
      Victoria: true,
      Ciocile: true,
      Tataru: true,
      Visani: true,
      "Surdila-Gaiseanca": true,
      Gemenele: true,
      Dudesti: true,
      Rosiori: true,
      Maxineni: true,
      Stancuta: true,
      "Mihai Bravu": true,
      Ramnicelu: true,
      "Spiru Haret": true,
      Romanu: true,
      "Cuza Voda": true,
      Plopu: true,
      "Bordei Verde": true,
      Urleasca: true,
      Gradistea: true,
      Jugureanu: true,
      "Valea Canepii": true,
      Traian: true,
      "Lacu Sarat": true,
      Unirea: true,
      Ciresu: true,
      Perisoru: true,
      "Scortaru Vechi": true,
      "Tudor Vladimirescu": true,
      Baldovinesti: true,
      Galbenu: true,
      Marasu: true,
      Dedulesti: true,
      "Corbu Nou": true,
      Drogu: true,
      Scarlatesti: true,
      Silistea: true,
      Silistraru: true,
      Filipesti: true,
      Dudescu: true,
      "Bertestii de Jos": true,
      "Tepes Voda": true,
      Tacau: true,
      "Salcia Tudor": true,
      Oprisenesti: true,
      "Constantin Gabrielescu": true,
      Ibrianu: true,
      Racovita: true,
      Satuc: true,
      Batogu: true,
      "Tarlele Filiu": true,
      "Surdila-Greci": true,
      Vultureni: true,
      Latinu: true,
      Magureni: true,
      Pietroiu: true,
      Liscoteanca: true,
      Coltea: true,
      Gulianca: true,
      "Scortaru Nou": true,
      Bandoiu: true,
      Titcov: true,
      Agaua: true,
      "Caineni-Bai": true,
      Oancea: true,
      Olaneasca: true,
      Chichinetu: true,
      Custura: true,
      "Faurei Sat": true,
      Florica: true,
      Frecatei: true,
      Zamfiresti: true,
      Horia: true,
      "Lacu Rezii": true,
      Maraloiu: true,
      Pitulati: true,
      Berlesti: true,
      Stanca: true,
      Constantinesti: true,
      "Mihail Kogalniceanu": true,
      "Gura Calmatui": true,
      "Bertestii de Sus": true,
      Muchea: true,
      Esna: true,
      Sihleanu: true,
      "Corbu Vechi": true,
      Albina: true,
      Plopi: true,
      Chioibasesti: true,
      Plasoiu: true,
      Comaneasca: true,
      Gurguieti: true,
      "Cotu Lung": true,
      Gavani: true,
      Caldarusa: true,
      Varsatura: true,
      Odaieni: true,
      Ariciu: true,
      Pantecani: true,
      Polizesti: true,
      Martacesti: true,
      Corbeni: true,
      "Valea Calmatuiului": true,
      "Bratesu Vechi": true,
      "Gara Ianca": true,
      Pribeagu: true,
      Voinesti: true,
      Boarca: true,
      "Maru Rosu": true,
      "Cotu Mihalea": true,
      Ionesti: true,
      Salcia: true,
      Stoienesti: true,
      Vamesu: true,
      Bumbacari: true,
      Cistia: true,
      Bradeanca: true,
      Desirati: true,
      Filiu: true,
      "Gura Garlutei": true,
      Morotesti: true,
      Nedeicu: true,
      "Nicolae Balcescu": true,
      Nicolesti: true,
    },
    BV: {
      Brasov: true,
      Fagaras: true,
      Sacele: true,
      Zarnesti: true,
      Codlea: true,
      Rasnov: true,
      Victoria: true,
      Predeal: true,
      Ghimbav: true,
      Rupea: true,
      Feldioara: true,
      Prejmer: true,
      Cristian: true,
      Harman: true,
      Dumbravita: true,
      "Poiana Marului": true,
      Teliu: true,
      Sanpetru: true,
      Vulcan: true,
      Tarlungeni: true,
      "Lunca Calnicului": true,
      Budila: true,
      Halchiu: true,
      Apata: true,
      Racos: true,
      Hoghiz: true,
      "Moieciu de Jos": true,
      Bod: true,
      "Colonia Bod": true,
      Zizin: true,
      Ormenis: true,
      Sohodol: true,
      Bran: true,
      Maierus: true,
      Cincu: true,
      Holbav: true,
      Purcareni: true,
      Sercaia: true,
      "Sinca Noua": true,
      "Sambata de Sus": true,
      Homorod: true,
      "Tohanu Nou": true,
      Crizbav: true,
      Mandra: true,
      Simon: true,
      Ungra: true,
      Cuciulata: true,
      Fiser: true,
      Augustin: true,
      Dragus: true,
      Cata: true,
      Persani: true,
      Lisa: true,
      Acris: true,
      "Satu Nou": true,
      "Comana de Jos": true,
      Recea: true,
      "Sinca Veche": true,
      "Moieciu de Sus": true,
      Rotbav: true,
      "Ucea de Sus": true,
      Predelut: true,
      "Ucea de Jos": true,
      Vladeni: true,
      Dalghiu: true,
      Ileni: true,
      "Vama Buzaului": true,
      Jibert: true,
      "Timisu de Jos": true,
      "Vistea de Jos": true,
      Voila: true,
      Copacel: true,
      Sercaita: true,
      Arini: true,
      "Venetia de Jos": true,
      Daisoara: true,
      Dacia: true,
      Cincsor: true,
      Berivoi: true,
      "Colonia Reconstructia": true,
      Magura: true,
      Beclean: true,
      "Colonia 1 Mai": true,
      Sebes: true,
      Pestera: true,
      "Vistea de Sus": true,
      Crihalma: true,
      Oltet: true,
      Halmeag: true,
      "Ticusu Vechi": true,
      Bunesti: true,
      Parau: true,
      Fundata: true,
      Breaza: true,
      Harseni: true,
      Crit: true,
      Lovnic: true,
      Vad: true,
      "Ticusu Nou": true,
      Voivodeni: true,
      Soars: true,
      Jimbor: true,
      "Sambata de Jos": true,
      Dopca: true,
      "Podu Oltului": true,
      Cheia: true,
      "Timisu de Sus": true,
      Cutus: true,
      Granari: true,
      Buzaiel: true,
      Sirnea: true,
      Drauseni: true,
      Mercheasa: true,
      Felmer: true,
      Hurez: true,
      Rucar: true,
      Dejani: true,
      "Venetia de Sus": true,
      "Gura Vaii": true,
      Rausor: true,
      Dridif: true,
      Viscri: true,
      Mateias: true,
      Barcut: true,
      "Stupinii Prejmerului": true,
      Carpinis: true,
      Margineni: true,
      Grid: true,
      "Comana de Sus": true,
      Fantana: true,
      "Bogata Olteana": true,
      Toderita: true,
      Beia: true,
      Toarcla: true,
      Iasi: true,
      Ohaba: true,
      Mesendorf: true,
      Palos: true,
      Sona: true,
      Bucium: true,
      Rodbav: true,
      Calbor: true,
      Roades: true,
      Boholt: true,
      Sasciori: true,
      Ludisor: true,
      Selistat: true,
      Valcea: true,
      Savastreni: true,
      Cobor: true,
      Pojorta: true,
      Ionesti: true,
      Malinis: true,
      Valeni: true,
      Paltin: true,
      Fundatica: true,
      "Drumul Carului": true,
      Corbi: true,
      "Paraul Rece": true,
      Lupsa: true,
      Luta: true,
      "Statiunea Climaterica Sambata": true,
      Vistisoara: true,
      "Poiana Brasov": true,
    },
    B: {
      "Bucuresti sectorul 1": true,
      "Bucuresti sectorul 2": true,
      "Bucuresti sectorul 3": true,
      "Bucuresti sectorul 4": true,
      "Bucuresti sectorul 5": true,
      "Bucuresti sectorul 6": true,
    },
    BZ: {
      Buzau: true,
      "Ramnicu Sarat": true,
      Nehoiu: true,
      Pogoanele: true,
      Padina: true,
      Rusetu: true,
      Berca: true,
      Smeeni: true,
      Gheraseni: true,
      Parscov: true,
      Stalpu: true,
      Ramnicelu: true,
      Candesti: true,
      Cochirleanca: true,
      "Vadu Pasii": true,
      Patarlagele: true,
      Capatanesti: true,
      Scurtesti: true,
      Fundeni: true,
      Boldu: true,
      "Glodeanu Sarat": true,
      Unguriu: true,
      Oreavul: true,
      "Posta Calnau": true,
      Cislau: true,
      Luciu: true,
      Grebanu: true,
      Caldarasti: true,
      Maxenu: true,
      Maracineni: true,
      "Valea Ramnicului": true,
      Valcelele: true,
      Lipia: true,
      "Glodeanu-Silistea": true,
      "Bascenii de Jos": true,
      Vernesti: true,
      Tabarasti: true,
      Pietroasele: true,
      Florica: true,
      Amara: true,
      Balaceanu: true,
      Sageata: true,
      Sapoca: true,
      Boboc: true,
      Largu: true,
      Potoceni: true,
      Stancesti: true,
      "Vadu Soresti": true,
      Sahateni: true,
      Pogonele: true,
      "Puiestii de Jos": true,
      Lunca: true,
      Cotatcu: true,
      Saranga: true,
      Suditi: true,
      Magura: true,
      Matesti: true,
      "Lunca Priporului": true,
      "Movila Banului": true,
      Costesti: true,
      Ghergheasa: true,
      Breaza: true,
      Plevna: true,
      "Basca Rozilei": true,
      Pietrosu: true,
      "Zarnestii de Slanic": true,
      Buda: true,
      Zarnesti: true,
      Paltineni: true,
      Salcioara: true,
      "Valea Parului": true,
      "Basca Chiojdului": true,
      Bradeanu: true,
      Zoresti: true,
      Gavanesti: true,
      Lopatari: true,
      Cernatesti: true,
      Rubla: true,
      Dambroca: true,
      "Vintila Voda": true,
      Galbinasi: true,
      "Lunca Jaristei": true,
      Maruntisu: true,
      Smardan: true,
      Greceanca: true,
      Topliceni: true,
      Limpezis: true,
      Babeni: true,
      Chiojdu: true,
      Amaru: true,
      Furtunesti: true,
      Casoca: true,
      "Izvoru Dulce": true,
      Blajani: true,
      Dedulesti: true,
      Scutelnici: true,
      Ulmeni: true,
      Dascalesti: true,
      Corbu: true,
      "Gura Teghii": true,
      Vintileanca: true,
      "Bascenii de Sus": true,
      Grajdana: true,
      Ziduri: true,
      "Buda Craciunesti": true,
      Murgesti: true,
      "Sibiciu de Sus": true,
      Tronari: true,
      "Heliade Radulescu": true,
      Luncile: true,
      Caragele: true,
      Viperesti: true,
      "C.a. Rosetti": true,
      Scarisoara: true,
      Albesti: true,
      Joseni: true,
      Nicolesti: true,
      Plescoi: true,
      "Udati-Manzu": true,
      Homesti: true,
      Pitulicea: true,
      "Sarata-Monteoru": true,
      Calvini: true,
      Costieni: true,
      Tisau: true,
      Cotorca: true,
      Mlajet: true,
      Spataru: true,
      "Dealul Viei": true,
      Bentu: true,
      Lanurile: true,
      Niscov: true,
      Catina: true,
      "Lunca Frumoasa": true,
      Plesesti: true,
      Varlaam: true,
      Paltinis: true,
      Fintesti: true,
      "Valea Nucului": true,
      "Gura Dimienii": true,
      Panatau: true,
      Badila: true,
      Robeasca: true,
      Rosioru: true,
      Margineanu: true,
      Zilisteanca: true,
      Ograzile: true,
      Racoviteni: true,
      Clondiru: true,
      Vacareasca: true,
      Oratia: true,
      "Balta Alba": true,
      Ciuta: true,
      "Cotu Ciorii": true,
      "Coltu Pietrii": true,
      Bragareasa: true,
      Manzalesti: true,
      Hales: true,
      Plostina: true,
      Ivanetu: true,
      "Plaiu Nucului": true,
      Satuc: true,
      "Valea Salciilor": true,
      Focsanei: true,
      Merei: true,
      Tintesti: true,
      Policiori: true,
      Terca: true,
      Strezeni: true,
      Mihailesti: true,
      Ratesti: true,
      "Sibiciu de Jos": true,
      Naeni: true,
      Livada: true,
      Zoita: true,
      Caldaruseanca: true,
      Baile: true,
      Braesti: true,
      Crang: true,
      Colti: true,
      "Alexandru Odobescu": true,
      Stiubei: true,
      Mitropolia: true,
      Podgoria: true,
      Caltuna: true,
      "Mucesti-Danulesti": true,
      "Valea Catinei": true,
      Budisteni: true,
      Macrina: true,
      Sarile: true,
      Barasti: true,
      Beceni: true,
      Muscelusa: true,
      Baltareti: true,
      Aldeni: true,
      Muscel: true,
      Sarulesti: true,
      Pruneni: true,
      Scortoasa: true,
      "Valea Lupului": true,
      Balteni: true,
      Bratilesti: true,
      Dulbanu: true,
      Mosesti: true,
      Palici: true,
      Aliceni: true,
      "Movila Oii": true,
      Niculesti: true,
      Catiasu: true,
      Lera: true,
      "Puiestii de Sus": true,
      Valcele: true,
      Plesi: true,
      "Valea Viei": true,
      Toropalesti: true,
      Vispesti: true,
      Petrisoru: true,
      Arcanu: true,
      Padurenii: true,
      Sarbesti: true,
      "Satu Nou": true,
      Bajani: true,
      Margariti: true,
      Robesti: true,
      "Gura Calnaului": true,
      Potarnichesti: true,
      Bozioru: true,
      Fulga: true,
      Vizireni: true,
      Coconari: true,
      Cuculeasa: true,
      Cilibia: true,
      "Podu Muncii": true,
      "Coltii de Jos": true,
      Lacurile: true,
      Mierea: true,
      Bordusani: true,
      Nemertea: true,
      Gageni: true,
      "Valea Salciei": true,
      Ileana: true,
      "Valeanca-Vilanesti": true,
      Beilic: true,
      Banita: true,
      Poenitele: true,
      Ursoaia: true,
      "Carligu Mare": true,
      Petrachesti: true,
      Raducesti: true,
      Posta: true,
      Modreni: true,
      Nehoiasu: true,
      "Gara Cilibia": true,
      Balanesti: true,
      Recea: true,
      Soresti: true,
      Fantanele: true,
      Colibasi: true,
      Floresti: true,
      Plopeasa: true,
      Olari: true,
      Sarata: true,
      Nenciulesti: true,
      "Grabicina de Jos": true,
      Poienile: true,
      Manasia: true,
      "Valea Larga-Sarulesti": true,
      "Udati-Lucieni": true,
      "Gura Bascei": true,
      Dogari: true,
      Moisica: true,
      Beslii: true,
      Casota: true,
      Goidesti: true,
      Rusavat: true,
      Tega: true,
      Pinu: true,
      Chirlesti: true,
      Campulungeanca: true,
      Cozieni: true,
      Prosca: true,
      "Istrita de Jos": true,
      "Sasenii Noi": true,
      Lipanescu: true,
      Begu: true,
      "Golu Grabicina": true,
      "Valea Cotoarei": true,
      Izvoru: true,
      Lacu: true,
      Negosina: true,
      "Valea Sibiciului": true,
      "Lacu Sinaia": true,
      "Sergent Ionel Stefan": true,
      Gomoesti: true,
      Curmatura: true,
      Bisoca: true,
      Carpinistea: true,
      Paclele: true,
      Manzu: true,
      "Balta Tocila": true,
      Vinetisu: true,
      Beciu: true,
      "Gura Vaii": true,
      Suchea: true,
      Cioranca: true,
      Goicelu: true,
      Lopatareasa: true,
      "Valea Fantanei": true,
      Baltagari: true,
      Cocarceni: true,
      Margaritesti: true,
      "Valea Putului Merei": true,
      Budrea: true,
      Coltaneni: true,
      "Clondiru de Sus": true,
      Danulesti: true,
      Carlomanesti: true,
      "Coca-Antimiresti": true,
      Plaisor: true,
      Tulburea: true,
      "Satu Vechi": true,
      "Gura Saratii": true,
      Canesti: true,
      Fundata: true,
      Trestioara: true,
      "Valea Stanei": true,
      Slobozia: true,
      "Gara Bobocu": true,
      Sindrila: true,
      Campeni: true,
      Trestia: true,
      Balhacu: true,
      Izvoranu: true,
      Fotin: true,
      "Pietroasa Mica": true,
      "Muscelu Caramanesti": true,
      "Gura Badicului": true,
      Zeletin: true,
      Dara: true,
      Leiculesti: true,
      Plescioara: true,
      Zaharesti: true,
      Pardosi: true,
      Fundaturile: true,
      "Piatra Alba": true,
      Runcu: true,
      Izvoarele: true,
      "Glodu-Petcari": true,
      Chiliile: true,
      Ciresu: true,
      "Lacu cu Anini": true,
      "Sasenii Vechi": true,
      Scorteanca: true,
      Dalma: true,
      Varf: true,
      Bercesti: true,
      Costomiru: true,
      "Coca-Niculesti": true,
      Baceni: true,
      "Valea Verzei": true,
      Alunis: true,
      "Livada Mica": true,
      Maguricea: true,
      Barbuncesti: true,
      Rapile: true,
      "Carligu Mic": true,
      Curcanesti: true,
      Ciobanoaia: true,
      Jghiab: true,
      Badeni: true,
      Brebu: true,
      Frasinet: true,
      Cojanu: true,
      Crevelesti: true,
      "Valea Banului": true,
      Bustea: true,
      Balaia: true,
      Stanila: true,
      Scarlatesti: true,
      Gavanele: true,
      "Gura Fagetului": true,
      Deleni: true,
      Teisu: true,
      "Caratnau de Jos": true,
      Pietraru: true,
      Stavarasti: true,
      "Valea Salciei-Catun": true,
      Ruginoasa: true,
      "Manastirea Ratesti": true,
      Plavatu: true,
      Pacurile: true,
      Parjolesti: true,
      "Valea Ursului": true,
      "Valea lui Lalu": true,
      Tocileni: true,
      Pestritu: true,
      Varteju: true,
      Nucu: true,
      "Poiana Valcului": true,
      Potecu: true,
      "Grabicina de Sus": true,
      "Odaia Banului": true,
      Fisici: true,
      Manastirea: true,
      Punga: true,
      Ghizdita: true,
      Tabacari: true,
      "Calea Chiojdului": true,
      "Vadu Oii": true,
      "Valea Larga": true,
      Chiperu: true,
      Secuiu: true,
      Zaplazi: true,
      Anini: true,
      Glodurile: true,
      Plopi: true,
      Bodinesti: true,
      Scorosesti: true,
      Ulmet: true,
      "Caratnau de Sus": true,
      Sareni: true,
      Ceairu: true,
      Batogu: true,
      Caldarusa: true,
      Budesti: true,
      Scaeni: true,
      "Valea Ratei": true,
      Ciocanesti: true,
      Dobrilesti: true,
      Odaile: true,
      Baesti: true,
      "Gura Siriului": true,
      Tarlele: true,
      Grosani: true,
      "Poiana Pletari": true,
      Parscovelu: true,
      Colteni: true,
      "Sasenii pe Vale": true,
      Salcia: true,
      Ghiocari: true,
      Spidele: true,
      Vavalucile: true,
      "Valea Stefanului": true,
      "Capu Satului": true,
      Lungesti: true,
      Posobesti: true,
      Viforata: true,
      Vladeni: true,
      Tarcov: true,
      Trestieni: true,
      Corneanu: true,
      Nistoresti: true,
      Gontesti: true,
      Zapodia: true,
      Stroesti: true,
      Caltesti: true,
      Gornet: true,
      Smeesti: true,
      "Valea Roatei": true,
      "Valea Purcarului": true,
      Buduile: true,
      Nenciu: true,
      Tatarligu: true,
      Movilita: true,
      "Sarile-Catun": true,
      Arbanasi: true,
      Gorani: true,
      Olesesti: true,
      "Valea Schiopului": true,
      "Fata lui Nan": true,
      Gresia: true,
      Bradeanca: true,
      Comisoaia: true,
      Ojasca: true,
      Tatulesti: true,
    },
    CL: {
      Calarasi: true,
      Oltenita: true,
      Borcea: true,
      Chirnogi: true,
      Modelu: true,
      Dragalina: true,
      Fundulea: true,
      Roseti: true,
      Ulmeni: true,
      Fundeni: true,
      Ciocanesti: true,
      Radovanu: true,
      Curcani: true,
      Perisoru: true,
      Budesti: true,
      Manastirea: true,
      "Lehliu-Gara": true,
      Chiselet: true,
      "Dor Marunt": true,
      Vasilati: true,
      Galbinasi: true,
      "Stefan cel Mare": true,
      Nana: true,
      Crivat: true,
      "Stefan Voda": true,
      Unirea: true,
      Independenta: true,
      "Valea Rosie": true,
      "Dragos Voda": true,
      Cascioarele: true,
      Stancea: true,
      Soldanu: true,
      Sohatu: true,
      Jegalia: true,
      Frumusani: true,
      Gradistea: true,
      Razvani: true,
      "Cuza Voda": true,
      Lehliu: true,
      Mitreni: true,
      Plataresti: true,
      "Sarulesti-Gara": true,
      Luica: true,
      Dorobantu: true,
      "Vlad Tepes": true,
      Tonea: true,
      Galdau: true,
      Progresu: true,
      "Valea Argovei": true,
      Ceacu: true,
      "Nicolae Balcescu": true,
      Valcelele: true,
      "Drajna Noua": true,
      "Radu Voda": true,
      Varasti: true,
      Spantov: true,
      Rasa: true,
      Aprozi: true,
      Coconi: true,
      "Dalga-Gara": true,
      "Alexandru Odobescu": true,
      Iezeru: true,
      Sultana: true,
      "Constantin Brancoveanu": true,
      Sapunari: true,
      Negoesti: true,
      "Tamadau Mare": true,
      Potcoava: true,
      "Mihai Viteazu": true,
      Ulmu: true,
      Ileana: true,
      Cunesti: true,
      Belciugatele: true,
      Dalga: true,
      Gruiu: true,
      "Cetatea Veche": true,
      Coslogeni: true,
      Pasarea: true,
      Silistea: true,
      Padurisu: true,
      "Valea Popii": true,
      Plevna: true,
      Gostilele: true,
      Nucetu: true,
      "Calarasii Vechi": true,
      Clatesti: true,
      "Tudor Vladimirescu": true,
      Bogata: true,
      Buciumeni: true,
      Floroaica: true,
      Lupsanu: true,
      Cucuieti: true,
      "Valea Stanii": true,
      Florica: true,
      Stefanesti: true,
      Gurbanesti: true,
      Sarulesti: true,
      Artari: true,
      Visinii: true,
      Buzoeni: true,
      Faurei: true,
      Mariuta: true,
      Luptatori: true,
      Postavari: true,
      Satnoeni: true,
      Sandulita: true,
      Bosneagu: true,
      Cotofanca: true,
      Plumbuita: true,
      "Podu Pitarului": true,
      Oltina: true,
      Dichiseni: true,
      "Fantana Doamnei": true,
      Ogoru: true,
      Popesti: true,
      Galatui: true,
      Infratirea: true,
      Danesti: true,
      Nuci: true,
      Frasinet: true,
      "Frasinetu de Jos": true,
      Candeasca: true,
      Calareti: true,
      Socoalele: true,
      "Valea Presnei": true,
      "Marculesti-Gara": true,
      Orasti: true,
      "Satu Nou": true,
      Vladiceasca: true,
      Cojesti: true,
      Bogdana: true,
      Solacolu: true,
      Seinoiu: true,
      Vlaiculesti: true,
      Preasna: true,
      Zimbru: true,
      Podari: true,
      Pelinu: true,
      Curatesti: true,
      "Tamadau Mic": true,
      Razoarele: true,
      Darvari: true,
      Polcesti: true,
      Paicu: true,
      Pitigaia: true,
      Sacele: true,
      Magureni: true,
      Salcioara: true,
      Ostrovu: true,
      "Valea Rusului": true,
      Tariceni: true,
      Mataraua: true,
      Rasurile: true,
      Satucu: true,
      "Alexandru I. Cuza": true,
      Codreni: true,
      Libertatea: true,
      Lunca: true,
      "Preasna Veche": true,
      "Radu Negru": true,
      Stoenesti: true,
      "Valea Seaca": true,
    },
    CS: {
      Resita: true,
      Caransebes: true,
      Bocsa: true,
      Oravita: true,
      "Otelu Rosu": true,
      "Moldova Veche": true,
      Anina: true,
      "Baile Herculane": true,
      "Moldova Noua": true,
      Steierdorf: true,
      Teregova: true,
      Mehadia: true,
      Toplet: true,
      Bozovici: true,
      Carasova: true,
      Berzovia: true,
      Dognecea: true,
      Tarnova: true,
      Verendin: true,
      "Slatina-Timis": true,
      "Eftimie Murgu": true,
      Glimboca: true,
      "Rusca Montana": true,
      Racasdia: true,
      Obreja: true,
      Maureni: true,
      Calnic: true,
      Bautar: true,
      Berzasca: true,
      "Turnu Ruieni": true,
      Borlova: true,
      Armenis: true,
      Sichevita: true,
      Rusca: true,
      "Lapusnicu Mare": true,
      Bania: true,
      Ramna: true,
      Pojejena: true,
      Coronini: true,
      Liubcova: true,
      Marga: true,
      "Ciclova Romana": true,
      Domasnea: true,
      Vermes: true,
      Gradinari: true,
      Valiug: true,
      Prigor: true,
      Ghertenis: true,
      Luncavita: true,
      Varciorova: true,
      Dalboset: true,
      Plugova: true,
      Bucova: true,
      Lupac: true,
      Fizes: true,
      Cornutel: true,
      "Zorlentu Mare": true,
      Greoni: true,
      Petrosnita: true,
      Maru: true,
      Mehadica: true,
      Vrani: true,
      "Padina Matei": true,
      Farliug: true,
      "Valea Bolvasnita": true,
      Clocotici: true,
      Iablanita: true,
      Naidas: true,
      Ciudanovita: true,
      Ilova: true,
      Varadia: true,
      Sacu: true,
      Petnic: true,
      Cornea: true,
      Carbunari: true,
      "Ocna de Fier": true,
      Binis: true,
      Bucosnita: true,
      Garnic: true,
      "Globu Craiovei": true,
      Prilipet: true,
      Fenes: true,
      "Sopotu Vechi": true,
      Sosdea: true,
      Socol: true,
      Ciresa: true,
      Doman: true,
      Ruschita: true,
      Valisoara: true,
      Moceris: true,
      Zavoi: true,
      "Sasca Montana": true,
      "Ticvaniu Mare": true,
      Garbovat: true,
      Cuptoare: true,
      Zlatita: true,
      Poiana: true,
      Cavaran: true,
      Comoraste: true,
      Patas: true,
      Lapusnicel: true,
      Brebu: true,
      "Sfanta Elena": true,
      Brosteni: true,
      Tirol: true,
      Macesti: true,
      "Ciclova Montana": true,
      Belobresca: true,
      Soceni: true,
      Parvova: true,
      Gornea: true,
      Iaz: true,
      Campia: true,
      Crusovat: true,
      "23-Aug": true,
      Paltinis: true,
      Forotic: true,
      Voislova: true,
      Ezeris: true,
      Golet: true,
      "Bradisoru de Jos": true,
      Nermed: true,
      Pecinisca: true,
      Rafnic: true,
      Ciuchici: true,
      "Valea Timisului": true,
      Mercina: true,
      Zorile: true,
      "Borlovenii Vechi": true,
      Bolvasnita: true,
      Doclin: true,
      Barza: true,
      Delinesti: true,
      Radimna: true,
      Jupa: true,
      "Borlovenii Noi": true,
      Zervesti: true,
      Terova: true,
      Valeapai: true,
      Zagujeni: true,
      "Sasca Romana": true,
      Magura: true,
      Stinapari: true,
      "Sat Batran": true,
      Secu: true,
      "Surducu Mare": true,
      Vraniut: true,
      Susca: true,
      Copacele: true,
      Maciova: true,
      Iam: true,
      Tincova: true,
      Vodnic: true,
      Garliste: true,
      Berliste: true,
      "Matnicu Mare": true,
      Prisian: true,
      Buchin: true,
      Scaius: true,
      Prisaca: true,
      "Valea Bistrei": true,
      Ilidia: true,
      Stancilova: true,
      Goruia: true,
      Var: true,
      Canicea: true,
      Rachitova: true,
      Lescovita: true,
      Carnecea: true,
      Mal: true,
      "Poiana Marului": true,
      Izgar: true,
      "Ticvaniu Mic": true,
      Moniom: true,
      "Sadova Noua": true,
      Zlagna: true,
      Divici: true,
      "Slatina-Nera": true,
      "Sopotu Nou": true,
      Rugi: true,
      Ciuta: true,
      Secaseni: true,
      Potoc: true,
      Milcoveni: true,
      Moldovita: true,
      Nicolint: true,
      "Ohaba-Matnic": true,
      "Sub Margine": true,
      Cornereva: true,
      Cornisoru: true,
      "Sadova Veche": true,
      Apadia: true,
      Ersig: true,
      Globurau: true,
      Bigar: true,
      Pestere: true,
      Dalci: true,
      Duleu: true,
      Agadici: true,
      Iabalcea: true,
      Valeadeni: true,
      Petrilova: true,
      Ciortea: true,
      Bogaltin: true,
      Bogodint: true,
      "Remetea-Poganici": true,
      Ravensca: true,
      Dezesti: true,
      Jitin: true,
      "Pogara de Sus": true,
      "Salbagelu Nou": true,
      Socolari: true,
      Putna: true,
      Sumita: true,
      Macoviste: true,
      Zbegu: true,
      Bojia: true,
      Giurgiova: true,
      Rachita: true,
      Cozla: true,
      Topla: true,
      Cozia: true,
      "Valea Mare": true,
      Calina: true,
      Zanogi: true,
      Iertof: true,
      Zorlencior: true,
      "Rusova Noua": true,
      Ruginosu: true,
      Camena: true,
      Negiudin: true,
      Ohabita: true,
      Garana: true,
      Marila: true,
      "Valea Rachitei": true,
      Brezon: true,
      Crusovita: true,
      Izvor: true,
      Rustin: true,
      "Vama Marga": true,
      "Hora Mare": true,
      "Carsa Rosie": true,
      Zmogotin: true,
      "Lunca Florii": true,
      "Rusova Veche": true,
      "Lunca Zaicii": true,
      "Poiana Lunga": true,
      Carsie: true,
      Parneaura: true,
      "Cracu Teiului": true,
      Poneasca: true,
      "Sub Plai": true,
      "Valea Rosie": true,
      Zoina: true,
      Prislop: true,
      Studena: true,
      Pogara: true,
      Barbosu: true,
      Obita: true,
      Strugasca: true,
      "Sub Crang": true,
      Barz: true,
      Gruni: true,
      Zasloane: true,
      Mesteacan: true,
      "Poienile Boinei": true,
      Costis: true,
      Frasinis: true,
      Tatu: true,
      Urcu: true,
      Bazias: true,
      Borugi: true,
      Prisacina: true,
      Boina: true,
      Inelet: true,
      Ciresel: true,
      Dolina: true,
      Lucacevat: true,
      "Valea Ravensca": true,
      Arsuri: true,
      "Valea Minisului": true,
      "Hora Mica": true,
      Zanou: true,
      "Cracu Mare": true,
      Curmatura: true,
      Dristie: true,
      Cicleni: true,
      Dobraia: true,
      "Valea Sichevitei": true,
      Camenita: true,
      "Resita Mica": true,
      Scarisoara: true,
      Martinovat: true,
      Preveciori: true,
      Boinita: true,
      "Brebu Nou": true,
      Brestelnic: true,
      Bratova: true,
      "Cracu Almaj": true,
      Streneac: true,
      "Valea Orevita": true,
      Plopu: true,
      Liborajdea: true,
      "Ogasu Podului": true,
      Lindenfeld: true,
      Drencova: true,
    },
    CJ: {
      "Cluj-Napoca": true,
      Turda: true,
      Dej: true,
      "Campia Turzii": true,
      Gherla: true,
      Huedin: true,
      Gilau: true,
      Viisoara: true,
      "Mihai Viteazu": true,
      Apahida: true,
      Floresti: true,
      Baciu: true,
      "Aghiresu-Fabrici": true,
      Sic: true,
      Bontida: true,
      Luna: true,
      Cojocna: true,
      "Ocna Dejului": true,
      Cuzdrioara: true,
      Iara: true,
      Unguras: true,
      "Luna de Sus": true,
      Marisel: true,
      Negreni: true,
      Feleacu: true,
      Iclod: true,
      "Valea Draganului": true,
      Frata: true,
      Chiuiesti: true,
      "Somesu Rece": true,
      Mociu: true,
      "Tritenii de Jos": true,
      Suatu: true,
      Borsa: true,
      Catcau: true,
      Rascruci: true,
      "Jucu de Sus": true,
      "Fizesu Gherlii": true,
      Padureni: true,
      Ciucea: true,
      "Mintiu Gherlii": true,
      Caseiu: true,
      Camarasu: true,
      Aghiresu: true,
      Mera: true,
      Luncani: true,
      "Soporu de Campie": true,
      Sannicoara: true,
      Buza: true,
      Moldovenesti: true,
      Bogata: true,
      "Tritenii de Sus": true,
      Sancraiu: true,
      Poieni: true,
      Calatele: true,
      Nires: true,
      Risca: true,
      Gheorghieni: true,
      Suceagu: true,
      Urca: true,
      Baisoara: true,
      Dezmir: true,
      Copaceni: true,
      Savadisla: true,
      "Ceanu Mare": true,
      Calarasi: true,
      Sanmarghita: true,
      Rugasesti: true,
      "Vaida-Camaras": true,
      Maguri: true,
      Chinteni: true,
      Tureni: true,
      Morlaca: true,
      "Izvoru Crisului": true,
      Batin: true,
      Catina: true,
      "Capusu Mare": true,
      Valcele: true,
      Dabaca: true,
      Urisor: true,
      Vlaha: true,
      Rachitele: true,
      "Capusu Mic": true,
      Bunesti: true,
      Livada: true,
      "Maguri-Racatau": true,
      Palatca: true,
      Vistea: true,
      Taga: true,
      Rogojel: true,
      Podeni: true,
      "Valea Ierii": true,
      Finisel: true,
      Aiton: true,
      "Luna de Jos": true,
      Bucea: true,
      Sanpaul: true,
      Boldut: true,
      "Petrestii de Jos": true,
      Boian: true,
      Macau: true,
      Orman: true,
      Rediu: true,
      Berchiesu: true,
      Iacobeni: true,
      Manastireni: true,
      Nima: true,
      Bedeciu: true,
      Gadalin: true,
      Bologa: true,
      Garbau: true,
      Badeni: true,
      Panticeu: true,
      Samboleni: true,
      Cornesti: true,
      Mica: true,
      Fundatura: true,
      Cara: true,
      "Jucu de Mijloc": true,
      "Aschileu Mare": true,
      "Somcutu Mic": true,
      Geaca: true,
      Manasturel: true,
      Sacuieu: true,
      Alunis: true,
      Hasdate: true,
      Manastirea: true,
      Visea: true,
      "Muntele Rece": true,
      Corusu: true,
      Boju: true,
      Sandulesti: true,
      Feldioara: true,
      Leghia: true,
      Agris: true,
      Margau: true,
      Hodisu: true,
      Belis: true,
      Pata: true,
      Tranisu: true,
      Salisca: true,
      "Cacova Ierii": true,
      Popesti: true,
      Bobalna: true,
      Caianu: true,
      Plaiesti: true,
      Turea: true,
      Cutca: true,
      "Somesu Cald": true,
      Naoiu: true,
      "Recea-Cristur": true,
      Vechea: true,
      Agarbiciu: true,
      Micesti: true,
      Sardu: true,
      Cetan: true,
      Cheia: true,
      Santioana: true,
      "Ceanu Mic": true,
      Vanatori: true,
      Berindu: true,
      Nicula: true,
      Nasal: true,
      Pintic: true,
      Gligoresti: true,
      Corpadea: true,
      "Cublesu Somesan": true,
      Liteni: true,
      Colonia: true,
      Ghirolt: true,
      "Dealu Negru": true,
      Bicalatu: true,
      Inucu: true,
      Strambu: true,
      Calata: true,
      Vultureni: true,
      Visagu: true,
      Aruncuta: true,
      Cristorel: true,
      Baita: true,
      "Poiana Horea": true,
      Valeni: true,
      Sacel: true,
      "Jichisu de Jos": true,
      Magoaja: true,
      Soimeni: true,
      Lujerdiu: true,
      Coplean: true,
      Bagara: true,
      "Iuriu de Campie": true,
      "Juc-Herghelie": true,
      Chesau: true,
      "Dealu Mare": true,
      Dumbrava: true,
      Paniceni: true,
      "Ghirisu Roman": true,
      Ploscos: true,
      Sucutard: true,
      Vad: true,
      Bont: true,
      Surduc: true,
      "Aschileu Mic": true,
      Codor: true,
      "Muntele Baisorii": true,
      Nadaselu: true,
      "Calarasi-Gara": true,
      "Dangau Mare": true,
      "Tritenii-Hotar": true,
      Sarata: true,
      Martinesti: true,
      Barai: true,
      "Bogata de Jos": true,
      "Lunca Visagului": true,
      Nadasu: true,
      Lacu: true,
      "Fagetu Ierii": true,
      Guga: true,
      Lita: true,
      Fodora: true,
      Criseni: true,
      "Dangau Mic": true,
      Boteni: true,
      Salicea: true,
      Marcesti: true,
      "Topa Mica": true,
      Feiurdeni: true,
      Deleni: true,
      Macicasu: true,
      Ceaba: true,
      Mihaiesti: true,
      "Jichisu de Sus": true,
      "Garbau Dejului": true,
      "Bogata de Sus": true,
      "Filea de Jos": true,
      Faureni: true,
      Sanmartin: true,
      "Zorenii de Vale": true,
      Razbuneni: true,
      "Valea Grosilor": true,
      "Valea Ungurasului": true,
      "Valea Florilor": true,
      "Caianu-Vama": true,
      Deusu: true,
      "Poiana Fratii": true,
      "Manasturu Romanesc": true,
      Sava: true,
      Buru: true,
      Muncel: true,
      Tioltiur: true,
      Hagau: true,
      "Diviciorii Mari": true,
      Babdiu: true,
      Giula: true,
      Darja: true,
      Samboieni: true,
      Stolna: true,
      Craesti: true,
      Sacalaia: true,
      Petresti: true,
      "Scrind-Frasinet": true,
      Masca: true,
      Domosu: true,
      Barlea: true,
      "Filea de Sus": true,
      Stejeris: true,
      Comsesti: true,
      "Ticu-Colonie": true,
      Ciurila: true,
      Rosieni: true,
      Elciu: true,
      Santejude: true,
      Chidea: true,
      Osoi: true,
      Silivas: true,
      Arghisu: true,
      Petea: true,
      Salatiu: true,
      Ocolisel: true,
      Plaiuri: true,
      Coasta: true,
      "Giurcuta de Sus": true,
      Finciu: true,
      Babutiu: true,
      Strucut: true,
      Alunisu: true,
      Rotunda: true,
      Legii: true,
      Vale: true,
      Saula: true,
      Iclozel: true,
      Nearsova: true,
      "Hodai Boian": true,
      Maia: true,
      Olariu: true,
      "Salistea Noua": true,
      Tauti: true,
      Ciubancuta: true,
      Corneni: true,
      "Curtuiusu Dejului": true,
      "Petrestii de Mijloc": true,
      "Caianu Mic": true,
      "Tiocu de Jos": true,
      Ciumafaia: true,
      Dancu: true,
      Paglisa: true,
      Badesti: true,
      Stoiana: true,
      "Valea Calda": true,
      Calna: true,
      Cerc: true,
      "Muntele Cacovei": true,
      Pietroasa: true,
      Suaras: true,
      Huci: true,
      Ciubanca: true,
      Horlacea: true,
      Huta: true,
      Braisoru: true,
      Caprioara: true,
      "Tiocu de Sus": true,
      Copru: true,
      Balcesti: true,
      "Dosu Napului": true,
      Dretea: true,
      Hodaie: true,
      Padurenii: true,
      Tarpiu: true,
      Saliste: true,
      "Boj-Catun": true,
      "Muresenii de Campie": true,
      Prunis: true,
      Leurda: true,
      Sutu: true,
      Valcelele: true,
      Fanate: true,
      Prelucele: true,
      Plopi: true,
      Mahal: true,
      Bociu: true,
      Sumurducu: true,
      Tauseni: true,
      Lapustesti: true,
      Valisoara: true,
      "Diviciorii Mici": true,
      "Valea lui Cati": true,
      "Satu Lung": true,
      Puini: true,
      Targusor: true,
      Radaia: true,
      Oas: true,
      Ardeova: true,
      Cremenea: true,
      Ciuleni: true,
      Damburile: true,
      Bica: true,
      Doroltu: true,
      "Petrestii de Sus": true,
      Clapa: true,
      Chiris: true,
      Crairat: true,
      "Santejude Vale": true,
      Osorhel: true,
      Straja: true,
      Borzesti: true,
      Catalina: true,
      Escu: true,
      Saradis: true,
      Ticu: true,
      "Valea lui Opris": true,
      "Magura Ierii": true,
      Morau: true,
      "Muntele Sacelului": true,
      "Valea Vadului": true,
      "Moara de Padure": true,
      Bagaciu: true,
      Buteni: true,
      "Valea Caseielului": true,
      Bodrog: true,
      "Dambu Mare": true,
      Jurca: true,
      Pruni: true,
      Igritia: true,
      Ciurgau: true,
      "Borsa-Catun": true,
      "Salistea Veche": true,
      Pustuta: true,
      Salatruc: true,
      Dorna: true,
      "Muntele Bocului": true,
      "Valea Luncii": true,
      Lungesti: true,
      "Sub Coasta": true,
      Sigau: true,
      Pruneni: true,
      "Dealu Botii": true,
      Turmasi: true,
      Lobodas: true,
      Darot: true,
      Smida: true,
      Custura: true,
      Frasinet: true,
      Antas: true,
      "Padurea Iacobeni": true,
      Cerbesti: true,
      "Muntele Filii": true,
      "Valea Garboului": true,
      "Dosu Bricii": true,
      Razoare: true,
      "Valea Agrisului": true,
      Blidaresti: true,
      Sicfa: true,
      Comorata: true,
      Moristi: true,
      "Valea Ciresoii": true,
      Starcu: true,
      Falca: true,
      Mortesti: true,
      Campenesti: true,
      "Borsa-Crestaia": true,
      Andici: true,
      "Casele Micesti": true,
      "Giurcuta de Jos": true,
      "Lunca Bontului": true,
      Pestera: true,
    },
    CT: {
      Constanta: true,
      Medgidia: true,
      Mangalia: true,
      Navodari: true,
      Cernavoda: true,
      Ovidiu: true,
      Harsova: true,
      Murfatlar: true,
      "Mihail Kogalniceanu": true,
      Cumpana: true,
      "Valu lui Traian": true,
      Techirghiol: true,
      Cobadin: true,
      Tuzla: true,
      Lumina: true,
      "Eforie Sud": true,
      "Eforie Nord": true,
      "Negru Voda": true,
      "Palazu Mare": true,
      Baneasa: true,
      Corbu: true,
      Cogealac: true,
      Agigea: true,
      "Poarta Alba": true,
      "Nicolae Balcescu": true,
      Ciobanu: true,
      Topraisar: true,
      Ostrov: true,
      Ghindaresti: true,
      Rasova: true,
      "Cuza Voda": true,
      Castelu: true,
      Pecineaga: true,
      "Satu Nou": true,
      "23-Aug": true,
      Oltina: true,
      Sacele: true,
      Topalu: true,
      Garliciu: true,
      Chirnogeni: true,
      "2 Mai": true,
      Pestera: true,
      "Mircea Voda": true,
      "Mihai Viteazu": true,
      Limanu: true,
      Fantanele: true,
      Nisipari: true,
      Dorobantu: true,
      Ciocarlia: true,
      Dunareni: true,
      Viisoara: true,
      Tortoman: true,
      Targusor: true,
      Piatra: true,
      Dulcesti: true,
      Amzacea: true,
      Independenta: true,
      Istria: true,
      Mosneni: true,
      Sinoie: true,
      Cochirleni: true,
      Schitu: true,
      Albesti: true,
      Plopeni: true,
      "Ciocarlia de Sus": true,
      "Valea Dacilor": true,
      Adamclisi: true,
      Lipnita: true,
      Faclia: true,
      Crucea: true,
      Mereni: true,
      Tariverde: true,
      Nuntasi: true,
      Pietreni: true,
      Viile: true,
      Siminoc: true,
      Almalau: true,
      "Cotu Vaii": true,
      "General Scarisoreanu": true,
      Baraganu: true,
      Comana: true,
      Saraiu: true,
      Lanurile: true,
      Faurei: true,
      Coslugea: true,
      "Seimenii Mici": true,
      Gradina: true,
      Nazarcea: true,
      "Tepes Voda": true,
      Stupina: true,
      Dunarea: true,
      Aliman: true,
      Movilita: true,
      Horia: true,
      Negureni: true,
      Costinesti: true,
      Vulturu: true,
      Saligny: true,
      Pantelimon: true,
      "Izvoru Mare": true,
      "Ramnicu de Jos": true,
      Silistea: true,
      Dobromir: true,
      Poiana: true,
      Zorile: true,
      Darabani: true,
      Canlia: true,
      Razoarele: true,
      Tataru: true,
      Vadu: true,
      Petrosani: true,
      Galita: true,
      "Sanatoriul Agigea": true,
      "Movila Verde": true,
      Arsa: true,
      Osmancea: true,
      Biruinta: true,
      Cerchezu: true,
      Negresti: true,
      Vlahii: true,
      Oituz: true,
      Sipotele: true,
      Viroaga: true,
      Lazu: true,
      "Ion Corvin": true,
      Dulgheru: true,
      Carvan: true,
      Seimeni: true,
      "Ivrinezu Mare": true,
      Baltagesti: true,
      Valeni: true,
      Casicea: true,
      Olteni: true,
      Dumbraveni: true,
      Crisan: true,
      "Stefan cel Mare": true,
      Tichilesti: true,
      Runcu: true,
      Potarnichea: true,
      Tufani: true,
      "Ivrinezu Mic": true,
      Miorita: true,
      Sibioara: true,
      "Dobromiru din Deal": true,
      Deleni: true,
      Cheia: true,
      Ciobanita: true,
      Conacu: true,
      "Fantana Mare": true,
      Esechioi: true,
      Lespezi: true,
      Mireasa: true,
      Urluia: true,
      Garlita: true,
      Pelinu: true,
      Credinta: true,
      "Palazu Mic": true,
      Raristea: true,
      Siriu: true,
      Cascioarele: true,
      Vartop: true,
      Valcelele: true,
      Galbiori: true,
      Bugeac: true,
      "Pantelimon de Jos": true,
      "Remus Opreanu": true,
      Cetatea: true,
      Nistoresti: true,
      "Vadu Oii": true,
      Cuiugiuc: true,
      Vanatori: true,
      Izvoarele: true,
      Crangu: true,
      "Gura Dobrogei": true,
      Padureni: true,
      Goruni: true,
      Coroana: true,
      Magura: true,
      Closca: true,
      Hagieni: true,
      Floriile: true,
      Abrud: true,
      "Vama Veche": true,
      "Ramnicu de Sus": true,
      Calugareni: true,
      Tibrinu: true,
      Capidava: true,
      Dropia: true,
      Furnica: true,
      Traian: true,
      Luminita: true,
      Brebeni: true,
      "Tudor Vladimirescu": true,
      Stejaru: true,
      Miristea: true,
      Hateg: true,
      Casian: true,
      Gherghina: true,
      Veteranu: true,
      Strunga: true,
      "Statiunea Zoologica Marina Agigea": true,
      "Cap Aurora": true,
      Curcani: true,
      Graniceru: true,
      Jupiter: true,
      Mamaia: true,
      "Mamaia-Sat": true,
      Neptun: true,
      Olimp: true,
      Saturn: true,
      Straja: true,
      Venus: true,
    },
    CV: {
      "Sfantu Gheorghe": true,
      "Targu Secuiesc": true,
      Covasna: true,
      "Intorsura Buzaului": true,
      Baraolt: true,
      Ghelinta: true,
      Zagon: true,
      Turia: true,
      "Sita Buzaului": true,
      Zabala: true,
      Cernat: true,
      Ojdula: true,
      Sanzieni: true,
      Bretcu: true,
      Ozun: true,
      Barcani: true,
      Lemnia: true,
      Varghis: true,
      Micfalau: true,
      Bixad: true,
      "Batanii Mari": true,
      Haghig: true,
      Lunga: true,
      "Valea Crisului": true,
      Belin: true,
      "Borosneu Mare": true,
      Catalina: true,
      Reci: true,
      Doboseni: true,
      Araci: true,
      Poian: true,
      Bodoc: true,
      Papauti: true,
      Filia: true,
      Arcus: true,
      Capeni: true,
      Floroaia: true,
      "Valea Mare": true,
      Comandau: true,
      Ghidfalau: true,
      Dobarlau: true,
      Chichis: true,
      Herculian: true,
      Dalnic: true,
      "Belin-Vale": true,
      Ilieni: true,
      "Racosul de Sus": true,
      Bradut: true,
      Valcele: true,
      Mereni: true,
      "Aita Mare": true,
      Petriceni: true,
      Moacsa: true,
      "Aita Seaca": true,
      "Aita Medie": true,
      Martanus: true,
      Biborteni: true,
      Estelnic: true,
      Santionlunca: true,
      Bradet: true,
      Talisoara: true,
      Ladauti: true,
      Saramas: true,
      "Valea Seaca": true,
      Anghelus: true,
      Bacel: true,
      Let: true,
      Martineni: true,
      Chilieni: true,
      Brates: true,
      Telechia: true,
      Zabratau: true,
      Zalan: true,
      Marcusa: true,
      Surcea: true,
      Olteni: true,
      Malnas: true,
      Tamasfalau: true,
      Crasna: true,
      "Dobolii de Jos": true,
      "Batanii Mici": true,
      Miclosoara: true,
      Calnic: true,
      Lutoasa: true,
      Ariusd: true,
      Coseni: true,
      "Malnas-Bai": true,
      Iaras: true,
      Marcus: true,
      Belani: true,
      Lisnau: true,
      "Lunca Marcusului": true,
      Chiurus: true,
      Bodos: true,
      Albis: true,
      Bicfalau: true,
      Hatuica: true,
      Aninoasa: true,
      Oituz: true,
      "Borosneu Mic": true,
      Alungeni: true,
      Fotos: true,
      Zoltan: true,
      "Valea Dobarlaului": true,
      Padureni: true,
      Pachia: true,
      "Casinu Mic": true,
      Bita: true,
      Hilib: true,
      Icafalau: true,
      Imeni: true,
      Sancraiu: true,
      Harale: true,
      "Valea Scurta": true,
      "Dobolii de Sus": true,
      "Lunca Ozunului": true,
      Tufalau: true,
      "Valea Zalanului": true,
      Scradoasa: true,
      Hetea: true,
      Peteni: true,
      Saciova: true,
      Magherus: true,
      "Lisnau-Vale": true,
      "Ozunca-Bai": true,
      "Valea Mica": true,
      Carpinenii: true,
      Merisor: true,
    },
    DB: {
      Targoviste: true,
      Moreni: true,
      Gaesti: true,
      Pucioasa: true,
      Titu: true,
      Fieni: true,
      Doicesti: true,
      Sotanga: true,
      Lunguletu: true,
      Ocnita: true,
      "Baleni-Sarbi": true,
      Razvad: true,
      Bezdead: true,
      Ghirdoveni: true,
      Poiana: true,
      Darmanesti: true,
      Bucsani: true,
      "Gura Sutii": true,
      "Baleni-Romani": true,
      Comisani: true,
      Branesti: true,
      Visina: true,
      Branistea: true,
      Romanesti: true,
      "Gura Ocnitei": true,
      Potlogi: true,
      Vacaresti: true,
      "Picior de Munte": true,
      Vladeni: true,
      Persinari: true,
      "Valeni-Dambovita": true,
      Mija: true,
      Morteni: true,
      Crevedia: true,
      "Vulcana-Pandele": true,
      Lucieni: true,
      Brezoaia: true,
      Pietrosita: true,
      "Slobozia Moara": true,
      Teis: true,
      "Valea Voivozilor": true,
      Niculesti: true,
      "I. L. Caragiale": true,
      Decindeni: true,
      Gheboaia: true,
      Nucet: true,
      Aninoasa: true,
      Racari: true,
      Rascaeti: true,
      Tartasesti: true,
      Iazu: true,
      Ciocanesti: true,
      "Costestii din Vale": true,
      Viforata: true,
      Adanca: true,
      Cornesti: true,
      Dobra: true,
      Fantanele: true,
      Cojasca: true,
      Ungureni: true,
      Baldana: true,
      Sperieteni: true,
      Ionesti: true,
      Marcesti: true,
      Lazuri: true,
      Sacueni: true,
      Grozavesti: true,
      Darza: true,
      Buciumeni: true,
      "Dragaesti Pamanteni": true,
      Rancaciov: true,
      Mogosani: true,
      Dragomiresti: true,
      Brezoaele: true,
      Butimanu: true,
      Fierbinti: true,
      Voinesti: true,
      Odobesti: true,
      Moroeni: true,
      "Corbii Mari": true,
      Motaieni: true,
      "Valea Leurzii": true,
      Caprioru: true,
      Pucheni: true,
      Gheboieni: true,
      Raciu: true,
      "Dealu Mare": true,
      Cazaci: true,
      "Iedera de Jos": true,
      "Vulcana-Bai": true,
      Barbuletu: true,
      "Finta Mare": true,
      Dragodanesti: true,
      Habeni: true,
      Salcuta: true,
      Produlesti: true,
      Serdanu: true,
      Glodeni: true,
      "Vulcana de Sus": true,
      "Valea Lunga Ogrea": true,
      Sateni: true,
      Contesti: true,
      Manesti: true,
      Selaru: true,
      Gorgota: true,
      Dragodana: true,
      Bungetu: true,
      "Gura Vulcanei": true,
      Lunca: true,
      Ciocanari: true,
      Crovu: true,
      Dambovicioara: true,
      Tatarani: true,
      Glod: true,
      "Iedera de Sus": true,
      "Odaia Turcului": true,
      "Rau Alb de Jos": true,
      "Gura Foii": true,
      Racovita: true,
      Brosteni: true,
      "Gemenea Bratulesti": true,
      "Marginenii de Sus": true,
      "Scheiu de Jos": true,
      Viisoara: true,
      Greci: true,
      Pietrari: true,
      "Candesti-Vale": true,
      Petresti: true,
      Visinesti: true,
      Balteni: true,
      "Dragaesti Ungureni": true,
      Ulmi: true,
      Urziceanca: true,
      Mavrodin: true,
      Ghinesti: true,
      Colacu: true,
      Priboiu: true,
      Badeni: true,
      Zavoiu: true,
      Vlasceni: true,
      "Suseni Socetu": true,
      "Scheiu de Sus": true,
      Pitaru: true,
      Matasaru: true,
      Gulia: true,
      "Dealu Frumos": true,
      "Malu cu Flori": true,
      Postarnacu: true,
      "Costestii din Deal": true,
      Ibrianu: true,
      Croitori: true,
      Zidurile: true,
      Tetcoiu: true,
      Laculete: true,
      Vizuresti: true,
      Runcu: true,
      Ghimpati: true,
      Boboci: true,
      Toculesti: true,
      Samurcasi: true,
      "Valea Mare": true,
      Boteni: true,
      Gusoiu: true,
      Bolovani: true,
      Poroinica: true,
      Burduca: true,
      Urseiu: true,
      Oncesti: true,
      Glogoveanu: true,
      "Suta Seaca": true,
      "Puntea de Greci": true,
      Costesti: true,
      Hulubesti: true,
      Potocelu: true,
      "Butoiu de Jos": true,
      Silistea: true,
      Priseaca: true,
      Ragu: true,
      Ludesti: true,
      "Butoiu de Sus": true,
      "Patroaia Vale": true,
      "Podu Rizii": true,
      Mislea: true,
      "Mircea Voda": true,
      Cojocaru: true,
      Maruntisu: true,
      Ghergani: true,
      Merii: true,
      Brancoveanu: true,
      Movila: true,
      Bilciuresti: true,
      Catunu: true,
      Valea: true,
      Suduleni: true,
      "Putu cu Salcie": true,
      "Valea Lunga Gorgota": true,
      Bechinesti: true,
      "Capu Coastei": true,
      Magura: true,
      Manga: true,
      "Rau Alb de Sus": true,
      Frasinu: true,
      Manastioara: true,
      "Miclosanii Mici": true,
      Izvoarele: true,
      Brebu: true,
      Jugureni: true,
      Cucuteni: true,
      Berevoesti: true,
      Bela: true,
      "Valea Caselor": true,
      Plopu: true,
      Izvoru: true,
      Tomsani: true,
      Colibasi: true,
      Manastirea: true,
      Uliesti: true,
      "Bratestii de Jos": true,
      Fusea: true,
      Telesti: true,
      Badulesti: true,
      Bujoreanca: true,
      "Gura Barbuletului": true,
      Schela: true,
      Cuparu: true,
      Cocani: true,
      "Frasin Deal": true,
      Cretu: true,
      Gherghesti: true,
      Decindea: true,
      Ferestre: true,
      Hagioaica: true,
      Miulesti: true,
      Neajlovu: true,
      "Vadu Stanchii": true,
      Ochiuri: true,
      Diaconesti: true,
      Sabiesti: true,
      Piatra: true,
      Mogosesti: true,
      "Stubeie Tisa": true,
      Ilfoveni: true,
      "Satu Nou": true,
      Ratoaia: true,
      Cetatuia: true,
      Olteni: true,
      Miculesti: true,
      "Crangurile de Sus": true,
      Bumbuia: true,
      Suvita: true,
      Voia: true,
      Gherghitesti: true,
      "Valea lui Dan": true,
      Cornatelu: true,
      Cretulesti: true,
      Dumbrava: true,
      Baraceni: true,
      Fagetu: true,
      "Cricovu Dulce": true,
      Crivatu: true,
      "Pucioasa-Sat": true,
      Matraca: true,
      Sultanu: true,
      Varfuri: true,
      "Crangurile de Jos": true,
      Livezile: true,
      "Cuza Voda": true,
      Carlanesti: true,
      Hodarasti: true,
      Mesteacan: true,
      Catanele: true,
      Serbaneasa: true,
      Sipot: true,
      Statesti: true,
      Straosti: true,
      Craciunesti: true,
      "Hanu lui Pala": true,
      "Candesti Deal": true,
      "Valea Lunga-Cricov": true,
      Crangasi: true,
      "Coada Izvorului": true,
      Geangoesti: true,
      Ulmetu: true,
      Copaceni: true,
      Costisata: true,
      Banesti: true,
      Cristeasca: true,
      "Valea Larga": true,
      Lucianca: true,
      "Patroaia Deal": true,
      "Malu Mierii": true,
      Salcioara: true,
      Blidari: true,
      Milosari: true,
      Cobiuta: true,
      "Finta Veche": true,
      Poienita: true,
      Gamanesti: true,
      Garleni: true,
      Alunisu: true,
      Mereni: true,
      Stanesti: true,
      Colanu: true,
      "Podu Cristinii": true,
      Savesti: true,
      Corni: true,
      Meisoare: true,
      Balanesti: true,
      Udresti: true,
      Bacesti: true,
      Merisoru: true,
      Vultureanca: true,
      Capsuna: true,
      "Moara din Groapa": true,
      "Dupa Deal": true,
      Tunari: true,
      Manjina: true,
      "Potlogeni-Deal": true,
      "Potlogeni Vale": true,
      Stavropolia: true,
      Dobresti: true,
      Calugareni: true,
      Helesteu: true,
      Ratesti: true,
      "Laculete-Gara": true,
      "Podu Corbencii": true,
      Chirca: true,
      "Miclosanii Mari": true,
      "Mosia Mica": true,
      Saru: true,
      Malurile: true,
      Alunis: true,
      Padureni: true,
      Feteni: true,
      Slobozia: true,
      Aninosani: true,
      Cojoiu: true,
      Dospinesti: true,
      Muscel: true,
      Barbuceanu: true,
      Dimoiu: true,
      "Frasin Vale": true,
      Varfureni: true,
      Nisipurile: true,
      Nicolaesti: true,
      "Valea Dadei": true,
      Bradatel: true,
      Stratonesti: true,
      "Valea Morii": true,
      "Moara Noua": true,
      Oreasca: true,
    },
    DJ: {
      Craiova: true,
      Bailesti: true,
      Calafat: true,
      Dabuleni: true,
      Filiasi: true,
      "Poiana Mare": true,
      Segarcea: true,
      Motatei: true,
      Sadova: true,
      Cetate: true,
      Marsani: true,
      "Galicea Mare": true,
      Desa: true,
      "Ciupercenii Noi": true,
      Leu: true,
      Barca: true,
      Calarasi: true,
      Daneti: true,
      Plenita: true,
      Ostroveni: true,
      Maglavit: true,
      Unirea: true,
      Isalnita: true,
      Rast: true,
      Bechet: true,
      Podari: true,
      "Valea Stanciului": true,
      Cerat: true,
      Goicea: true,
      Cosoveni: true,
      "Amarastii de Jos": true,
      Lipovu: true,
      "Horezu Poenari": true,
      Pielesti: true,
      Cernele: true,
      Caraula: true,
      Tuglui: true,
      Giubega: true,
      "Piscu Vechi": true,
      Giurgita: true,
      Bistret: true,
      "Apele Vii": true,
      "Ciupercenii Vechi": true,
      Urzicuta: true,
      Ghidici: true,
      Fratostita: true,
      Negoi: true,
      Celaru: true,
      Bradesti: true,
      Sarata: true,
      "Malu Mare": true,
      Castranova: true,
      Breasta: true,
      Predesti: true,
      Vartop: true,
      "Silistea Crucii": true,
      "Macesu de Sus": true,
      Teasc: true,
      Intorsura: true,
      Ghindeni: true,
      Hunia: true,
      Galiciuica: true,
      Cleanov: true,
      Gangiova: true,
      Prapor: true,
      Carcea: true,
      Rojiste: true,
      Mofleni: true,
      Perisor: true,
      Carna: true,
      Puturi: true,
      Argetoaia: true,
      Listeava: true,
      "Tunarii Vechi": true,
      Smardan: true,
      Zanoaga: true,
      Secui: true,
      "Cotofenii din Fata": true,
      Afumati: true,
      Calopar: true,
      Negoiesti: true,
      Diosti: true,
      Gighera: true,
      Scaesti: true,
      Salcia: true,
      Bratovoesti: true,
      Orodel: true,
      Bucovat: true,
      Dobrotesti: true,
      Brabeti: true,
      Nedeia: true,
      Boureni: true,
      "Piscu Sadovei": true,
      Basarabi: true,
      "Macesu de Jos": true,
      Cioroiasi: true,
      Dranic: true,
      Comosteni: true,
      Izvoare: true,
      "Castrele Traiane": true,
      "Cotofenii din Dos": true,
      Terpezita: true,
      Balta: true,
      "Piscu Nou": true,
      "Racarii de Sus": true,
      Carpen: true,
      Plesoi: true,
      "Amarastii de Sus": true,
      Radomir: true,
      Padea: true,
      Zaval: true,
      "Botosesti-Paia": true,
      Sfarcea: true,
      Goiesti: true,
      "Seaca de Camp": true,
      Catane: true,
      Ghizdavesti: true,
      Verbita: true,
      Facai: true,
      Salcuta: true,
      Badosi: true,
      Popoveni: true,
      Preajba: true,
      Dobridor: true,
      Radovan: true,
      "Simnicu de Jos": true,
      "Valea lui Patru": true,
      Campeni: true,
      Plosca: true,
      "Racarii de Jos": true,
      "Bistretu Nou": true,
      Ciocanesti: true,
      Mihaita: true,
      "Motatei Gara": true,
      Golfin: true,
      Ciutura: true,
      Palilula: true,
      Ocolna: true,
      Livezi: true,
      Ghercesti: true,
      Bralostita: true,
      "Cernelele de Sus": true,
      Varvor: true,
      Calugarei: true,
      Plopsor: true,
      Melinesti: true,
      Tatomiresti: true,
      "Catanele Noi": true,
      Braniste: true,
      Locusteni: true,
      Soreni: true,
      Sarbatoarea: true,
      Moreni: true,
      Panaghia: true,
      Tamburesti: true,
      "Marotinu de Sus": true,
      Cornu: true,
      Gubaucea: true,
      Cernatesti: true,
      Brabova: true,
      Nisipuri: true,
      Sitoaia: true,
      "Marotinu de Jos": true,
      Veleni: true,
      Zvorsca: true,
      Toceni: true,
      "Robanestii de Sus": true,
      Prunet: true,
      Mischii: true,
      Covei: true,
      "Seaca de Padure": true,
      Sopot: true,
      "Cioroiu Nou": true,
      Curmatura: true,
      Teslui: true,
      Golenti: true,
      "Preajba de Padure": true,
      Murta: true,
      Bogea: true,
      Albesti: true,
      Belcinu: true,
      "Tunarii Noi": true,
      "Georocu Mare": true,
      Caciulatesti: true,
      Murgasi: true,
      Popanzalesti: true,
      Rovine: true,
      Milesti: true,
      Tiu: true,
      Balasan: true,
      Verbicioara: true,
      "Urzica Mare": true,
      "Izvorul Rece": true,
      "Valea Fantanilor": true,
      "Lacrita Mare": true,
      Farcas: true,
      Busu: true,
      Malaesti: true,
      Mlecanesti: true,
      Amarasti: true,
      Tencanau: true,
      Almaj: true,
      Golumbu: true,
      Viisoara: true,
      Cornetu: true,
      Dragotesti: true,
      Bucovicior: true,
      "Bradestii Batrani": true,
      "Valea Lungului": true,
      Secu: true,
      "Rasnicu Oghian": true,
      Urdinita: true,
      Vela: true,
      "Rachita de Jos": true,
      Marza: true,
      Potmeltu: true,
      Barboi: true,
      Corlate: true,
      Gogosu: true,
      Velesti: true,
      "Domnu Tudor": true,
      Caciulatu: true,
      Schitu: true,
      Foisor: true,
      Ohaba: true,
      Soceni: true,
      Criva: true,
      Obedin: true,
      Booveni: true,
      Leordoasa: true,
      Garlesti: true,
      Izvor: true,
      Sapata: true,
      "Balta Verde": true,
      Piria: true,
      Pietroaia: true,
      Gaia: true,
      Dobresti: true,
      Urieni: true,
      Seculesti: true,
      Benesti: true,
      Bodaiesti: true,
      "Gura Racului": true,
      Gogosita: true,
      Grecesti: true,
      Bascov: true,
      Racovita: true,
      "Robanestii de Jos": true,
      Milovan: true,
      "Balota de Sus": true,
      Floresti: true,
      "Gura Vaii": true,
      Gabru: true,
      Carligei: true,
      Belot: true,
      Comanicea: true,
      Cornita: true,
      Georocel: true,
      Dudovicesti: true,
      "Balota de Jos": true,
      Moflesti: true,
      Lesile: true,
      Beharca: true,
      "Leamna de Sus": true,
      Stefanel: true,
      Tarnava: true,
      Dobromira: true,
      Mosneni: true,
      "Smadovicioara de Secu": true,
      Gropanele: true,
      Pisculet: true,
      Ungureni: true,
      "Leamna de Jos": true,
      "Viisoara Mosneni": true,
      Ciocanele: true,
      Maracinele: true,
      "Bodaiestii de Sus": true,
      Tartal: true,
      Talpas: true,
      Urechesti: true,
      Mosna: true,
      Pometesti: true,
      Teiu: true,
      "Rachita de Sus": true,
      "Valea Muierii de Jos": true,
      Busteni: true,
      Caruia: true,
      Bulzesti: true,
      Motoci: true,
      Suharu: true,
      Dutulesti: true,
      "Lipovu de Sus": true,
      "Varvoru de Jos": true,
      Mogosesti: true,
      Buzduc: true,
      Saliste: true,
      Jiul: true,
      Dragoaia: true,
      Infratirea: true,
      Godeni: true,
      Pioresti: true,
      "Preajba de Jos": true,
      "Simnicu de Sus": true,
      Fantani: true,
      Gradistea: true,
      Rosieni: true,
      Cotu: true,
      Golumbelu: true,
      Bojoiu: true,
      "Poiana Fantanii": true,
      Spineni: true,
      Nistoi: true,
      Geblesti: true,
      Sarsca: true,
      Fantanele: true,
      Stiubei: true,
      Brandusa: true,
      Stoicesti: true,
      Popeasa: true,
      Picaturile: true,
      Vladimir: true,
      Novac: true,
      Bujor: true,
      Odoleni: true,
      Rupturile: true,
      Lazu: true,
      Uscaci: true,
      Crovna: true,
      "Lacrita Mica": true,
      Cosereni: true,
      Frasin: true,
      Malumnic: true,
      Muereni: true,
      Calinesti: true,
      Prejoi: true,
      Cernat: true,
      Romanesti: true,
      Deleni: true,
      Putinei: true,
      "Rasnicu Batran": true,
      Floran: true,
      Berbesu: true,
      Adancata: true,
      Luncsoru: true,
      Baranu: true,
      Sumandra: true,
      Fratila: true,
      "Plopu Amarasti": true,
      Almajel: true,
      Bazdana: true,
      Tandara: true,
      Cetatuia: true,
      Meteu: true,
      Iordachesti: true,
      Piscani: true,
      "Teascu din Deal": true,
      "Ungurenii Mici": true,
      Muierusu: true,
      Pereni: true,
      Bobeanu: true,
      Gogosesti: true,
      Faget: true,
      Plostina: true,
      Filaret: true,
      Jieni: true,
      Ursoaia: true,
      Malaica: true,
      Busuletu: true,
      "Piscu Lung": true,
      Seglet: true,
      Poienile: true,
      Langa: true,
      Desnatui: true,
      Popesti: true,
      Carstovani: true,
      Gruita: true,
      Voita: true,
      "Valea Mare": true,
      "Predestii Mici": true,
      Bucicani: true,
      Zlatari: true,
      Caraiman: true,
      Chiasu: true,
      Italieni: true,
    },
    GL: {
      Galati: true,
      Tecuci: true,
      Liesti: true,
      Pechea: true,
      Matca: true,
      Cudalbi: true,
      "Targu Bujor": true,
      Corod: true,
      "Tudor Vladimirescu": true,
      Ivesti: true,
      Independenta: true,
      Bucesti: true,
      Barcea: true,
      Piscu: true,
      Tulucesti: true,
      Beresti: true,
      Munteni: true,
      Toflea: true,
      Fartanesti: true,
      Frumusita: true,
      "Slobozia Conachi": true,
      Movileni: true,
      Grivita: true,
      Chiraftei: true,
      "Cuza Voda": true,
      Cuca: true,
      Draganesti: true,
      "Malu Alb": true,
      Baleni: true,
      Sivita: true,
      Schela: true,
      "Umbraresti-Deal": true,
      "Hanu Conachi": true,
      Branistea: true,
      Mastacani: true,
      "Costache Negri": true,
      "Valea Marului": true,
      Foltesti: true,
      Tepu: true,
      Talpigi: true,
      Gohor: true,
      Brahasesti: true,
      Smulti: true,
      Rediu: true,
      Fantanele: true,
      Viile: true,
      Umbraresti: true,
      Vanatori: true,
      Cavadinesti: true,
      Baneasa: true,
      Sendreni: true,
      Negrilesti: true,
      "Odaia Manolache": true,
      Draguseni: true,
      Suhurlui: true,
      Suceveni: true,
      "Furcenii Noi": true,
      Radesti: true,
      Poiana: true,
      "Furcenii Vechi": true,
      Moscu: true,
      "Namoloasa Sat": true,
      Oancea: true,
      Smardan: true,
      Ungureni: true,
      Cosmesti: true,
      Jorasti: true,
      "Cosmestii-Vale": true,
      Vladesti: true,
      Ghidigeni: true,
      Varlezi: true,
      Blanzi: true,
      Namoloasa: true,
      Ciorasti: true,
      Podoleni: true,
      Nicoresti: true,
      Balasesti: true,
      Balintesti: true,
      Cismele: true,
      Ganesti: true,
      Mandresti: true,
      Craiesti: true,
      Buciumeni: true,
      Scanteiesti: true,
      Branesti: true,
      Izvoarele: true,
      Stoicani: true,
      Baltareti: true,
      "Slobozia Blaneasa": true,
      Corni: true,
      Tamaoani: true,
      Salcia: true,
      Ijdileni: true,
      Balabanesti: true,
      Fundeanu: true,
      Nartesti: true,
      Maciseni: true,
      Tiganesti: true,
      Certesti: true,
      "Fundenii Noi": true,
      Tatarca: true,
      Slivna: true,
      "Serbestii Vechi": true,
      Adam: true,
      "Vasile Alecsandri": true,
      Cotoroaia: true,
      Gefu: true,
      Plesa: true,
      Fantani: true,
      Carlomanesti: true,
      Carapcesti: true,
      Ionasesti: true,
      "Beresti-Meria": true,
      Torcesti: true,
      Condrea: true,
      "Slobozia Corni": true,
      Rogojeni: true,
      Vadeni: true,
      Lungesti: true,
      Roscani: true,
      Calmatui: true,
      Lungoci: true,
      Negrea: true,
      Plevna: true,
      "Mihail Kogalniceanu": true,
      Bratulesti: true,
      "Ciurestii Noi": true,
      Bursucani: true,
      Visina: true,
      Costi: true,
      "Gara Berheci": true,
      "Tecucelu Sec": true,
      Cauiesti: true,
      Hantesti: true,
      Ciuresti: true,
      Urlesti: true,
      Vames: true,
      "Priponestii de Jos": true,
      Priponesti: true,
      Aldesti: true,
      Traian: true,
      Dobrinesti: true,
      Taplau: true,
      Nicopole: true,
      Vizuresti: true,
      Zarnesti: true,
      Ireasca: true,
      "Coasta Lupei": true,
      "Piscu Corbului": true,
      Silistea: true,
      Ghinghesti: true,
      Frunzeasca: true,
      Comanesti: true,
      Stietesti: true,
      Cruceanu: true,
      Garbovat: true,
      Lunca: true,
      Sarbi: true,
      Pupezeni: true,
      Cositeni: true,
      Puricani: true,
      Posta: true,
      "Tepu de Sus": true,
      Malureni: true,
      Prodanesti: true,
      "Satu Nou": true,
      "Slobozia Oancea": true,
      Saseni: true,
      Corcioveni: true,
      Sipote: true,
      Grozavesti: true,
      Zimbru: true,
      "Gara Ghidigeni": true,
      Onciu: true,
      Lupele: true,
      "Gura Garbovatului": true,
      Crangeni: true,
      Lozova: true,
      Fundeni: true,
      Hustiu: true,
    },
    GR: {
      Giurgiu: true,
      "Bolintin-Vale": true,
      Hotarele: true,
      Varasti: true,
      Floresti: true,
      Mihailesti: true,
      "Bolintin-Deal": true,
      Ogrezeni: true,
      Prundu: true,
      Cartojani: true,
      Baneasa: true,
      "Valea Dragului": true,
      Vedea: true,
      "Adunatii-Copaceni": true,
      Malu: true,
      "Malu Spart": true,
      Marsa: true,
      Fratesti: true,
      Slobozia: true,
      "Mihai Bravu": true,
      Gostinu: true,
      Palanca: true,
      Ghimpati: true,
      Colibasi: true,
      Trestieni: true,
      Sabareni: true,
      "Roata de Jos": true,
      Cosoba: true,
      Daia: true,
      "Darasti-Vlasca": true,
      Stoenesti: true,
      Greaca: true,
      Oinacu: true,
      Buturugeni: true,
      Dobreni: true,
      Joita: true,
      Gaiseni: true,
      Comana: true,
      Cascioarele: true,
      Herasti: true,
      Hulubesti: true,
      "Vlad Tepes": true,
      "Mihai Voda": true,
      Gostinari: true,
      Branistea: true,
      Remus: true,
      Toporu: true,
      Chiriacu: true,
      Clejani: true,
      Isvoarele: true,
      Naipu: true,
      Rasuceni: true,
      Singureni: true,
      Izvoarele: true,
      Stanesti: true,
      Gaujani: true,
      "Crevedia Mare": true,
      Putineiu: true,
      Gradistea: true,
      Uzunu: true,
      Padureni: true,
      Campurelu: true,
      Calugareni: true,
      "Vanatorii Mari": true,
      Pietrele: true,
      Cucuruzu: true,
      Sadina: true,
      "Letca Veche": true,
      Milcovatu: true,
      Bacu: true,
      Novaci: true,
      Tantava: true,
      Iepuresti: true,
      Gradinari: true,
      Popesti: true,
      Copaciu: true,
      Branistari: true,
      "Letca Noua": true,
      Dealu: true,
      Bulbucata: true,
      Pietrisu: true,
      Bucsani: true,
      Ulmi: true,
      Falastoaca: true,
      Puieni: true,
      Zorile: true,
      Gogosari: true,
      Plopsoru: true,
      Cetatea: true,
      Icoana: true,
      Vieru: true,
      "Crevedia Mica": true,
      Hobaia: true,
      Budeni: true,
      Tomulesti: true,
      Izvoru: true,
      Cranguri: true,
      Poenari: true,
      Crivina: true,
      Stejaru: true,
      "Vanatorii Mici": true,
      Mironesti: true,
      "Vadu Lat": true,
      Camineasca: true,
      Carpenisu: true,
      "Valea Bujorului": true,
      "Poiana lui Stanga": true,
      Ghizdaru: true,
      Frasinu: true,
      Vlasin: true,
      Bila: true,
      Varlaam: true,
      Podisor: true,
      Draganeasca: true,
      Suseni: true,
      "Valea Plopilor": true,
      Goleasca: true,
      "Podu Doamnei": true,
      Neajlov: true,
      Gorneni: true,
      Gaiseanca: true,
      Oncesti: true,
      Mogosesti: true,
      "Roata Mica": true,
      Hodivoaia: true,
      Ghionea: true,
      Balanu: true,
      Mosteni: true,
      Posta: true,
      "Putu Greci": true,
      Teisori: true,
      Cupele: true,
      "Sfantu Gheorghe": true,
      Uiesti: true,
      Draganescu: true,
      "Crucea de Piatra": true,
      Schitu: true,
      Zboiu: true,
      Obedeni: true,
      Corbeanca: true,
      "Radu Voda": true,
      Sterea: true,
      "Dimitrie Cantemir": true,
      Teiusu: true,
      Ianculesti: true,
      Stalpu: true,
      Cetatuia: true,
      Milosesti: true,
      "Podu Popa Nae": true,
      "Petru Rares": true,
      Ralesti: true,
      Mirau: true,
      Zadariciu: true,
      Facau: true,
      Draghiceanu: true,
      Valcele: true,
      Priboiu: true,
      Anghelesti: true,
      "Valter Maracineanu": true,
      Carapancea: true,
      Banesti: true,
      "Satu Nou": true,
      Chirculesti: true,
      Coteni: true,
      "Podu Ilfovatului": true,
      Comasca: true,
    },
    GJ: {
      "Targu Jiu": true,
      Motru: true,
      Rovinari: true,
      "Bumbesti-Jiu": true,
      Matasari: true,
      Ticleni: true,
      "Targu Carbunesti": true,
      Turceni: true,
      "Baia de Fier": true,
      Novaci: true,
      Floresti: true,
      Polovragi: true,
      Balteni: true,
      Tantareni: true,
      Ceauru: true,
      "Pesteana Jiu": true,
      Tismana: true,
      Balesti: true,
      Urdari: true,
      Bengesti: true,
      Albeni: true,
      Poiana: true,
      "Stramba Jiu": true,
      "Rosia de Amaradia": true,
      Pociovalistea: true,
      Stoina: true,
      Turburea: true,
      Lelesti: true,
      Aninoasa: true,
      Sohodol: true,
      Cocoreni: true,
      Dobrita: true,
      Dragotesti: true,
      Balta: true,
      "Pesteana de Jos": true,
      Ionesti: true,
      Andreesti: true,
      Saulesti: true,
      Telesti: true,
      Godinesti: true,
      Pestisani: true,
      Covrigi: true,
      Bustuchin: true,
      Plostina: true,
      Runcu: true,
      Closani: true,
      Pocruia: true,
      Pojogeni: true,
      Musetesti: true,
      Costesti: true,
      Carpinis: true,
      Turcinesti: true,
      Sterpoaia: true,
      Vladimir: true,
      Viersani: true,
      Borascu: true,
      Vladuleni: true,
      Balcesti: true,
      Piscoiu: true,
      "Valea Mare": true,
      "Bumbesti-Pitic": true,
      "Motru Sec": true,
      Moi: true,
      Piscuri: true,
      Valeni: true,
      Dragutesti: true,
      "Capu Dealului": true,
      Carbesti: true,
      Lupoaia: true,
      "Iasi-Gorj": true,
      "Pistestii din Deal": true,
      Carligei: true,
      Fantanele: true,
      Frasin: true,
      Cernadia: true,
      Urechesti: true,
      "Poiana Seciuri": true,
      Ciocadia: true,
      Vagiulesti: true,
      Bucsana: true,
      Olari: true,
      Tetila: true,
      "Carbunesti-Sat": true,
      Totea: true,
      Valea: true,
      Lihulesti: true,
      Corobai: true,
      Rosiuta: true,
      Costeni: true,
      Seciurile: true,
      Stejari: true,
      Crasna: true,
      Radosi: true,
      Slavuta: true,
      Ursoaia: true,
      Plopsoru: true,
      Pades: true,
      "Rosia Jiu": true,
      Curpen: true,
      Sardanesti: true,
      "Targu Logresti": true,
      Bobu: true,
      Poienari: true,
      Calugareni: true,
      Murgesti: true,
      Balanesti: true,
      Obarsia: true,
      Sipotu: true,
      Dragoeni: true,
      Groserea: true,
      Curtisoara: true,
      Maiag: true,
      Slobozia: true,
      Gornacel: true,
      Izvoarele: true,
      Budieni: true,
      Bradiceni: true,
      Somanesti: true,
      Francesti: true,
      Licurici: true,
      Talvesti: true,
      Artanu: true,
      Tamasesti: true,
      Buduhala: true,
      Celei: true,
      Jupanesti: true,
      Negreni: true,
      Stanesti: true,
      Bibesti: true,
      Calugareasa: true,
      Miluta: true,
      Schela: true,
      Sambotin: true,
      Slivilesti: true,
      Dumbraveni: true,
      Negomir: true,
      Samarinesti: true,
      Ruget: true,
      Bulbuceni: true,
      Miculesti: true,
      Calaparu: true,
      Glodeni: true,
      Talpasesti: true,
      Balacesti: true,
      Sarbesti: true,
      Sacelu: true,
      Iliesti: true,
      Scoarta: true,
      Rugi: true,
      Hotaroasa: true,
      Stramtu: true,
      Barsesti: true,
      "Preajba Mare": true,
      Hirisesti: true,
      Barbatesti: true,
      Cruset: true,
      Cocorova: true,
      "Calnicu de Sus": true,
      Romanesti: true,
      Alimpesti: true,
      Stefanesti: true,
      Pinoasa: true,
      Dragoiesti: true,
      Racovita: true,
      Horasti: true,
      Baltisoara: true,
      "Valea Desului": true,
      Balosani: true,
      "Aninisu din Vale": true,
      Borosteni: true,
      Bradet: true,
      "Blahnita de Sus": true,
      Zorlesti: true,
      Glogova: true,
      Hurezani: true,
      Iezureni: true,
      Trestioara: true,
      Magheresti: true,
      "Mentii din Dos": true,
      Olteanu: true,
      "Valea Pojarului": true,
      Branesti: true,
      Runcurel: true,
      Rasova: true,
      Bolbocesti: true,
      Radinesti: true,
      Capreni: true,
      Cartiu: true,
      Gureni: true,
      Arcani: true,
      "Valea Viei": true,
      Gornovita: true,
      Prigoria: true,
      Vacarea: true,
      Croici: true,
      "Ohaba Jiu": true,
      Copacioasa: true,
      "Crasna din Deal": true,
      Petresti: true,
      Suseni: true,
      Ceplea: true,
      Insuratei: true,
      Paisani: true,
      Parau: true,
      Plesa: true,
      "Farcasesti Mosneni": true,
      Dambova: true,
      "Valea cu Apa": true,
      Garbovu: true,
      Calnic: true,
      Tehomir: true,
      Frunza: true,
      Buzesti: true,
      Maru: true,
      Halangesti: true,
      Bercesti: true,
      Cojmanesti: true,
      "Valea Perilor": true,
      Murgilesti: true,
      Sura: true,
      Valuta: true,
      Stancesti: true,
      Busuioci: true,
      Picu: true,
      Racoti: true,
      "Valea Manastirii": true,
      Barza: true,
      Floresteni: true,
      Negoiesti: true,
      Bolboasa: true,
      Topesti: true,
      Ciuperceni: true,
      "Urda de Sus": true,
      "Parau de Pripor": true,
      Rapa: true,
      Spahii: true,
      Sitesti: true,
      Stolojani: true,
      "Apa Neagra": true,
      Isvarna: true,
      Cornesti: true,
      Danciulesti: true,
      Orzesti: true,
      Timiseni: true,
      Socu: true,
      Iormanesti: true,
      Bibulesti: true,
      Lazaresti: true,
      Seaca: true,
      Vaieni: true,
      Pojaru: true,
      Vart: true,
      "Parau Boia": true,
      Condeiesti: true,
      Bucureasa: true,
      Valcele: true,
      Ciorari: true,
      Ursati: true,
      Poienita: true,
      "Voitestii de Vale": true,
      Vartopu: true,
      Dolcesti: true,
      Bacesti: true,
      Mierea: true,
      Corsoru: true,
      Danesti: true,
      Fratesti: true,
      Cornetu: true,
      Catunele: true,
      Musculesti: true,
      Purcaru: true,
      Frumusei: true,
      Gilortu: true,
      Carciu: true,
      Nucetu: true,
      Rogojel: true,
      Coltesti: true,
      Vanata: true,
      Sasa: true,
      Galcesti: true,
      "Stramba Vulcan": true,
      Dobrana: true,
      Sanatesti: true,
      Siacu: true,
      Berlesti: true,
      Grui: true,
      Bratuia: true,
      Farcasesti: true,
      "Gura Susitei": true,
      Vidin: true,
      "Ciupercenii de Oltet": true,
      Pegeni: true,
      "Urda de Jos": true,
      Bolbosi: true,
      Scrada: true,
      Bobaia: true,
      Cojani: true,
      Paltinu: true,
      Lazuri: true,
      Popesti: true,
      "Parau Viu": true,
      Jiltu: true,
      "Valea Motrului": true,
      "Satu Nou": true,
      Ohaba: true,
      Cretesti: true,
      Campofeni: true,
      Hobita: true,
      "Logresti Mosteni": true,
      "Pesteana Vulcan": true,
      Rachiti: true,
      Cetatea: true,
      Nistoresti: true,
      Mirosloveni: true,
      Chiciora: true,
      Haiesti: true,
      Plopu: true,
      "Dealu Pomilor": true,
      Bratesti: true,
      Deleni: true,
      Ungureni: true,
      "Voitestii din Deal": true,
      "Parau de Vale": true,
      "Aninisu din Deal": true,
      Bircii: true,
      Alexeni: true,
      Boca: true,
      Stroiesti: true,
      "Totea de Hurezani": true,
      Miericeaua: true,
      Toiaga: true,
      Arsuri: true,
      Mogosani: true,
      Scorusu: true,
      Sitoaia: true,
      Baniu: true,
      Botorogi: true,
      Cursaru: true,
      Prunesti: true,
      Calcesti: true,
      "Stancesti Larga": true,
      Galesoaia: true,
      Bohorel: true,
      Trocani: true,
      Stiucani: true,
      Horezu: true,
      Slamnesti: true,
      Merfulesti: true,
      Tarculesti: true,
      Colibasi: true,
      Calesti: true,
      Miclosu: true,
      Steic: true,
      Leurda: true,
      Zaicoiu: true,
      "Popesti Stejari": true,
      Curteana: true,
      Seuca: true,
      Barzeiu: true,
      Gavanesti: true,
      Raci: true,
      Valari: true,
      Brosteni: true,
      Polata: true,
      Barcaciu: true,
      Camuiesti: true,
      Pieptani: true,
      Clesnesti: true,
      Orzu: true,
      "Dealu Viilor": true,
      "Gura Menti": true,
      "Valea Bisericii": true,
      Bradetel: true,
      "Cerna-Sat": true,
      "Ceratu de Copacioasa": true,
      Rasovita: true,
      Badesti: true,
      Macesu: true,
      Lintea: true,
      Igirosu: true,
      Scurtu: true,
      Burlani: true,
      Brebenei: true,
      Marinesti: true,
      "Valea Poienii": true,
      Obreja: true,
      Bazavani: true,
      Larga: true,
      Alunis: true,
      Becheni: true,
      Arjoci: true,
      Hodoreasca: true,
      Vaidei: true,
      Duculesti: true,
      Tirioi: true,
      Petrachei: true,
      Stejaru: true,
      Namete: true,
      Voinigesti: true,
      Lupoita: true,
      Ratez: true,
      "Blahnita de Jos": true,
      Motorgi: true,
      Parvulesti: true,
      Balani: true,
      "Valea Racilor": true,
      Mielusei: true,
      Didilesti: true,
      Bojinu: true,
      Arpadia: true,
      Canepesti: true,
      Boboiesti: true,
      "Campu Mare": true,
      Valceaua: true,
      Ulmet: true,
      Gamani: true,
      "Barzeiu de Gilort": true,
      Mazaroi: true,
      Priporu: true,
      Cionti: true,
      "Brostenii de Sus": true,
      Arseni: true,
      Blidari: true,
      "Dealu Viei": true,
      Doseni: true,
      Chiliu: true,
      "Dealu Leului": true,
      "Valea Mica": true,
      "Dealu Spirei": true,
      Zorzila: true,
      Pajistele: true,
      Rogojeni: true,
      Jeristea: true,
      Boia: true,
      Stejerei: true,
    },
    HR: {
      "Miercurea Ciuc": true,
      "Odorheiu Secuiesc": true,
      Gheorgheni: true,
      Toplita: true,
      Balan: true,
      "Cristuru Secuiesc": true,
      Vlahita: true,
      Sandominic: true,
      Remetea: true,
      Ditrau: true,
      Joseni: true,
      Corund: true,
      Ciumani: true,
      Zetea: true,
      Praid: true,
      Lueta: true,
      Lazarea: true,
      Tulghes: true,
      Suseni: true,
      Borsec: true,
      Siculeni: true,
      Tomesti: true,
      Ciceu: true,
      Sancraieni: true,
      Sansimion: true,
      Danesti: true,
      Bilbor: true,
      Madaras: true,
      "Valea Rece": true,
      Capalnita: true,
      Santimbru: true,
      Vale: true,
      "Satu Mare": true,
      Galautas: true,
      Ciucsangeorgiu: true,
      "Baile Tusnad": true,
      Ineu: true,
      Lupeni: true,
      Dealu: true,
      Frumoasa: true,
      "Ocna de Jos": true,
      Hodosa: true,
      Varsag: true,
      Meresti: true,
      Subcetate: true,
      "Valea Stramba": true,
      "Ocna de Sus": true,
      Cozmeni: true,
      Bancu: true,
      Sanmartin: true,
      Atid: true,
      Voslabeni: true,
      "Porumbenii Mari": true,
      "Lunca de Jos": true,
      Racu: true,
      Nicolesti: true,
      Ciucani: true,
      Filias: true,
      Eliseni: true,
      Carta: true,
      Sancrai: true,
      Simonesti: true,
      Corbu: true,
      Misentea: true,
      Mugeni: true,
      "Tusnadu Nou": true,
      Zencani: true,
      Cetatuia: true,
      Calimanel: true,
      Mihaileni: true,
      Bradesti: true,
      Tusnad: true,
      "Casinu Nou": true,
      "Plaiesii de Sus": true,
      Darjiu: true,
      Chileni: true,
      Avramesti: true,
      Borzont: true,
      "Izvoru Muresului": true,
      Lutita: true,
      Bodogaia: true,
      Sarmas: true,
      Magherus: true,
      Moglanesti: true,
      "Sub Cetate": true,
      Morareni: true,
      Criseni: true,
      Armaseni: true,
      "Lunca de Sus": true,
      Runc: true,
      Barzava: true,
      Jolotca: true,
      Tarnovita: true,
      "Izvorul Trotusului": true,
      Nadejdea: true,
      Ruganesti: true,
      Betesti: true,
      Fundoaia: true,
      "Paltinis-Ciuc": true,
      Goagiu: true,
      Bisericani: true,
      Secuieni: true,
      Lazaresti: true,
      "Valea Ugra": true,
      Dobeni: true,
      Martinis: true,
      Vacaresti: true,
      Delnita: true,
      "Pauleni-Ciuc": true,
      Livezi: true,
      Ocland: true,
      Platonesti: true,
      "Capu Corbului": true,
      Rachitis: true,
      Feliceni: true,
      Craciunel: true,
      "Soimusu Mic": true,
      Soimeni: true,
      Sanpaul: true,
      Cechesti: true,
      "Plaiesii de Jos": true,
      Siclod: true,
      Mujna: true,
      "Porumbenii Mici": true,
      Imper: true,
      "Valea lui Pavel": true,
      "Satu Nou": true,
      Iacobeni: true,
      Ulcani: true,
      "Valea Boros": true,
      Taureni: true,
      Cusmed: true,
      Paltinis: true,
      Filpea: true,
      "Soimusu Mare": true,
      Forteni: true,
      Cobatesti: true,
      "Fantana Brazilor": true,
      "Galautas-Parau": true,
      Fitod: true,
      "Valea Garbea": true,
      Aldea: true,
      Comiat: true,
      Izvoare: true,
      Calnaci: true,
      Vidacut: true,
      Atia: true,
      Ulies: true,
      "Armasenii Noi": true,
      "Harghita-Bai": true,
      Oraseni: true,
      Beta: true,
      Eghersec: true,
      Petecu: true,
      Luncani: true,
      "Valea Capelei": true,
      Polonita: true,
      Taietura: true,
      Daia: true,
      Hoghia: true,
      "Minele Lueta": true,
      Firtanus: true,
      "Poiana Fagului": true,
      Bulgareni: true,
      Leliceni: true,
      Potiond: true,
      Teleac: true,
      Valeni: true,
      Badeni: true,
      Baratcos: true,
      "Valea lui Antaloc": true,
      Vagani: true,
      "Valea Intunecoasa": true,
      Pauleni: true,
      Vrabia: true,
      Inlaceni: true,
      Comanesti: true,
      Oteni: true,
      Firtusu: true,
      Petreni: true,
      Cehetel: true,
      Tarcesti: true,
      Tibod: true,
      Bentid: true,
      "Medisoru Mare": true,
      Dejutiu: true,
      Ghipes: true,
      Hagota: true,
      Rares: true,
      Cireseni: true,
      Ghidut: true,
      Recea: true,
      "Cadaciu Mare": true,
      "Puntea Lupului": true,
      Andreeni: true,
      Matiseni: true,
      Sicasau: true,
      Becas: true,
      Sacel: true,
      Chinusu: true,
      Fancel: true,
      Ciaracio: true,
      Alunis: true,
      Ciba: true,
      Fagetel: true,
      "Baile Chirui": true,
      Pintic: true,
      Nuteni: true,
      Turdeni: true,
      Tamasu: true,
      Toleseni: true,
      "Lacu Rosu": true,
      "Valea Rotunda": true,
      "Satu Mic": true,
      Arvateni: true,
      "Cadaciu Mic": true,
      Nicoleni: true,
      Liban: true,
      Secu: true,
      Calugareni: true,
      "Medisoru Mic": true,
      "Baile Homorod": true,
      Ighiu: true,
      Cotormani: true,
      "Poiana Tarnavei": true,
      "Laz-Soimus": true,
      Sineu: true,
      "Chedia Mica": true,
      Calonda: true,
      Duda: true,
      Plopis: true,
      Iasu: true,
      Alexandrita: true,
      "Dealu Armanului": true,
      Desag: true,
      Vasileni: true,
      "Laz-Firtanus": true,
      Sancel: true,
      Ciobanis: true,
      Locodeni: true,
      "Chedia Mare": true,
      Uilac: true,
      Carpitus: true,
      Zapodea: true,
      Obranesti: true,
      Vargatac: true,
      Covacipeter: true,
      Senetea: true,
      Preluca: true,
      "Valea Uzului": true,
      Visafolio: true,
      Bucin: true,
      Ghiurche: true,
      Hosasau: true,
      "Jigodin-Bai": true,
      Martonca: true,
      "Santimbru-Bai": true,
      Sasveres: true,
      Tengheler: true,
    },
    HD: {
      Hunedoara: true,
      Deva: true,
      Petrosani: true,
      Lupeni: true,
      Vulcan: true,
      Petrila: true,
      Orastie: true,
      Brad: true,
      Simeria: true,
      Uricani: true,
      Calan: true,
      Hateg: true,
      Aninoasa: true,
      Geoagiu: true,
      Ghelari: true,
      Barza: true,
      "Jiu-Paroseni": true,
      Iscroni: true,
      Ilia: true,
      "Certeju de Sus": true,
      "Teliucu Inferior": true,
      Dobra: true,
      Cristur: true,
      Baru: true,
      Zdrapti: true,
      "Pestisu Mare": true,
      Brazi: true,
      Romos: true,
      Castau: true,
      Pricaz: true,
      Hartagani: true,
      Soimus: true,
      Criscior: true,
      "Santamaria-Orlea": true,
      "Aurel Vlaicu": true,
      "Baia de Cris": true,
      "Valea Bradului": true,
      Petros: true,
      Valisoara: true,
      Clopotiva: true,
      Pui: true,
      "Rapoltu Mare": true,
      "Luncoiu de Jos": true,
      Bosorod: true,
      Tebea: true,
      Sibisel: true,
      Banita: true,
      Livadia: true,
      Mintia: true,
      Vetel: true,
      Taratel: true,
      "Cincis-Cerna": true,
      Bucuresci: true,
      Jiet: true,
      Zam: true,
      Vaidei: true,
      Sarmizegetusa: true,
      "Valea de Brazi": true,
      Branisca: true,
      Rachitova: true,
      Tampa: true,
      Mesteacan: true,
      Ormindea: true,
      "Salasu de Sus": true,
      Romosel: true,
      Santandrei: true,
      "Bretea Muresana": true,
      "Tarnava de Cris": true,
      Chitid: true,
      "Vata de Jos": true,
      "Geoagiu-Bai": true,
      Bacia: true,
      Beriu: true,
      Cimpa: true,
      Harau: true,
      Serel: true,
      Ribita: true,
      Batiz: true,
      Streisangeorgiu: true,
      Hondol: true,
      "Campu lui Neag": true,
      Mihaileni: true,
      Racastia: true,
      Subcetate: true,
      "Orastioara de Sus": true,
      Carnesti: true,
      Crisan: true,
      Risculita: true,
      Santuhalm: true,
      "Lapugiu de Sus": true,
      Pesteana: true,
      "Cainelu de Sus": true,
      Banpotoc: true,
      Boz: true,
      Costesti: true,
      Sesuri: true,
      Barsau: true,
      Bobalna: true,
      Fizesti: true,
      "Luncoiu de Sus": true,
      Stanija: true,
      Petreni: true,
      Sacel: true,
      Turdas: true,
      Paclisa: true,
      Sarbi: true,
      Lesnic: true,
      Galati: true,
      Gelmar: true,
      Curechiu: true,
      "Valcelele Bune": true,
      "Silvasu de Jos": true,
      Lapusnic: true,
      Visca: true,
      Tarnita: true,
      "Barastii Hategului": true,
      Baita: true,
      Varmaga: true,
      Homorod: true,
      Bos: true,
      Ponor: true,
      "Ocolisu Mic": true,
      Ciopeia: true,
      Roscani: true,
      Hasdau: true,
      Gurasada: true,
      Densus: true,
      Blajeni: true,
      "Silvasu de Sus": true,
      "Barcea Mare": true,
      Nucsoara: true,
      Totesti: true,
      Paros: true,
      "Vata de Sus": true,
      Pravaleni: true,
      Ostrov: true,
      Maceu: true,
      Chiscadaga: true,
      "Rau de Mori": true,
      Federi: true,
      Merisor: true,
      Uroi: true,
      "Simeria Veche": true,
      Bucium: true,
      Trestia: true,
      "Campuri-Surduc": true,
      Strei: true,
      Hasdat: true,
      Reea: true,
      "Orastioara de Jos": true,
      Bacea: true,
      Ociu: true,
      Balomir: true,
      Chimindia: true,
      Lunca: true,
      Podele: true,
      Grid: true,
      Ciungani: true,
      Balata: true,
      Balsa: true,
      "Nadastia de Sus": true,
      Dupapiatra: true,
      Gantaga: true,
      Renghet: true,
      "Ohaba-Ponor": true,
      Pojoga: true,
      Meria: true,
      "Muncelu Mic": true,
      Nojag: true,
      Pestenita: true,
      Cris: true,
      "Valea Sangeorgiului": true,
      "Lunca Cernii de Sus": true,
      Birtin: true,
      "Ludestii de Jos": true,
      Sulighete: true,
      Negoiu: true,
      Saliste: true,
      Boholt: true,
      Rusor: true,
      Boita: true,
      Valioara: true,
      "Dancu Mare": true,
      Stejarel: true,
      Steia: true,
      "Teliucu Superior": true,
      "Dumbrava de Jos": true,
      Mihaiesti: true,
      "Buces-Vulcan": true,
      "Salasu de Jos": true,
      Basarabasa: true,
      Brotuna: true,
      Fornadia: true,
      "Nadastia de Jos": true,
      Baiesti: true,
      Risca: true,
      Craciunesti: true,
      Uric: true,
      Grohotele: true,
      Nalatvad: true,
      Tustea: true,
      Sanpetru: true,
      Prihodiste: true,
      Plopi: true,
      "Bretea Romana": true,
      Hatagel: true,
      Stei: true,
      "Blajeni-Vulcan": true,
      "Dalja Mare": true,
      Slatinioara: true,
      "General Berthelot": true,
      Ocisor: true,
      Saulesti: true,
      "Valea Lupului": true,
      "Dealu Mare": true,
      Braznic: true,
      Coroiesti: true,
      Carastau: true,
      "Valea Daljii": true,
      Manerau: true,
      "Bretea Streiului": true,
      Tarsa: true,
      Cazanesti: true,
      Gothatea: true,
      Obarsa: true,
      Fintoag: true,
      "Ohaba de Sub Piatra": true,
      Valcele: true,
      Rapoltel: true,
      "Ocolisu Mare": true,
      Bozes: true,
      Spini: true,
      "Valea Poienii": true,
      Jeledinti: true,
      Ruda: true,
      Salistioara: true,
      Vorta: true,
      Pischinti: true,
      Rusi: true,
      "Cernisoara Florese": true,
      Bejan: true,
      Rovina: true,
      Farcadin: true,
      Paulis: true,
      Dabaca: true,
      Glodghilesti: true,
      Batalar: true,
      Godinesti: true,
      Sacaramb: true,
      Tomesti: true,
      Paucinesti: true,
      "Ciula Mare": true,
      "Gradistea de Munte": true,
      Grosuri: true,
      "Ruda-Brad": true,
      Sacamas: true,
      Tarnava: true,
      Buces: true,
      Nandru: true,
      Plai: true,
      Sancrai: true,
      "Lunca Cernii de Jos": true,
      Zeicani: true,
      "Barcea Mica": true,
      "Rau Alb": true,
      "Rau Barbat": true,
      "Poiana Rachitelii": true,
      Rascoala: true,
      Suseni: true,
      Toplita: true,
      Teiu: true,
      "Almas-Saliste": true,
      "Ciula Mica": true,
      Unciuc: true,
      Carpinis: true,
      Fizes: true,
      Salciva: true,
      "Bucium-Orlea": true,
      "Dealu Babii": true,
      Martinesti: true,
      Popesti: true,
      Boiu: true,
      Panc: true,
      Lasau: true,
      Lelese: true,
      Tatarasti: true,
      Barbura: true,
      "Santamaria de Piatra": true,
      Cozia: true,
      Josani: true,
      Ohaba: true,
      "Dalja Mica": true,
      Hobita: true,
      Ostrovel: true,
      Folt: true,
      Ret: true,
      "Strei-Sacel": true,
      Covragiu: true,
      Sereca: true,
      "Tatarastii de Cris": true,
      Livada: true,
      Voia: true,
      Burjuc: true,
      Tisa: true,
      "Runcu Mare": true,
      "Valea Lunga": true,
      "Poienita Voinii": true,
      "Almasu Sec": true,
      Breazova: true,
      Cucuis: true,
      Tiulesti: true,
      "Boiu de Sus": true,
      "Hobita-Gradiste": true,
      Cerisor: true,
      Dobrot: true,
      "Magura-Toplita": true,
      Bradatel: true,
      Govajdia: true,
      "Pestisu Mic": true,
      Salatruc: true,
      "Calanu Mic": true,
      Tarnavita: true,
      Batrana: true,
      "Rau Mic": true,
      Malaiesti: true,
      "Valea Nandrului": true,
      Crivadia: true,
      Cerbal: true,
      "Ciungu Mare": true,
      Bobaia: true,
      Izvoarele: true,
      "Dancu Mic": true,
      Poiana: true,
      Carjiti: true,
      Carmazanesti: true,
      "Lapugiu de Jos": true,
      "Campuri de Sus": true,
      "Cainelu de Jos": true,
      Radulesti: true,
      Zavoi: true,
      Cerbia: true,
      Baldovin: true,
      Ursici: true,
      Micanesti: true,
      Cigmau: true,
      Coaja: true,
      Poieni: true,
      "Dumbrava de Sus": true,
      Uibaresti: true,
      "Gura Bordului": true,
      "Certeju de Jos": true,
      Mada: true,
      Livezi: true,
      Tamasasa: true,
      Alun: true,
      Totia: true,
      "Almasu Mic de Munte": true,
      Herepeia: true,
      "Poienita Tomii": true,
      "Ohaba Streiului": true,
      Feregi: true,
      "Ohaba-Sibisel": true,
      Stancesti: true,
      Pestera: true,
      "Bocsa Mica": true,
      "Ostrovu Mic": true,
      Dudesti: true,
      Vadu: true,
      Cherghes: true,
      Stauini: true,
      "Toplita Muresului": true,
      Bujoru: true,
      Socet: true,
      Tamasesti: true,
      Bunila: true,
      Poganesti: true,
      Craguis: true,
      "Bulzestii de Jos": true,
      Leaut: true,
      Ulies: true,
      "Panc-Saliste": true,
      Paulesti: true,
      Poienita: true,
      Stoieneasa: true,
      Runcsor: true,
      Valeni: true,
      "Muncelu Mare": true,
      Techereu: true,
      Cuies: true,
      Luncani: true,
      "Almasu Mic": true,
      Cosesti: true,
      Danulesti: true,
      Archia: true,
      Gros: true,
      Turmas: true,
      "Boiu de Jos": true,
      Vica: true,
      "Bulzestii de Sus": true,
      Ribicioara: true,
      Tirici: true,
      "Valea Arsului": true,
      Almasel: true,
      Caraci: true,
      Ardeu: true,
      Luncsoara: true,
      Cioclovina: true,
      Holdea: true,
      Petresti: true,
      "Costesti-Deal": true,
      Valari: true,
      Oprisesti: true,
      Grind: true,
      Grohot: true,
      Sohodol: true,
      Dumbravita: true,
      Stretea: true,
      "Vadu Dobrii": true,
      Aranies: true,
      "Boia Barzii": true,
      Giurgesti: true,
      "Dealu Mic": true,
      Ciulpaz: true,
      Potingani: true,
      Criva: true,
      Abucea: true,
      Rapas: true,
      Dumbrava: true,
      "Stancesti-Ohaba": true,
      Ulm: true,
      Galbina: true,
      "Merisoru de Munte": true,
      Fantana: true,
      Tomnatec: true,
      Furcsoara: true,
      "Valea Babii": true,
      "Fata Rosie": true,
      Magura: true,
      "Ludestii de Sus": true,
      Rusesti: true,
      Valea: true,
      "Barastii Iliei": true,
      Bretelin: true,
      Plop: true,
      Cutin: true,
      Fagetel: true,
      Stanculesti: true,
      "Runcu Mic": true,
      Cabesti: true,
      Rachitaua: true,
      "Bocsa Mare": true,
      Braseu: true,
      Deleni: true,
      "Mermezeu-Valeni": true,
      Valceluta: true,
      Bacaia: true,
      Gialacuta: true,
      Piatra: true,
      Dumesti: true,
      Bercu: true,
      Magureni: true,
      Rosia: true,
      Goles: true,
      "Dragu-Brad": true,
      Ticera: true,
      Caoi: true,
      Bunesti: true,
      Gotesti: true,
      "Valea Mare de Cris": true,
      Bastea: true,
      "Bejan-Tarnavita": true,
      Copaci: true,
      Ciumita: true,
      Mosoru: true,
      "Curpenii Silvasului": true,
    },
    IL: {
      Slobozia: true,
      "Fetesti-Gara": true,
      Urziceni: true,
      Tandarei: true,
      Fetesti: true,
      Amara: true,
      Facaeni: true,
      Cosereni: true,
      Garbovi: true,
      Manasia: true,
      Bordusani: true,
      "Munteni-Buzau": true,
      Barbulesti: true,
      Cazanesti: true,
      Dridu: true,
      Jilavele: true,
      "Mihail Kogalniceanu": true,
      Traian: true,
      Saveni: true,
      Scanteia: true,
      "Gheorghe Doja": true,
      Grivita: true,
      Ograda: true,
      "Gheorghe Lazar": true,
      Cocora: true,
      Alexeni: true,
      Grindu: true,
      Vladeni: true,
      Movilita: true,
      Condeesti: true,
      "Fierbintii de Sus": true,
      Bucu: true,
      Movila: true,
      "Ion Roata": true,
      Adancata: true,
      Rosiori: true,
      Milosesti: true,
      Boranesti: true,
      Suditi: true,
      Vlasca: true,
      Maia: true,
      "Slobozia Noua": true,
      Axintele: true,
      "Malu Rosu": true,
      Andrasesti: true,
      Barcanesti: true,
      Ciochina: true,
      Giurgeni: true,
      Marculesti: true,
      Stelnica: true,
      Bora: true,
      Moldoveni: true,
      "Valea Macrisului": true,
      Luciu: true,
      "Fierbinti-Targ": true,
      Colelia: true,
      Sarateni: true,
      "Fierbintii de Jos": true,
      Brosteni: true,
      Cegani: true,
      Reviga: true,
      "Gura Ialomitei": true,
      Rasi: true,
      Iazu: true,
      Salcioara: true,
      Perieti: true,
      Sinesti: true,
      Smirna: true,
      Buesti: true,
      Rovine: true,
      Buliga: true,
      "Patru Frati": true,
      Brazii: true,
      Balaciu: true,
      "Valea Ciorii": true,
      Lacusteni: true,
      Platonesti: true,
      Cosambesti: true,
      Ciulnita: true,
      "Sfantu Gheorghe": true,
      Gimbasani: true,
      Dragoesti: true,
      Borduselu: true,
      Misleanu: true,
      Poiana: true,
      Butoiu: true,
      Horia: true,
      Albesti: true,
      Armasesti: true,
      Crunti: true,
      Orezu: true,
      Marsilieni: true,
      Progresu: true,
      Ciocarlia: true,
      Lilieci: true,
      Grindasi: true,
      Paltinisu: true,
      Tovarasia: true,
      Slatioarele: true,
      "Dridu-Snagov": true,
      Nicolesti: true,
      Fratilesti: true,
      Malu: true,
      Rasimnicea: true,
      Murgeanca: true,
      Orboesti: true,
      Copuzu: true,
      Maltezi: true,
      "Crasanii de Jos": true,
      "Grecii de Jos": true,
      Stejaru: true,
      Catrunesti: true,
      "Ion Ghica": true,
      "Gura Vaii": true,
      Sintesti: true,
      Fundata: true,
      "Mircea cel Batran": true,
      Cotorca: true,
      Barbatescu: true,
      Ivanesti: true,
      Nenisori: true,
      Bucsa: true,
      "Crasanii de Sus": true,
      Piersica: true,
      Dumitresti: true,
      "Bitina-Ungureni": true,
      Hagiesti: true,
      "Valea Bisericii": true,
      "Bitina-Pamanteni": true,
      "Chiroiu-Pamanteni": true,
      Movileanca: true,
      Livedea: true,
      Hagieni: true,
      Bataluri: true,
      Retezatu: true,
      "Chiroiu-Satu Nou": true,
      "Chiroiu-Ungureni": true,
      "Amara Noua": true,
      Boteni: true,
    },
    IS: {
      Iasi: true,
      Pascani: true,
      "Targu Frumos": true,
      Tomesti: true,
      Harlau: true,
      Dancu: true,
      "Podu Iloaiei": true,
      Raducaneni: true,
      Belcesti: true,
      Halaucesti: true,
      Focuri: true,
      Deleni: true,
      Cristesti: true,
      Mironeasa: true,
      "Lunca Cetatuii": true,
      Motca: true,
      Butea: true,
      Todiresti: true,
      Parcovaci: true,
      Voinesti: true,
      Gastesti: true,
      Letcani: true,
      Dobrovat: true,
      Oteleni: true,
      Lunca: true,
      Erbiceni: true,
      Maxut: true,
      Dumbravita: true,
      Bivolari: true,
      Heci: true,
      "Muncelu de Sus": true,
      Comarna: true,
      "Coarnele Caprei": true,
      Topile: true,
      Mogosesti: true,
      "Glodenii Gandului": true,
      Cozmesti: true,
      Holboca: true,
      "Valea Lupului": true,
      Iugani: true,
      Siretel: true,
      Tibanesti: true,
      Popricani: true,
      Miroslovesti: true,
      Mosna: true,
      Horlesti: true,
      Popesti: true,
      Ciurea: true,
      Tatarusi: true,
      Ciohorani: true,
      Prisacani: true,
      Vladeni: true,
      Bratesti: true,
      Carjoaia: true,
      Fantanele: true,
      Garbesti: true,
      Cogeasca: true,
      "Valea Seaca": true,
      Farcaseni: true,
      Scobinti: true,
      Tansa: true,
      Rachiteni: true,
      Chiscareni: true,
      Buhalnita: true,
      Trifesti: true,
      Perieni: true,
      Osoi: true,
      "Stolniceni-Prajescu": true,
      Sticlaria: true,
      Uda: true,
      Contesti: true,
      Sinesti: true,
      Bosia: true,
      "Satu Nou": true,
      Cotnari: true,
      Borosoaia: true,
      Andrieseni: true,
      Ruginoasa: true,
      Dagata: true,
      Golaiesti: true,
      Baltati: true,
      Pausesti: true,
      Dumesti: true,
      Totoesti: true,
      Crivesti: true,
      Izvoarele: true,
      Costuleni: true,
      Mircesti: true,
      Ceplenita: true,
      Bohotin: true,
      Boureni: true,
      Grajduri: true,
      Rediu: true,
      Soci: true,
      Covasna: true,
      Plugari: true,
      Suhulet: true,
      Hodora: true,
      Blagesti: true,
      Slobozia: true,
      Victoria: true,
      Liteni: true,
      Ciortesti: true,
      Crucea: true,
      Hartoape: true,
      Badeni: true,
      Pietrosu: true,
      Scheia: true,
      Miroslava: true,
      Scanteia: true,
      Braesti: true,
      Munteni: true,
      Sodomeni: true,
      Carniceni: true,
      Verseni: true,
      Poiana: true,
      Fetesti: true,
      Coropceni: true,
      Buznea: true,
      Razboieni: true,
      "Iazu Nou": true,
      Zmeu: true,
      Bals: true,
      Costesti: true,
      Dumbrava: true,
      Vanatori: true,
      Probota: true,
      Bradicesti: true,
      Grozesti: true,
      Goesti: true,
      Manastirea: true,
      Bosteni: true,
      Goruni: true,
      Cozia: true,
      Buda: true,
      "Harmanestii Vechi": true,
      Handresti: true,
      Stornesti: true,
      Budai: true,
      Breazu: true,
      "Poiana Marului": true,
      Tutora: true,
      Zagavia: true,
      "Podolenii de Sus": true,
      Tabara: true,
      Domnita: true,
      Tiganasi: true,
      Moreni: true,
      Luncasi: true,
      Hadambu: true,
      Tautesti: true,
      Lespezi: true,
      Serbesti: true,
      Feredeni: true,
      Dorobant: true,
      Romanesti: true,
      Scobalteni: true,
      Aroneanu: true,
      Lungani: true,
      Hermeziu: true,
      Borsa: true,
      Potangeni: true,
      Madarjac: true,
      Sarca: true,
      Chicerea: true,
      Borosesti: true,
      Bogonos: true,
      Iorcani: true,
      Madarjesti: true,
      Draguseni: true,
      Oboroceni: true,
      "Mihail Kogalniceanu": true,
      Hoisesti: true,
      Sipote: true,
      "Bursuc-Deal": true,
      Pietris: true,
      "Tudor Vladimirescu": true,
      Bogdanesti: true,
      Ganesti: true,
      "Mogosesti-Siret": true,
      Glavanesti: true,
      Barnova: true,
      Hilita: true,
      Vulturi: true,
      Bulbucani: true,
      Harmaneasa: true,
      Humosu: true,
      Halceni: true,
      Poieni: true,
      Manzatesti: true,
      Ipatele: true,
      Iepureni: true,
      Helesteni: true,
      Rasboieni: true,
      Harpasesti: true,
      Gorban: true,
      Saveni: true,
      "Alexandru I. Cuza": true,
      Paun: true,
      "Larga-Jijia": true,
      Radeni: true,
      "Valea Oilor": true,
      Ulmi: true,
      Ungheni: true,
      Macaresti: true,
      Dolhesti: true,
      Arama: true,
      Roscani: true,
      Horodistea: true,
      "Harmanestii Noi": true,
      Ciurbesti: true,
      Uricani: true,
      Opriseni: true,
      Horpaz: true,
      Prigoreni: true,
      Tungujei: true,
      Barlesti: true,
      Scoposeni: true,
      "Podu Hagiului": true,
      Jigoreni: true,
      Doroscani: true,
      Balteni: true,
      "Dumitrestii Galatii": true,
      Rosu: true,
      Bacu: true,
      Strunga: true,
      "Picioru Lupului": true,
      "Gura Badilitei": true,
      Spineni: true,
      Cucuteni: true,
      Manjesti: true,
      Avantu: true,
      Icuseni: true,
      "Alexandru cel Bun": true,
      Orzeni: true,
      Luceni: true,
      Frenciugi: true,
      Zaboloteni: true,
      Vorovesti: true,
      Miclauseni: true,
      Alexeni: true,
      Pocreaca: true,
      Tibana: true,
      Giurgesti: true,
      Bratulesti: true,
      "Valea Satului": true,
      Forasti: true,
      Ursita: true,
      "Coada Stancii": true,
      Cauesti: true,
      "Coltu Cornii": true,
      Cornesti: true,
      Movileni: true,
      Stanca: true,
      Vascani: true,
      Runcu: true,
      Todirel: true,
      Habasesti: true,
      Volintiresti: true,
      "Cuza Voda": true,
      Buhaeni: true,
      Pietraria: true,
      Carlig: true,
      Malaesti: true,
      Podisu: true,
      "Schitu Duca": true,
      "Zece Prajini": true,
      Solonet: true,
      Cilibiu: true,
      "Poiana Manastirii": true,
      "Cioca-Boca": true,
      "Schitu Stavnic": true,
      "Poiana de Sus": true,
      "Rusenii Vechi": true,
      Homita: true,
      Gropnita: true,
      Stroesti: true,
      Valcelele: true,
      "Gura Bohotin": true,
      Mitoc: true,
      "Poiana Scheii": true,
      "Cotu lui Ivan": true,
      "Piscu Rusului": true,
      Baiceni: true,
      Albesti: true,
      Proselnici: true,
      Ursoaia: true,
      Sangeri: true,
      Padureni: true,
      Valenii: true,
      "Lunca Rates": true,
      Bodesti: true,
      Fedeleseni: true,
      Kogalniceni: true,
      "Valea Racului": true,
      Luparia: true,
      Rotaria: true,
      Bocnita: true,
      Brosteni: true,
      Bahluiu: true,
      "Rediu Aldei": true,
      Isaiia: true,
      Petresti: true,
      Moimesti: true,
      Boldesti: true,
      Zlodica: true,
      Vladiceni: true,
      Zberoaia: true,
      "Podolenii de Jos": true,
      Stejarii: true,
      "Iazu Vechi": true,
      Spranceana: true,
      Banu: true,
      Frumusica: true,
      Iacobeni: true,
      "Rusenii Noi": true,
      Carbunari: true,
      Zbereni: true,
      Tipilesti: true,
      Ciocarlesti: true,
      Chiperesti: true,
      Gradinari: true,
      Balciu: true,
      Cositeni: true,
      Budesti: true,
      Sacaresti: true,
      "Tufestii de Sus": true,
      Curaturi: true,
      Onesti: true,
      Spinoasa: true,
      Berezlogi: true,
      Boatca: true,
      Cercu: true,
      Obrijeni: true,
      Frasuleni: true,
      Cireseni: true,
      Sendreni: true,
      Bojila: true,
      Mitesti: true,
      Bratuleni: true,
      Fagat: true,
      "Valea Lunga": true,
      Dadesti: true,
      Sculeni: true,
      Griesti: true,
      Balusesti: true,
      "Podu Jijiei": true,
      "Cotu Morii": true,
      "Vadu Vejei": true,
      "Coasta Magurii": true,
      "Valea Adanca": true,
      Visan: true,
      Holm: true,
      Vocotesti: true,
      Recea: true,
      Gaureni: true,
      Valcica: true,
      Poienile: true,
      Vladomira: true,
      "Ion Neculce": true,
      "Bursuc-Vale": true,
      Buruienesti: true,
      Oproaia: true,
      Traian: true,
      Barbatesti: true,
      Tarnita: true,
      Hlincea: true,
      Ursaresti: true,
      Chilisoaia: true,
      Cucova: true,
      Sorogani: true,
      Draganesti: true,
      Petrosica: true,
      Dancas: true,
      "Moara Ciornei": true,
      Vladnicut: true,
      Curagau: true,
      Iosupeni: true,
      "Rediu Mitropoliei": true,
      Medeleni: true,
      "Poiana cu Cetate": true,
      "Gura Vaii": true,
      "Leahu-Nacu": true,
      Blaga: true,
      Salageni: true,
      "Valea Ursului": true,
      Buzdug: true,
      "Schitu Hadambului": true,
      Filiasi: true,
      Vama: true,
      Cotargaci: true,
      Alexesti: true,
      Corcodel: true,
      Bran: true,
    },
    IF: {
      Voluntari: true,
      Buftea: true,
      Pantelimon: true,
      "Popesti Leordeni": true,
      Jilava: true,
      Chitila: true,
      Otopeni: true,
      Bragadiru: true,
      Branesti: true,
      Afumati: true,
      Peris: true,
      Balotesti: true,
      Domnesti: true,
      Magurele: true,
      "1 Decembrie": true,
      Mogosoaia: true,
      Cornetu: true,
      Berceni: true,
      "Moara Vlasiei": true,
      Chiajna: true,
      Glina: true,
      Clinceni: true,
      Vidra: true,
      Dobroesti: true,
      Tunari: true,
      "Darasti-Ilfov": true,
      Copaceni: true,
      Ciorogarla: true,
      Ciolpani: true,
      Rosu: true,
      Cretesti: true,
      Fundeni: true,
      Tanganu: true,
      Catelu: true,
      "Silistea Snagovului": true,
      Cernica: true,
      Lipia: true,
      "Dragomiresti-Deal": true,
      Sintesti: true,
      Buciumeni: true,
      Balaceanca: true,
      "Stefanestii de Jos": true,
      Gruiu: true,
      Gradistea: true,
      Varteju: true,
      Ghermanesti: true,
      Dascalu: true,
      Darvari: true,
      Caciulati: true,
      Burias: true,
      "Stefanestii de Sus": true,
      Snagov: true,
      Tancabesti: true,
      Tamasi: true,
      Piteasca: true,
      Petrachioaia: true,
      Islaz: true,
      Alunisu: true,
      Rudeni: true,
      Corbeanca: true,
      "Merii Petchii": true,
      Caldararu: true,
      Olteni: true,
      "Dragomiresti-Vale": true,
      Saftica: true,
      Zurbaua: true,
      Sitaru: true,
      Ciofliceni: true,
      Sindrilita: true,
      Piscu: true,
      Pasarea: true,
      "Micsunestii Mari": true,
      Dudu: true,
      Nuci: true,
      Cozieni: true,
      Dumitrana: true,
      Ganeasa: true,
      Izvorani: true,
      Posta: true,
      "Moara Domneasca": true,
      "Santu Floresti": true,
      Teghes: true,
      "Micsunestii-Moara": true,
      Gagu: true,
      Maineasca: true,
      Vanatori: true,
      Balteni: true,
      Petresti: true,
      Surlari: true,
      Ostratu: true,
      Dumbraveni: true,
      Luparia: true,
      Manolache: true,
      "Balta Neagra": true,
      Pruni: true,
      Cretuleasca: true,
      Vladiceasca: true,
      Creata: true,
      Runcu: true,
      "Vadu Anei": true,
      Buda: true,
      Dimieni: true,
      Odaile: true,
      Ordoreanu: true,
    },
    MM: {
      "Baia Mare": true,
      "Sighetu Marmatiei": true,
      Borsa: true,
      "Viseu de Sus": true,
      "Baia Sprie": true,
      "Poienile de Sub Munte": true,
      Moisei: true,
      Seini: true,
      "Targu Lapus": true,
      "Salistea de Sus": true,
      Cavnic: true,
      "Viseu de Jos": true,
      Ruscova: true,
      Repedea: true,
      Barsana: true,
      Ieud: true,
      "Rona de Sus": true,
      Sacel: true,
      Lapus: true,
      "Somcuta Mare": true,
      Rozavlea: true,
      Dragomiresti: true,
      Stramtura: true,
      Sapanta: true,
      "Viseu de Mijloc": true,
      Botiza: true,
      Petrova: true,
      Budesti: true,
      "Bogdan Voda": true,
      Leordina: true,
      Remeti: true,
      "Tautii de Sus": true,
      Sieu: true,
      "Campulung la Tisa": true,
      "Suciu de Sus": true,
      Sarasau: true,
      "Vadu Izei": true,
      "Rona de Jos": true,
      "Grosii Tiblesului": true,
      "Crasna Viseului": true,
      "Tautii-Magheraus": true,
      Baiut: true,
      Baita: true,
      Cicarlau: true,
      Berbesti: true,
      Ardusat: true,
      "Valea Viseului": true,
      Farcasa: true,
      "Baita de Sub Codru": true,
      Gardani: true,
      Ulmeni: true,
      Sasar: true,
      Oncesti: true,
      Ungureni: true,
      "Valea Hotarului": true,
      Rogoz: true,
      Calinesti: true,
      Iapa: true,
      Coltau: true,
      Sisesti: true,
      "Ocna Sugatag": true,
      "Miresu Mare": true,
      Salsig: true,
      Craciunesti: true,
      Valeni: true,
      Ilba: true,
      "Suciu de Jos": true,
      Surdesti: true,
      Satulung: true,
      "Valea Cufundoasa": true,
      Coas: true,
      Lapusel: true,
      Tisa: true,
      "Asuaju de Sus": true,
      Breb: true,
      "Sat-Sugatag": true,
      Giulesti: true,
      Chelinta: true,
      Libotin: true,
      Grosi: true,
      Manau: true,
      "Baile Borsa": true,
      Dumbravita: true,
      "Poienile Izei": true,
      Nistru: true,
      Bistra: true,
      Razoare: true,
      Bocicoel: true,
      Mara: true,
      "Remetea Chioarului": true,
      Cernesti: true,
      Iadara: true,
      Desesti: true,
      Sarbi: true,
      "Lunca la Tisa": true,
      Recea: true,
      "Satu Nou de Sus": true,
      Borcut: true,
      Damacuseni: true,
      "Valenii Somcutei": true,
      Tamaia: true,
      Arduzel: true,
      Chechis: true,
      "Somes-Uileac": true,
      Cupseni: true,
      Ciocotis: true,
      Rohia: true,
      Buciumi: true,
      "Copalnic-Manastur": true,
      Costiui: true,
      Glod: true,
      Nanesti: true,
      Fauresti: true,
      "Bocicoiu Mare": true,
      Sabisa: true,
      Berinta: true,
      "Strambu-Baiut": true,
      Coruia: true,
      Tulghies: true,
      Fersig: true,
      "Finteusu Mic": true,
      Bicaz: true,
      Sugau: true,
      Sacalaseni: true,
      Mocira: true,
      "Satu Nou de Jos": true,
      Copalnic: true,
      "Finteusu Mare": true,
      Trestia: true,
      Mogosesti: true,
      Pribilesti: true,
      "Oarta de Sus": true,
      Chiuzbaia: true,
      Fanate: true,
      "Boiu Mare": true,
      Rus: true,
      "Valea Chioarului": true,
      Harnicesti: true,
      Basesti: true,
      Cetatele: true,
      Arinis: true,
      Lucacesti: true,
      "Remeti pe Somes": true,
      Ticau: true,
      "Oarta de Jos": true,
      Slatioara: true,
      Berchez: true,
      Danesti: true,
      Culcea: true,
      Sindresti: true,
      "Lazu Baciului": true,
      "Viile Apei": true,
      Carbunari: true,
      "Bozanta Mare": true,
      Ciolt: true,
      Buzesti: true,
      Coroieni: true,
      "Valea Stejarului": true,
      Costeni: true,
      Boiereni: true,
      Odesti: true,
      Baba: true,
      Negreia: true,
      Laschia: true,
      "Valenii Lapusului": true,
      Hideaga: true,
      Berchezoaia: true,
      Cornesti: true,
      Larga: true,
      Prislop: true,
      Busag: true,
      Plopis: true,
      Feresti: true,
      "Danestii Chioarului": true,
      "Vima Mare": true,
      "Handalu Ilbei": true,
      Fericea: true,
      Unguras: true,
      Corni: true,
      "Asuaju de Jos": true,
      Ocolis: true,
      "Preluca Veche": true,
      Posta: true,
      Buteasa: true,
      "Vima Mica": true,
      Mesteacan: true,
      "Curtuiusu Mare": true,
      Stremt: true,
      Vicea: true,
      Piatra: true,
      Varai: true,
      Hoteni: true,
      "Dealu Mare": true,
      Coltirea: true,
      Carpinis: true,
      Urmenis: true,
      Vad: true,
      "Bozanta Mica": true,
      Tamasesti: true,
      Fantanele: true,
      Firiza: true,
      "Poiana Botizii": true,
      Inau: true,
      Hovrila: true,
      "Preluca Noua": true,
      Peteritea: true,
      "Codru Butesii": true,
      Salnita: true,
      Bargau: true,
      "Ariesu de Camp": true,
      Rusor: true,
      Blidari: true,
      Ciuta: true,
      "Curtuiusu Mic": true,
      Catalina: true,
      Cufoaia: true,
      Bontaieni: true,
      Brebeni: true,
      Tohat: true,
      Remecioara: true,
      Draghia: true,
      Magureni: true,
      "Ariesu de Padure": true,
      Dumbrava: true,
      Merisor: true,
      "Teceu Mic": true,
      Ulmoasa: true,
      Manastirea: true,
      Ortita: true,
      Rodina: true,
      Saliste: true,
      "Valea Neagra": true,
      Stoiceni: true,
      "Copalnic-Deal": true,
      "Dobricu Lapusului": true,
      "Dealu Corbului": true,
      Romanesti: true,
      Stejera: true,
      Intrerauri: true,
      Durusa: true,
      "Francenii Boiului": true,
      Groape: true,
      Aspra: true,
      Jugastreni: true,
      Izvoarele: true,
      Salta: true,
    },
    MH: {
      "Drobeta-Turnu Severin": true,
      Orsova: true,
      Strehaia: true,
      "Schela Cladovei": true,
      "Vanju Mare": true,
      Patulele: true,
      Salcia: true,
      "Garla Mare": true,
      "Ostrovu Mare": true,
      Cerneti: true,
      Eselnita: true,
      Simian: true,
      Oprisor: true,
      Cujmir: true,
      "Baia de Arama": true,
      Vrata: true,
      "Breznita-Ocol": true,
      Gruia: true,
      Darvari: true,
      Gvardinita: true,
      Branistea: true,
      Balacita: true,
      Vanjulet: true,
      "Gura Vaii": true,
      Devesel: true,
      "Balta Verde": true,
      Gemeni: true,
      Comanda: true,
      Jirov: true,
      Rogova: true,
      Bistrita: true,
      Danceu: true,
      Vanatori: true,
      Pristol: true,
      Punghina: true,
      "Breznita-Motru": true,
      Gogosu: true,
      Svinita: true,
      Livezile: true,
      Izimsa: true,
      Halanga: true,
      Izvoarele: true,
      Ciochiuta: true,
      Rosiori: true,
      "Obarsia de Camp": true,
      "Orevita Mare": true,
      Corcova: true,
      "Nicolae Balcescu": true,
      Dudasu: true,
      Jidostita: true,
      Recea: true,
      Sisesti: true,
      Cioroboreni: true,
      Hinova: true,
      "Jiana Veche": true,
      Malovat: true,
      "Burila Mica": true,
      "Jiana Mare": true,
      Scapau: true,
      Marasesti: true,
      Sovarna: true,
      Almajel: true,
      "Valea Ursului": true,
      Bala: true,
      Ilovita: true,
      Carceni: true,
      Negoesti: true,
      Podeni: true,
      Albulesti: true,
      "Burila Mare": true,
      "Obarsia-Closani": true,
      Crivina: true,
      Smadovita: true,
      Magheru: true,
      Vladaia: true,
      Greci: true,
      Aurora: true,
      Jiana: true,
      Corlatel: true,
      Noaptesa: true,
      Isverna: true,
      Prunisor: true,
      Slasoma: true,
      Ilovat: true,
      Traian: true,
      Gardoaia: true,
      Brosteni: true,
      Cozia: true,
      Bistretu: true,
      "Izvoru Barzii": true,
      Zegujani: true,
      "Valea Anilor": true,
      Goanta: true,
      Viasu: true,
      Prisaceaua: true,
      Stignita: true,
      Dobra: true,
      "Bala de Sus": true,
      Corzu: true,
      Severinesti: true,
      Bacles: true,
      "Dudasu Schelei": true,
      Grozesti: true,
      Dubova: true,
      Cordun: true,
      "Lupsa de Jos": true,
      "Lupsa de Sus": true,
      Rudina: true,
      Meris: true,
      "Poroina Mare": true,
      Buicesti: true,
      Craguesti: true,
      Parlagele: true,
      Cotoroaia: true,
      "Cujmiru Mic": true,
      Arginesti: true,
      Selistea: true,
      "Lunca Banului": true,
      "Garbovatu de Jos": true,
      Drincea: true,
      Iablanita: true,
      Voloiac: true,
      Schinteiesti: true,
      Pluta: true,
      Bobaita: true,
      Ciovarnasani: true,
      Copacioasa: true,
      Tamna: true,
      Bahna: true,
      Stangaceaua: true,
      Butoiesti: true,
      Baltanele: true,
      "Valea Buna": true,
      "Ostrovu Corbului": true,
      Tiganasi: true,
      Balta: true,
      Peri: true,
      Stejaru: true,
      Izvoralu: true,
      Imoasa: true,
      Crainici: true,
      Stanesti: true,
      "Padina Mare": true,
      Hotarani: true,
      Colibasi: true,
      Cocorova: true,
      Balotesti: true,
      Dalma: true,
      Scorila: true,
      Bucura: true,
      Titerlesti: true,
      "Dedovita Noua": true,
      "23-Aug": true,
      Barda: true,
      Cremenea: true,
      Cervenita: true,
      Ohaba: true,
      Prejna: true,
      Plopi: true,
      Susita: true,
      "Padina Mica": true,
      "Slatinicu Mare": true,
      "Garbovatu de Sus": true,
      "Izvoralu de Jos": true,
      Eibenthal: true,
      "Gura Motrului": true,
      Balvanesti: true,
      Zegaia: true,
      "Fantana Domneasca": true,
      "Izvoru Anestilor": true,
      Ponoarele: true,
      Pasarani: true,
      Petra: true,
      Erghevita: true,
      Tantaru: true,
      Batoti: true,
      "Fantanile Negre": true,
      Dalbocita: true,
      Higiu: true,
      "Izvoru Frumos": true,
      Baraiacu: true,
      Luncsoara: true,
      Gardaneasa: true,
      Stircovita: true,
      Cernaia: true,
      Costesti: true,
      Jugastru: true,
      Husnicioara: true,
      Negresti: true,
      Radutesti: true,
      "Poiana Gruii": true,
      Vrancea: true,
      Brebina: true,
      Busesti: true,
      "Baia Noua": true,
      Gornovita: true,
      Ercea: true,
      Ghelmegioaia: true,
      "Satu Mare": true,
      Selistiuta: true,
      "Podu Grosului": true,
      Poroinita: true,
      Boceni: true,
      Gornenti: true,
      Poroina: true,
      Hurducesti: true,
      Selisteni: true,
      Colaret: true,
      "Fata Cremenii": true,
      Cearangu: true,
      "Cerna-Varf": true,
      Ciresu: true,
      Putinei: true,
      Stancesti: true,
      "Cracu Muntelui": true,
      Bunoaica: true,
      "Maru Rosu": true,
      Salatruc: true,
      "Schitu Topolnitei": true,
      Gheorghesti: true,
      Runcusoru: true,
      Baditesti: true,
      "Valea Marcului": true,
      Nadanova: true,
      Puscasu: true,
      "Stefan Odobleja": true,
      Draghesti: true,
      Motruleni: true,
      "Dumbrava de Jos": true,
      Floresti: true,
      Turtaba: true,
      Barlogeni: true,
      Vladasesti: true,
      Racova: true,
      Negrusa: true,
      Tismana: true,
      Vidimiresti: true,
      Malarisca: true,
      Godeanu: true,
      Paunesti: true,
      Siroca: true,
      Poiana: true,
      Fauroaia: true,
      Budanesti: true,
      Ilovu: true,
      Sipotu: true,
      Brativoesti: true,
      Moisesti: true,
      "Valea Cosustei": true,
      Baluta: true,
      Cazanesti: true,
      Rocsoreni: true,
      "Balvanestii de Jos": true,
      Comanesti: true,
      "Fata Motrului": true,
      Lac: true,
      Olteanca: true,
      Stroesti: true,
      Capatanesti: true,
      "Adunatii Teiului": true,
      Studina: true,
      Cosovat: true,
      Lumnic: true,
      Opranesti: true,
      Biban: true,
      Bratilovu: true,
      Pistrita: true,
      Croica: true,
      Petris: true,
      Bratesul: true,
      Pesteana: true,
      Tarsa: true,
      Ceptureni: true,
      Rascolesti: true,
      Lazu: true,
      Paltinisu: true,
      Iupca: true,
      "Slatinicu Mic": true,
      "Valea Copcii": true,
      Jignita: true,
      Sardanesti: true,
      Menti: true,
      Mosneni: true,
      Pavat: true,
      Caramidaru: true,
      Sfodea: true,
      Magurele: true,
      Proitesti: true,
      Suharu: true,
      Celnata: true,
      Balota: true,
      "Dedovita Veche": true,
      Rosia: true,
      Voloicel: true,
      "Dunarea Mica": true,
      "Campu Mare": true,
      Ludu: true,
      Ceranganul: true,
      Raiculesti: true,
      "Valea Teiului": true,
      Borogea: true,
      Sperlesti: true,
      Pestenuta: true,
      Giura: true,
      Priboiesti: true,
      Breznicioara: true,
      Gutu: true,
      Buicani: true,
      Molani: true,
      Parvulesti: true,
      "Dumbrava de Sus": true,
      "Calinestii de Sus": true,
      Delureni: true,
      Giurgiani: true,
      Ruptura: true,
      Branzeni: true,
      "Dealu Mare": true,
      Jupanesti: true,
      Marga: true,
      Alunisul: true,
      "Coada Cornetului": true,
      Plai: true,
      "Dumbrava de Mijloc": true,
      Mijarca: true,
      Titirigi: true,
      Arvatesti: true,
      Livezi: true,
      "Cracu Lung": true,
      Firizu: true,
      Igiroasa: true,
      Vladica: true,
      Manu: true,
      Garnita: true,
      Govodarva: true,
      "Posta Veche": true,
      "Valea Petrii": true,
      Carsu: true,
      Dragotesti: true,
      Blidaru: true,
      Bragleasa: true,
      Varodia: true,
      Marmanu: true,
      Carjei: true,
      "Calinestii de Jos": true,
      Golineasa: true,
      Talapanu: true,
      Breta: true,
      Prunaru: true,
      Deleni: true,
      Visina: true,
      Dumbravita: true,
      Nevatu: true,
      "Satu Nou": true,
    },
    MS: {
      "Targu Mures": true,
      Reghin: true,
      Sighisoara: true,
      Tarnaveni: true,
      Ludus: true,
      Sovata: true,
      "Sangeorgiu de Mures": true,
      Iernut: true,
      "Sangeorgiu de Padure": true,
      Cristesti: true,
      "Sancraiu de Mures": true,
      "Miercurea Nirajului": true,
      Sarmasu: true,
      Ungheni: true,
      Ganesti: true,
      Band: true,
      Albesti: true,
      Apalina: true,
      "Zau de Campie": true,
      Fantanele: true,
      Craciunesti: true,
      Hodac: true,
      Ibanesti: true,
      Panet: true,
      Petelea: true,
      Danes: true,
      Glodeni: true,
      Remetea: true,
      Alunis: true,
      Adamus: true,
      Gurghiu: true,
      Nazna: true,
      Ernei: true,
      Gornesti: true,
      Deda: true,
      "Valea Larga": true,
      Glajarie: true,
      Chibed: true,
      Bahnea: true,
      "Santana de Mures": true,
      Eremitu: true,
      "Lunca Bradului": true,
      Voivodeni: true,
      Peris: true,
      Brancovenesti: true,
      Toaca: true,
      Dumbravioara: true,
      Chendu: true,
      Sarateni: true,
      Vanatori: true,
      Saschiz: true,
      Rastolita: true,
      Seleus: true,
      Bogata: true,
      Boiu: true,
      Saulia: true,
      Solovastru: true,
      Ghindari: true,
      Sanpaul: true,
      Raciu: true,
      Corunca: true,
      Bobohalma: true,
      Suseni: true,
      Ogra: true,
      Gheja: true,
      Dedrad: true,
      "Ceuasu de Campie": true,
      "Rusii-Munti": true,
      "Mihesu de Campie": true,
      Iernuteni: true,
      "Santioana de Mures": true,
      Deaj: true,
      "Valenii de Mures": true,
      Cornesti: true,
      Chetani: true,
      Galesti: true,
      Craiesti: true,
      Balauseri: true,
      Madaras: true,
      Delenii: true,
      Dambau: true,
      Berghia: true,
      Sanger: true,
      "Trei Sate": true,
      Balda: true,
      Breaza: true,
      Sincai: true,
      "Valea Izvoarelor": true,
      Jabenita: true,
      Nades: true,
      Saes: true,
      "Sanpetru de Campie": true,
      Livezeni: true,
      "Bistra Muresului": true,
      Cucerdea: true,
      Acatari: true,
      Bagaciu: true,
      Goreni: true,
      Pogaceaua: true,
      Zagar: true,
      Cipau: true,
      Batos: true,
      "Ideciu de Jos": true,
      Baita: true,
      Mureseni: true,
      Pasareni: true,
      Sacadat: true,
      Valureni: true,
      Calimanesti: true,
      Voiniceni: true,
      Vatava: true,
      Cuci: true,
      Viforoasa: true,
      Ceuas: true,
      Salcud: true,
      Taureni: true,
      Curteni: true,
      "Grebenisu de Campie": true,
      Hadareni: true,
      Haranglab: true,
      Hetiur: true,
      Sambrias: true,
      Tigmandru: true,
      "Filpisu Mare": true,
      Troita: true,
      Bala: true,
      Galateni: true,
      Roteni: true,
      Rosiori: true,
      Suplac: true,
      Dumbrava: true,
      Filea: true,
      Luieriu: true,
      Campenita: true,
      Vidrasau: true,
      Cipaieni: true,
      Orsova: true,
      Stanceni: true,
      Tirimia: true,
      Matrici: true,
      Valenii: true,
      "Beica de Jos": true,
      Bezid: true,
      Magherani: true,
      Archita: true,
      "Sarmasel-Gara": true,
      Lechinta: true,
      Cerghizel: true,
      "Ideciu de Sus": true,
      Tonciu: true,
      Agristeu: true,
      Idrifaia: true,
      "Lunca Muresului": true,
      "Papiu Ilarian": true,
      Gogan: true,
      Sarmasel: true,
      Atintis: true,
      "Satu Nou": true,
      Cuiesd: true,
      Tusinu: true,
      Sabed: true,
      Razoare: true,
      "Capusu de Campie": true,
      "Idicel-Padure": true,
      Apold: true,
      Viisoara: true,
      Cris: true,
      Senereus: true,
      "Petrilaca de Mures": true,
      Petrilaca: true,
      "Iclandu Mare": true,
      Caluseri: true,
      Valea: true,
      "Seulia de Mures": true,
      Faragau: true,
      Casva: true,
      Lunca: true,
      Soard: true,
      Dambu: true,
      Dumitreni: true,
      "Rapa de Jos": true,
      "Silea Nirajului": true,
      "Urisiu de Sus": true,
      Chirileu: true,
      Calugareni: true,
      Mica: true,
      Daia: true,
      Grindeni: true,
      Chinari: true,
      "Chiheru de Jos": true,
      Uila: true,
      Ulies: true,
      Pietris: true,
      Santioana: true,
      Visinelu: true,
      Cerghid: true,
      Logig: true,
      Custelnic: true,
      Frunzeni: true,
      Neagra: true,
      Odrihei: true,
      "Gheorghe Doja": true,
      Paingeni: true,
      Idicel: true,
      Murgesti: true,
      Deag: true,
      "Ibanesti-Padure": true,
      "Sacalu de Padure": true,
      "Laslau Mare": true,
      Soimus: true,
      Iclanzel: true,
      Fitcau: true,
      "Filpisu Mic": true,
      Cozma: true,
      Vargata: true,
      "Campu Cetatii": true,
      Padureni: true,
      "Sanmartinu de Campie": true,
      Vetca: true,
      Santu: true,
      Mestera: true,
      Morareni: true,
      Porumbeni: true,
      Iliesi: true,
      Serbeni: true,
      Gaiesti: true,
      "Dubistea de Padure": true,
      Tireu: true,
      Coroisanmartin: true,
      "Budiu Mic": true,
      Solocma: true,
      Cecalaca: true,
      Ghinesti: true,
      Roua: true,
      Ozd: true,
      "Sangeorgiu de Campie": true,
      "Laslau Mic": true,
      Teleac: true,
      Ilieni: true,
      Dataseni: true,
      "Valea Sanpetrului": true,
      "Urisiu de Jos": true,
      Culpiu: true,
      Mureni: true,
      Botorca: true,
      Tampa: true,
      Neaua: true,
      "Sardu Nirajului": true,
      Maiad: true,
      "Chiheru de Sus": true,
      Ormenis: true,
      "Valea Albestiului": true,
      Habic: true,
      Moisa: true,
      Vadas: true,
      Cinta: true,
      Oroiu: true,
      Topa: true,
      Iod: true,
      Barbosi: true,
      Deleni: true,
      Isla: true,
      Idiciu: true,
      Mitresti: true,
      Dumitrestii: true,
      "Iara de Mures": true,
      Moresti: true,
      Abus: true,
      Leordeni: true,
      Toldal: true,
      "Mihai Viteazu": true,
      "Sangeru de Padure": true,
      Stejeris: true,
      Somostelnic: true,
      Marasesti: true,
      Jacodu: true,
      Bordosiu: true,
      Dulcea: true,
      "Sfantu Gheorghe": true,
      Valeni: true,
      Stejarenii: true,
      "Sanmihai de Padure": true,
      "Fanatele Madarasului": true,
      Ciobotani: true,
      Adrian: true,
      Herghelia: true,
      "Valea Surii": true,
      Nadasa: true,
      "Valea Uriesului": true,
      Icland: true,
      Marculeni: true,
      Mosuni: true,
      Hartau: true,
      Fanate: true,
      Bardesti: true,
      Comori: true,
      "Valea Rece": true,
      Pacureni: true,
      Cotus: true,
      Rigmani: true,
      "Beica de Sus": true,
      Damieni: true,
      Tisieu: true,
      Gruisor: true,
      Ivanesti: true,
      Merisor: true,
      Suveica: true,
      Ranta: true,
      Bichis: true,
      "Sincai-Fanate": true,
      Vadu: true,
      Pauloaia: true,
      Laureni: true,
      Filitelnic: true,
      Lepindea: true,
      Sausa: true,
      Poienita: true,
      "Nima Raciului": true,
      Sanmarghita: true,
      Eremieni: true,
      Petea: true,
      Poarta: true,
      Maioresti: true,
      Bozed: true,
      Bradetelu: true,
      Venchi: true,
      "Dileu Vechi": true,
      Milasel: true,
      Feleag: true,
      Bolintineni: true,
      Ercea: true,
      "Valea Mare": true,
      Grausorul: true,
      "Valea Padurii": true,
      Hodosa: true,
      Paucisoara: true,
      Abud: true,
      Giulus: true,
      Blidireasa: true,
      Istihaza: true,
      Bord: true,
      Lenis: true,
      "Socolu de Campie": true,
      Gradini: true,
      Lascud: true,
      "Valea Fratiei": true,
      Gambut: true,
      Cioarga: true,
      Avramesti: true,
      Torba: true,
      Sacareni: true,
      "Valea Sanmartinului": true,
      Bereni: true,
      Cibu: true,
      Maia: true,
      Bedeni: true,
      Botez: true,
      "Dileu Nou": true,
      Orosia: true,
      "Oarba de Mures": true,
      Andreneasa: true,
      Cund: true,
      Sanisor: true,
      Bernadea: true,
      Caciulata: true,
      Cloasterf: true,
      Tiptelnic: true,
      "Valea Glodului": true,
      Vaideiu: true,
      Capeti: true,
      "Negrenii de Campie": true,
      Coroi: true,
      Fundoaia: true,
      "Draculea Bandului": true,
      "Orsova-Padure": true,
      Salasuri: true,
      Leorinta: true,
      Tirimioara: true,
      "Leorinta-Saulia": true,
      Cacuciu: true,
      Bara: true,
      "Parau Mare": true,
      Candu: true,
      "Capalna de Sus": true,
      Barlibas: true,
      Sebes: true,
      Magherus: true,
      Macicasesti: true,
      "Istan-Tau": true,
      Pusta: true,
      Ilioara: true,
      Recea: true,
      Drojdii: true,
      Nandra: true,
      "Adrianu Mare": true,
      Padurea: true,
      Rora: true,
      Bicasu: true,
      "Parau Crucii": true,
      Ihod: true,
      "Coasta Mare": true,
      Beu: true,
      Salard: true,
      Botei: true,
      Zapodea: true,
      Ursoaia: true,
      "Bezidu Nou": true,
      Bozeni: true,
      Saulita: true,
      Viilor: true,
      "Aurel Vlaicu": true,
      Soromiclea: true,
      "Gaura Sangerului": true,
      Larga: true,
      Ciulea: true,
      Corbesti: true,
      Lechincioara: true,
      Poduri: true,
      Madaraseni: true,
      Lefaia: true,
      Morut: true,
      Pipea: true,
      Sansimion: true,
      Onuca: true,
      Arsita: true,
      Merisoru: true,
      Vulcan: true,
      Ciurgau: true,
      "Sub Padure": true,
      Barza: true,
      Borzia: true,
      "Fanatele Capusului": true,
      "Moara de Jos": true,
      "Mura Mare": true,
      Pripoare: true,
      Bujor: true,
      Galaoaia: true,
      Ciretea: true,
      Herepea: true,
      Uricea: true,
      Lapusna: true,
      Dobra: true,
      "Adrianu Mic": true,
      Veta: true,
      Hagau: true,
      Tau: true,
      "Groapa Radaii": true,
      "Mura Mica": true,
      Ceie: true,
      Cordos: true,
      Zimti: true,
      Sapartoc: true,
      Sicele: true,
      Stefanca: true,
      Vaidacuta: true,
      Porumbac: true,
      Mirigioaia: true,
      Titiana: true,
      Bologaia: true,
      Chincius: true,
      "Fanatele Socolului": true,
      "Valea Uliesului": true,
      Malea: true,
      Saniacob: true,
      Racamet: true,
      Mogoaia: true,
      Stefaneaca: true,
      Ghidasteu: true,
      "Bujor-Hodaie": true,
      Chisalita: true,
      "Coasta Grindului": true,
      Cotorinau: true,
      Tablaseni: true,
      "Valea Seaca": true,
      Giurgis: true,
      Jacu: true,
      Tofalau: true,
      Scurta: true,
      "Valea Iclandului": true,
      "Valea Sasului": true,
      Curete: true,
      Cirhagau: true,
      Lotu: true,
      "Nima Milaselului": true,
      "Dupa Deal": true,
      Malaesti: true,
      "Valea Ungurului": true,
      Dalu: true,
      "Valea Daii": true,
      "Valea Sapartocului": true,
      Fundatura: true,
      Obarsie: true,
      Angofa: true,
      Lint: true,
      Valisoara: true,
      "Fantana Babii": true,
      Sandru: true,
      Barlibasoaia: true,
      Ciba: true,
      Foi: true,
      Hodaia: true,
      Maldaoci: true,
      Nicolesti: true,
      Sanvasii: true,
      Seuca: true,
    },
    NT: {
      "Piatra-Neamt": true,
      Roman: true,
      "Targu Neamt": true,
      Sabaoani: true,
      Savinesti: true,
      Podoleni: true,
      Roznov: true,
      Zanesti: true,
      "Vanatori-Neamt": true,
      Gheraesti: true,
      Bicaz: true,
      Adjudeni: true,
      Tamaseni: true,
      Pildesti: true,
      Horia: true,
      "Piatra Soimului": true,
      Sagna: true,
      Humulesti: true,
      Ruseni: true,
      Oglinzi: true,
      Buruienesti: true,
      "Bicaz-Chei": true,
      "Cotu Vames": true,
      Tazlau: true,
      Trifesti: true,
      Urecheni: true,
      Raucesti: true,
      Slobozia: true,
      Borlesti: true,
      Grumazesti: true,
      Tibucani: true,
      Luminis: true,
      Ghindaoani: true,
      Margineni: true,
      Garcina: true,
      Silistea: true,
      Damuc: true,
      "Ion Creanga": true,
      Cut: true,
      Cordun: true,
      Balusesti: true,
      Gadinti: true,
      Bodesti: true,
      Sabasa: true,
      Rediu: true,
      Dochia: true,
      Telec: true,
      "Dumbrava Rosie": true,
      Dodeni: true,
      Nisiporesti: true,
      Cracaoani: true,
      "Miron Costin": true,
      Tarcau: true,
      "Stefan cel Mare": true,
      Mastacan: true,
      Brusturi: true,
      Tupilati: true,
      Agapia: true,
      Ruginoasa: true,
      Barticesti: true,
      Hangu: true,
      "Bodestii de Jos": true,
      Bistrita: true,
      "Bicazu Ardelean": true,
      Candesti: true,
      Petricani: true,
      Negresti: true,
      Boboiesti: true,
      Topolita: true,
      Nemtisor: true,
      Radeni: true,
      Costisa: true,
      Ceahlau: true,
      Pastraveni: true,
      "Valea Seaca": true,
      Rotunda: true,
      Girov: true,
      Baltatesti: true,
      Pangaracior: true,
      Dolhesti: true,
      Moldoveni: true,
      Izvoare: true,
      Pipirig: true,
      Poieni: true,
      Poloboc: true,
      Bargauani: true,
      Tasca: true,
      "Valea Arini": true,
      Tarpesti: true,
      Cuejdiu: true,
      Stanca: true,
      Valeni: true,
      "Cracaul Negru": true,
      "Poiana Teiului": true,
      Boghicea: true,
      Timisesti: true,
      Tolici: true,
      Lunca: true,
      Doljesti: true,
      Farcasa: true,
      Gosmani: true,
      Hociungi: true,
      Dobreni: true,
      Borca: true,
      Dumbrava: true,
      Vadurele: true,
      Grinties: true,
      Dulcesti: true,
      Romani: true,
      Budesti: true,
      Traian: true,
      Secuieni: true,
      Hlapesti: true,
      Chintinici: true,
      Filioara: true,
      Stejaru: true,
      Poienari: true,
      Chilii: true,
      Oantu: true,
      "Petru Voda": true,
      Averesti: true,
      Davideni: true,
      Pluton: true,
      Hoisesti: true,
      Boistea: true,
      Manoaia: true,
      Oslobeni: true,
      Ingaresti: true,
      Ivanes: true,
      Vaduri: true,
      Buhalnita: true,
      Madei: true,
      Pataligeni: true,
      Varatec: true,
      Cuci: true,
      Soci: true,
      Socea: true,
      Simionesti: true,
      Tetcani: true,
      Icusesti: true,
      Bahna: true,
      Bistricioara: true,
      Blebea: true,
      Vulpasesti: true,
      "Valea Ursului": true,
      Bira: true,
      Butnaresti: true,
      Poiana: true,
      Giurgeni: true,
      Bozieni: true,
      "Poiana Largului": true,
      Bradu: true,
      Curechistea: true,
      "Paraul Carjei": true,
      Plaiesu: true,
      Betesti: true,
      Razboieni: true,
      Capsa: true,
      "Razboienii de Jos": true,
      Pancesti: true,
      Barcanesti: true,
      Draganesti: true,
      Huisurez: true,
      Corhana: true,
      Recea: true,
      Magazia: true,
      Straja: true,
      Tarzia: true,
      Pangarati: true,
      Negulesti: true,
      Basta: true,
      Iucsa: true,
      Dreptu: true,
      Bucium: true,
      Frunzeni: true,
      "Manastirea Neamt": true,
      Ghigoiesti: true,
      Vad: true,
      Brasauti: true,
      Faurei: true,
      Sacalusesti: true,
      Sovoaia: true,
      "Gheraestii Noi": true,
      Caciulesti: true,
      Ciritei: true,
      Buhonca: true,
      "Gura Vaii": true,
      Preutesti: true,
      "Paraul Pantei": true,
      Ungheni: true,
      Balanesti: true,
      Almas: true,
      Neagra: true,
      Popesti: true,
      Botesti: true,
      Stanita: true,
      Solca: true,
      Leghin: true,
      Cazaci: true,
      Viisoara: true,
      Chiriteni: true,
      Grosi: true,
      Grozavesti: true,
      "Humulestii Noi": true,
      Ghidion: true,
      Savesti: true,
      "Lunca Moldovei": true,
      "Valea Alba": true,
      Vladiceni: true,
      Bahnisoara: true,
      "Tibucanii de Jos": true,
      "Izvoru Muntelui": true,
      "Muncelu de Jos": true,
      "Dumbrava Deal": true,
      Frumosu: true,
      Preluca: true,
      Negritesti: true,
      Lutca: true,
      Carlig: true,
      Sacaleni: true,
      Carligi: true,
      "Valea Enei": true,
      Brosteni: true,
      Galu: true,
      Izvoru: true,
      Todireni: true,
      Oniceni: true,
      Ortasti: true,
      Borseni: true,
      "Bozienii de Sus": true,
      "Tutcanii din Vale": true,
      "Ticos-Floarea": true,
      Itrinesti: true,
      Hamzoaia: true,
      Ciurea: true,
      Climesti: true,
      Mesteacan: true,
      Rocna: true,
      Ruginesti: true,
      Munteni: true,
      Soimaresti: true,
      Turturesti: true,
      "Mitocu Balan": true,
      Ticos: true,
      Brates: true,
      Chilia: true,
      Barjoveni: true,
      Chicerea: true,
      Talpa: true,
      Craiesti: true,
      Spiridonesti: true,
      Dornesti: true,
      Moreni: true,
      Topoliceni: true,
      Versesti: true,
      "Poienile Oancei": true,
      "Paraul Fagului": true,
      Danesti: true,
      Rosiori: true,
      Nechit: true,
      Potoci: true,
      Casaria: true,
      Doina: true,
      Totoiesti: true,
      Hartop: true,
      Gorun: true,
      Nistria: true,
      "Poiana Humei": true,
      Dragova: true,
      Padureni: true,
      Agarcia: true,
      "Izvorul Alb": true,
      Pietrosu: true,
      Bunghi: true,
      Hartesti: true,
      Bordea: true,
      Marmureni: true,
      Corni: true,
      Pustieta: true,
      Micsunesti: true,
      Veja: true,
      Darloaia: true,
      Breaza: true,
      Batranesti: true,
      Netezi: true,
      Patricheni: true,
      Causeni: true,
      Giulesti: true,
      Sarata: true,
      "Secuienii Noi": true,
      Holm: true,
      Certieni: true,
      Busmei: true,
      Baneasa: true,
      "Tardenii Mici": true,
      Bornis: true,
      Doamna: true,
      Uncesti: true,
      Talpalai: true,
      Ghelaiesti: true,
      Dragomiresti: true,
      Scaricica: true,
      Unghi: true,
      Bisericani: true,
      Dusesti: true,
      Rasca: true,
      David: true,
      "Paraul Mare": true,
      Zvoranesti: true,
      Aramoaia: true,
      Secu: true,
      Tabara: true,
      Prajesti: true,
      Liliac: true,
      Homiceni: true,
      Gherman: true,
      "Valea Mare": true,
      Bogzesti: true,
      Britcani: true,
      Vladnicele: true,
      Barnadu: true,
      Ciornei: true,
      "Poiana Cracaoani": true,
      Roseni: true,
      Muncelu: true,
      Ardeluta: true,
      "Schitu Tarcau": true,
      "Tutcanii din Deal": true,
      Calugareni: true,
      Aramesti: true,
      "Hanul Ancutei": true,
      Linsesti: true,
      Baratca: true,
      "Trei Fantani": true,
      Plugari: true,
      "Bahna Mare": true,
      Spiesti: true,
      Deleni: true,
    },
    OT: {
      Slatina: true,
      Caracal: true,
      Bals: true,
      Corabia: true,
      "Draganesti-Olt": true,
      Scornicesti: true,
      Izbiceni: true,
      Brastavatu: true,
      Vadastrita: true,
      Rusanesti: true,
      Cilieni: true,
      Traian: true,
      "Iancu Jianu": true,
      Stoicanesti: true,
      Visina: true,
      Comani: true,
      Rotunda: true,
      Ianca: true,
      Crampoia: true,
      Giuvarasti: true,
      "Osica de Sus": true,
      Coteana: true,
      Valeni: true,
      Maruntei: true,
      Falcoiu: true,
      Grojdibodu: true,
      Alimanesti: true,
      Seaca: true,
      Brebeni: true,
      Babiciu: true,
      Stoenesti: true,
      Redea: true,
      Serbanesti: true,
      Movileni: true,
      Potcoava: true,
      Scarisoara: true,
      Vitanesti: true,
      Slatioara: true,
      "Piatra-Olt": true,
      "Visina Noua": true,
      Piatra: true,
      Tufeni: true,
      Bucinisu: true,
      Balteni: true,
      Pirscoveni: true,
      Orlea: true,
      "Strejestii de Sus": true,
      "Farcasu de Jos": true,
      Gostavatu: true,
      Oboga: true,
      Vadastra: true,
      Radomiresti: true,
      Studina: true,
      Potlogeni: true,
      Urzica: true,
      Deveselu: true,
      "Valea Mare": true,
      Garcov: true,
      "Stefan cel Mare": true,
      "Tia Mare": true,
      Branet: true,
      "Gura Padinii": true,
      Slaveni: true,
      Soparlita: true,
      Izvoarele: true,
      Bacea: true,
      Cezieni: true,
      Comanca: true,
      Balanesti: true,
      Optasi: true,
      Morunglav: true,
      Potelu: true,
      Crusovu: true,
      Daneasa: true,
      "Nicolae Titulescu": true,
      Ganeasa: true,
      Ipotesti: true,
      Sprancenata: true,
      "Obarsia Noua": true,
      Carlogani: true,
      Calinesti: true,
      "Osica de Jos": true,
      Studinita: true,
      Doanca: true,
      Negreni: true,
      Vladila: true,
      Dobroteasa: true,
      Dobrosloveni: true,
      Jieni: true,
      Mihaesti: true,
      Farcasele: true,
      Curtisoara: true,
      "Valea Merilor": true,
      Brancoveni: true,
      Priseaca: true,
      Bircii: true,
      Ghimpeteni: true,
      Dobrotinet: true,
      Greci: true,
      Cepari: true,
      Dranovatu: true,
      "Potcoava Falcoeni": true,
      Corbu: true,
      Calui: true,
      "Gura Caluiu": true,
      Ursa: true,
      Valcele: true,
      Gropsani: true,
      "Valcelele de Sus": true,
      "Margineni Slobozia": true,
      Busca: true,
      Catanele: true,
      Craciunei: true,
      "Orlea Noua": true,
      Dumitresti: true,
      Dejesti: true,
      Stavaru: true,
      Ghimpati: true,
      Perieti: true,
      Sinesti: true,
      Olari: true,
      Barza: true,
      Bobicesti: true,
      Baleasa: true,
      Petculesti: true,
      Hotarani: true,
      Strejesti: true,
      Ursoaia: true,
      Barca: true,
      Vulturesti: true,
      Cioroiu: true,
      Dobriceni: true,
      Tatulesti: true,
      Obarsia: true,
      Cireasov: true,
      Barcanesti: true,
      Profa: true,
      Margheni: true,
      Izvoru: true,
      Resca: true,
      Icoana: true,
      Gavanesti: true,
      Plaviceni: true,
      Hotaru: true,
      Ociogi: true,
      Buta: true,
      Arvateasca: true,
      Teslui: true,
      Leleasca: true,
      Poganu: true,
      Draghiceni: true,
      "Arcesti Cot": true,
      Dienci: true,
      "Valea lui Alb": true,
      Frunzaru: true,
      Teis: true,
      "Tudor Vladimirescu": true,
      Turia: true,
      "Bistrita Noua": true,
      Cioflanu: true,
      Baldovinesti: true,
      "Barsestii de Sus": true,
      Margaritesti: true,
      "Serbanestii de Sus": true,
      Corbeni: true,
      "Ianca Noua": true,
      "Mierlestii de Sus": true,
      Magura: true,
      Stoborasti: true,
      Leotesti: true,
      Jitaru: true,
      Potopinu: true,
      Mogosesti: true,
      "Runcu Mare": true,
      Colonesti: true,
      Ulmi: true,
      Floru: true,
      Pestra: true,
      Redisoara: true,
      Tonesti: true,
      Vitomiresti: true,
      Grozavesti: true,
      Vartopu: true,
      Cungrea: true,
      Poboru: true,
      Constantinesti: true,
      Verguleasa: true,
      Cioroiasu: true,
      Horezu: true,
      Dobrun: true,
      Mirila: true,
      "Criva de Sus": true,
      Fagetelu: true,
      Cornatelu: true,
      Colibasi: true,
      Doba: true,
      Baltati: true,
      Milcoveni: true,
      Proaspeti: true,
      Albesti: true,
      Cocorasti: true,
      Dobretu: true,
      Racovita: true,
      Oporelu: true,
      "Ghimpetenii Noi": true,
      Pietrisu: true,
      Plesoiu: true,
      "Criva de Jos": true,
      Lisa: true,
      "Linia din Vale": true,
      Gradinile: true,
      Liiceni: true,
      Topana: true,
      Berindei: true,
      Vlangaresti: true,
      "Bucinisu Mic": true,
      Arcesti: true,
      Vladuleni: true,
      "Milcovu din Deal": true,
      Alunisu: true,
      Voineasa: true,
      "Barastii de Vede": true,
      "Campu Parului": true,
      Deleni: true,
      Pescaresti: true,
      Chiteasca: true,
      Popesti: true,
      Romana: true,
      Buicesti: true,
      "Vladila Noua": true,
      "Campu Mare": true,
      Frasinetu: true,
      Zanoaga: true,
      "Satu Nou": true,
      Rescuta: true,
      Trepteni: true,
      Corlatesti: true,
      Barasti: true,
      Comanita: true,
      "Otestii de Jos": true,
      Poiana: true,
      Saltanesti: true,
      Tomeni: true,
      "Poiana Mare": true,
      Spataru: true,
      Gradinari: true,
      Zorleasca: true,
      Bechet: true,
      Plaviceanca: true,
      Brosteni: true,
      Butoi: true,
      Vineti: true,
      Morunesti: true,
      Bulimanu: true,
      Salcia: true,
      "Mihailesti Popesti": true,
      Cazanesti: true,
      "Cherlestii din Deal": true,
      Enosesti: true,
      Stanuleasa: true,
      Cucueti: true,
      "Barastii de Cepturi": true,
      Spineni: true,
      Cepesti: true,
      Pietris: true,
      Suica: true,
      Schitu: true,
      Ciocanesti: true,
      "Rosienii Mari": true,
      Oltisoru: true,
      "Otestii de Sus": true,
      Scorbura: true,
      Belgun: true,
      "Valea Soarelui": true,
      Rusciori: true,
      Tirisneag: true,
      "Frasinet Gara": true,
      Radesti: true,
      "Schitu din Deal": true,
      Chilia: true,
      Donesti: true,
      Mosteni: true,
      "Milcovu din Vale": true,
      Guesti: true,
      "Cherlestii Mosteni": true,
      Blaj: true,
      Burdulesti: true,
      Recea: true,
      "Rosienii Mici": true,
      Mandra: true,
      Ghiosani: true,
      Carstani: true,
      "Valea Satului": true,
      Teiusu: true,
      Isaci: true,
      Bondrea: true,
      Gradistea: true,
      Miesti: true,
      "Beria de Jos": true,
      Coteni: true,
      Ibanesti: true,
      Piscani: true,
      "Valea Fetei": true,
      Tabaci: true,
      "Rusanestii de Sus": true,
      Trufinesti: true,
      Peretu: true,
      Teius: true,
      Buzesti: true,
      Ungureni: true,
      Creti: true,
      Mierlicesti: true,
      "Beria de Sus": true,
      Raitiu: true,
      Ulmet: true,
      Bobu: true,
      "Schitu Deleni": true,
      Candelesti: true,
      "Schitu din Vale": true,
      Tabonu: true,
      Bagesti: true,
      Comanesti: true,
      Samburesti: true,
      Uria: true,
      Mereni: true,
      Ionicesti: true,
      Vulpeni: true,
      Launele: true,
      Prisaca: true,
      Optasani: true,
      Plopsorelu: true,
      Afumati: true,
      Ciuresti: true,
      Mamura: true,
      Vulpesti: true,
      "Malu Rosu": true,
      Chintesti: true,
      Gubandru: true,
      Vlaici: true,
      Motoesti: true,
      Lazaresti: true,
      Cioraca: true,
      Chilii: true,
      Cojgarei: true,
      Preotesti: true,
      "Cuza Voda": true,
      Batia: true,
      Ostrov: true,
      Ursi: true,
      Manulesti: true,
      Barbalai: true,
      Beculesti: true,
      Chelbesti: true,
      Damburile: true,
      Momaiu: true,
      Mircesti: true,
      Strugurelu: true,
      Batareni: true,
      Tufaru: true,
      Cerbeni: true,
      Cotorbesti: true,
      Simniceni: true,
      Navargeni: true,
      Pielcani: true,
      Boroesti: true,
      Davidesti: true,
      Govora: true,
      Surpeni: true,
      Vanesti: true,
      Mardale: true,
      Stejaru: true,
      Greeresti: true,
      Gruiu: true,
      Lunca: true,
      Stupina: true,
      Rudari: true,
    },
    PH: {
      Ploiesti: true,
      Campina: true,
      Mizil: true,
      Sinaia: true,
      "Valenii de Munte": true,
      Baicoi: true,
      "Breaza de Sus": true,
      "Boldesti-Scaeni": true,
      Plopeni: true,
      Busteni: true,
      Urlati: true,
      Azuga: true,
      "Filipestii de Padure": true,
      Strejnicu: true,
      Floresti: true,
      Telega: true,
      Magureni: true,
      "Cioranii de Jos": true,
      Pleasa: true,
      Bucov: true,
      Comarnic: true,
      Tesila: true,
      Slanic: true,
      "Poiana Campina": true,
      "Maneciu-Pamanteni": true,
      Varbilau: true,
      Ditesti: true,
      Poiana: true,
      Starchiojd: true,
      "Brebu Manastirei": true,
      Blejoi: true,
      Ghiosesti: true,
      "Cornu de Jos": true,
      "Marginenii de Jos": true,
      Bertea: true,
      Magurele: true,
      Banesti: true,
      Barcanesti: true,
      Tintea: true,
      Tatarani: true,
      Gheaba: true,
      "Brebu Megiesesc": true,
      Alunis: true,
      Valcanesti: true,
      "Filipestii de Targ": true,
      "Poiana Tapului": true,
      "Maneciu-Ungureni": true,
      "Aricestii Rahtivani": true,
      "Valea Calugareasca": true,
      Traisteni: true,
      Ploiestiori: true,
      Urleta: true,
      "Ceptura de Jos": true,
      "Drajna de Jos": true,
      Nedelea: true,
      "Cioranii de Sus": true,
      Salciile: true,
      Pietrosani: true,
      Izvoarele: true,
      Gornet: true,
      Slon: true,
      Berceni: true,
      Fantanele: true,
      "Breaza de Jos": true,
      Tariceni: true,
      "Fulga de Sus": true,
      Sipotu: true,
      Sangeru: true,
      Liliesti: true,
      "Vadu Parului": true,
      Grosani: true,
      Inotesti: true,
      "Targsoru Vechi": true,
      Magula: true,
      Gageni: true,
      Mislea: true,
      Batrani: true,
      Homoraciu: true,
      "Cocorastii Mislii": true,
      "Baba Ana": true,
      Miroslavesti: true,
      "Gura Vitioarei": true,
      Ologeni: true,
      Romanesti: true,
      Teisani: true,
      Paulesti: true,
      "Podenii Vechi": true,
      "Albesti-Paleologu": true,
      Negoiesti: true,
      Lipanesti: true,
      "Fulga de Jos": true,
      Surani: true,
      Colceag: true,
      "Brazii de Sus": true,
      Soimari: true,
      "Miresu Mare": true,
      Popesti: true,
      Batesti: true,
      Carbunesti: true,
      Scorteni: true,
      "Bordenii Mari": true,
      "Poienarii Burchii": true,
      "Poienarii Apostoli": true,
      Loloiasca: true,
      "Puchenii Mari": true,
      Scurtesti: true,
      Posada: true,
      Minieri: true,
      Potigrafu: true,
      "Aricestii Zeletin": true,
      Secaria: true,
      Tantareni: true,
      Salcia: true,
      Dumbrava: true,
      "Puchenii Mosneni": true,
      "Provita de Sus": true,
      Dambu: true,
      "Gura Vadului": true,
      Varbila: true,
      "Provita de Jos": true,
      Pietriceaua: true,
      Corlatesti: true,
      Baltesti: true,
      Calugareni: true,
      Stoenesti: true,
      Prajani: true,
      "Parepa-Rusani": true,
      "Podu Vadului": true,
      Catina: true,
      "Poiana Varbilau": true,
      Schiulesti: true,
      Conduratu: true,
      Tufeni: true,
      "Poienarii Rali": true,
      Tinosu: true,
      Fagetu: true,
      "Ocina de Sus": true,
      "Valea Tarsei": true,
      Gorgota: true,
      Mocesti: true,
      Pantazi: true,
      Draganesti: true,
      Rachieri: true,
      Sotrile: true,
      "Drajna de Sus": true,
      Palanca: true,
      Draganeasa: true,
      Goruna: true,
      Apostolache: true,
      Crivina: true,
      Chitorani: true,
      Buda: true,
      Seciu: true,
      "Valea Dulce": true,
      "Albesti-Muru": true,
      "Lunca Prahovei": true,
      Manesti: true,
      Boldesti: true,
      Livadea: true,
      Varnita: true,
      "Targsoru Nou": true,
      Bobolia: true,
      "Coada Izvorului": true,
      Ostrovu: true,
      Gradistea: true,
      Talea: true,
      Meri: true,
      Persunari: true,
      "Cornu de Sus": true,
      "Valea Cucului": true,
      "Bughea de Jos": true,
      "Gura Beliei": true,
      "Poiana Copaceni": true,
      Plopu: true,
      Ogretin: true,
      Zalhanaua: true,
      Ungureni: true,
      "Nucsoara de Jos": true,
      Lapos: true,
      Schela: true,
      Nistoresti: true,
      Cotofenesti: true,
      Habud: true,
      "Balta Doamnei": true,
      "Olarii Vechi": true,
      "Vadu Sapat": true,
      Baraitaru: true,
      Cerasu: true,
      "Moara Domneasca": true,
      Zanoaga: true,
      Gherghita: true,
      Rotari: true,
      "Malu Vanat": true,
      "Cocorastii Caplii": true,
      Soimesti: true,
      "Valea Popii": true,
      Matita: true,
      "Moara Noua": true,
      Cioceni: true,
      Sirna: true,
      "Cocorastii Grind": true,
      Stefesti: true,
      Tisa: true,
      Baltita: true,
      Tatarai: true,
      Tomsani: true,
      Facaieni: true,
      Nisipoasa: true,
      "Ceptura de Sus": true,
      Cocosesti: true,
      Ciresanu: true,
      Fundeni: true,
      "Nucsoara de Sus": true,
      Olari: true,
      Bustenari: true,
      Carjari: true,
      "Coada Malului": true,
      Bara: true,
      Chiojdeanca: true,
      Tarculesti: true,
      Adunati: true,
      Malaiesti: true,
      Dumbravesti: true,
      Ghighiu: true,
      Lopatnita: true,
      "Valea Stalpului": true,
      Tarlesti: true,
      Olteni: true,
      Ciupelnita: true,
      "Valea Larga": true,
      Predesti: true,
      Catunu: true,
      "Plaiu Campinei": true,
      Novacesti: true,
      Belciug: true,
      Stancesti: true,
      "Brazii de Jos": true,
      "Vitioara de Sus": true,
      Plaiu: true,
      Trenu: true,
      "Podu Lung": true,
      "Podenii Noi": true,
      "Valea Nicovani": true,
      Bratesti: true,
      Coslegi: true,
      Melicesti: true,
      "Valea Plopului": true,
      Valcelele: true,
      Zamfira: true,
      Pisculesti: true,
      Plavia: true,
      Podgoria: true,
      "Valea Borului": true,
      "Bordenii Mici": true,
      Odaile: true,
      Iazu: true,
      Coserele: true,
      Curcubeu: true,
      "Cocorastii Colt": true,
      "Orzoaia de Jos": true,
      Stubeiu: true,
      Magura: true,
      Stejaru: true,
      Predeal: true,
      Darvari: true,
      Surdesti: true,
      Trestioara: true,
      Iordacheanu: true,
      Arva: true,
      "Puchenii Mici": true,
      Doftana: true,
      "Lunca Mare": true,
      Frasinet: true,
      "Malaestii de Jos": true,
      Goga: true,
      "Cartierul Dambu": true,
      Moara: true,
      Tataru: true,
      "Cosmina de Sus": true,
      Fefelei: true,
      Tiparesti: true,
      Bratasanca: true,
      "Valea Anei": true,
      Vistieru: true,
      Barzila: true,
      Hatcarau: true,
      Nucet: true,
      "Cosmina de Jos": true,
      "Valea Pietrei": true,
      "Valea Lespezii": true,
      Dobrota: true,
      Sarca: true,
      Fanari: true,
      "Gornet-Cricov": true,
      Sicrita: true,
      Rahova: true,
      Mehedinta: true,
      "Lacu Turcului": true,
      Pioresti: true,
      "Ocina de Jos": true,
      Malamuc: true,
      Calinesti: true,
      Puscasi: true,
      Marlogea: true,
      Poienile: true,
      Ezeni: true,
      "Valea Ursoii": true,
      Bobicesti: true,
      Laposel: true,
      "Valea Nucetului": true,
      Seciuri: true,
      Priseaca: true,
      Sfarleanca: true,
      "Valea Tocii": true,
      Curmatura: true,
      "Valea Bradetului": true,
      Pacureti: true,
      "Valea Poienii": true,
      Gogeasca: true,
      Sfacaru: true,
      "Coltu de Jos": true,
      Nevesteasca: true,
      "Valea Cricovului": true,
      Buzota: true,
      Izesti: true,
      "Podu Corbului": true,
      "Arionestii Vechi": true,
      Cuib: true,
      Rafov: true,
      Straosti: true,
      Cheia: true,
      Pietrisu: true,
      "Poiana Trestiei": true,
      "Valea Crangului": true,
      Maruntis: true,
      Faget: true,
      Radila: true,
      "Valea Mantei": true,
      "Cap Rosu": true,
      Butuci: true,
      Izvoru: true,
      "Podu Valeni": true,
      "Podu lui Galben": true,
      "Posestii-Pamanteni": true,
      Jugureni: true,
      "Valea Stupinii": true,
      "Paulestii Noi": true,
      Rotarea: true,
      "Malu Rosu": true,
      "Posestii Ungureni": true,
      Ghiocel: true,
      Jercalai: true,
      Harsa: true,
      "Valea Screzii": true,
      "Arionestii Noi": true,
      Bodesti: true,
      Ghioldum: true,
      Slavu: true,
      Galmeia: true,
      "Trestienii de Sus": true,
      "Miresu Mic": true,
      Cherba: true,
      Chesnoiu: true,
      "Poiana Mare": true,
      Zambroaia: true,
      "Malaestii de Sus": true,
      Silistea: true,
      "Marginea Padurii": true,
      "Podu Cheii": true,
      Independenta: true,
      Tohani: true,
      "Lutu Rosu": true,
      "Satu de Sus": true,
      "Valea Unghiului": true,
      Costeni: true,
      "Plaiu Cornului": true,
      "Gura Crivatului": true,
      "Valea Urloii": true,
      Tarsoreni: true,
      Chiciureni: true,
      "Valea Scheilor": true,
      "Piatra Mica": true,
      Zahanaua: true,
      Bighilin: true,
      Piatra: true,
      Gavanel: true,
      Pacuri: true,
      Glod: true,
      "Satu Nou": true,
      "Valea Bradului": true,
      "Valea Seaca": true,
      Ghinoaica: true,
      "Trestienii de Jos": true,
      "Valea Orlei": true,
      Boboci: true,
      Udresti: true,
      Cernesti: true,
      Carbunari: true,
      Saratel: true,
      "Poiana Mierlei": true,
      "Orzoaia de Sus": true,
      "Poienarii Vechi": true,
      Buchilasi: true,
      "Bugnea de Sus": true,
      Ragman: true,
      Bradet: true,
      Albinari: true,
      "Valea Seman": true,
      Tufani: true,
      Tulburea: true,
      Chiritesti: true,
      Bogdanesti: true,
      Varfurile: true,
      Irimesti: true,
      Satucu: true,
      Podurile: true,
      Antofiloaia: true,
      Bozieni: true,
      "Podu Ursului": true,
      "Silistea Dealului": true,
      "Manastirea Suzana": true,
      Ciocrac: true,
      "Valea Mieilor": true,
      "Tulburea Valeni": true,
      "Valea Bobului": true,
      Schiau: true,
      Bosilcesti: true,
      Pitigoi: true,
      Zmeuret: true,
      Pietricica: true,
      Sarari: true,
      Salcioara: true,
      Plai: true,
      Coceana: true,
      Tontesti: true,
      Gresia: true,
      Draghicesti: true,
      Merdeala: true,
      Crangurile: true,
      Plaietu: true,
      Ulmi: true,
      "Valea Oprii": true,
    },
    SJ: {
      Zalau: true,
      "Simleu Silvaniei": true,
      Jibou: true,
      "Cehu Silvaniei": true,
      Sarmasag: true,
      Crasna: true,
      Nusfalau: true,
      Pericei: true,
      Chiesd: true,
      Camar: true,
      Cizer: true,
      Dersida: true,
      Varsolt: true,
      Ip: true,
      Borla: true,
      Bobota: true,
      Boghis: true,
      Marca: true,
      Plopis: true,
      Surduc: true,
      Buciumi: true,
      "Somes-Odorhei": true,
      Pusta: true,
      Halmasd: true,
      Deja: true,
      Ileanda: true,
      Carastelec: true,
      Samsud: true,
      Peceiu: true,
      Marin: true,
      Aghires: true,
      Hida: true,
      "Sanmihaiu Almasului": true,
      Zauan: true,
      Almasu: true,
      Mal: true,
      "Giurtelecu Simleului": true,
      Starciu: true,
      Diosod: true,
      Tihau: true,
      Balan: true,
      Simisna: true,
      Bocsa: true,
      Ulciug: true,
      Criseni: true,
      Cehei: true,
      Agrij: true,
      Chendrea: true,
      "Horoatu Crasnei": true,
      "Mesesenii de Sus": true,
      Napradea: true,
      "Valcau de Jos": true,
      "Galgau Almasului": true,
      Badacin: true,
      Cheud: true,
      Romanasi: true,
      "Valcau de Sus": true,
      Tusa: true,
      Panic: true,
      Lompirt: true,
      Rus: true,
      Banisor: true,
      Sag: true,
      Maeriste: true,
      Galgau: true,
      Popeni: true,
      Fagetu: true,
      Jac: true,
      Cristolt: true,
      Motis: true,
      Babeni: true,
      Ilisua: true,
      Preoteasa: true,
      Garbou: true,
      Inau: true,
      Alunis: true,
      "Poiana Blenchii": true,
      Ciocmani: true,
      Notig: true,
      "Cosniciu de Jos": true,
      "Mesesenii de Jos": true,
      Zalnoc: true,
      Dragu: true,
      Letca: true,
      Doba: true,
      Chechis: true,
      "Sanpetru Almasului": true,
      Treznea: true,
      Nadis: true,
      Racas: true,
      Recea: true,
      Ban: true,
      Cuzaplac: true,
      Iaz: true,
      Sumal: true,
      Badon: true,
      Cristelec: true,
      Biusa: true,
      Guruslau: true,
      Mirsid: true,
      "Cristur Criseni": true,
      Brebi: true,
      Salajeni: true,
      Galpaia: true,
      Cerisa: true,
      Gostila: true,
      "Sighetu Silvaniei": true,
      Petrindu: true,
      Zimbor: true,
      Pria: true,
      Valeni: true,
      Ciumarna: true,
      Drighiu: true,
      Var: true,
      Benesat: true,
      Fizes: true,
      Cuceu: true,
      Solomon: true,
      Cristoltel: true,
      Pausa: true,
      "Fildu de Sus": true,
      Hasmas: true,
      "Somes Guruslau": true,
      Huseni: true,
      Archid: true,
      "Fildu de Mijloc": true,
      Lemniu: true,
      "Moigrad-Porolissum": true,
      "Uileacu Simleului": true,
      Hurez: true,
      Glod: true,
      Coseiu: true,
      "Sub Cetate": true,
      Salatig: true,
      Bilghez: true,
      Creaca: true,
      Lesmir: true,
      Mesteacanu: true,
      Fodora: true,
      "Valea Pomilor": true,
      Calacea: true,
      Seredeiu: true,
      Domnin: true,
      Hereclean: true,
      Zalha: true,
      Verveghiu: true,
      "Sangeorgiu de Meses": true,
      Bogdana: true,
      Garceiu: true,
      Popteleac: true,
      "Santa Maria": true,
      Soimus: true,
      Turbuta: true,
      "Poarta Salajului": true,
      Stana: true,
      Rona: true,
      Tamasa: true,
      Mineu: true,
      "Rastoltu Desert": true,
      "Cosniciu de Sus": true,
      Ratin: true,
      Tranis: true,
      Lozna: true,
      Aleus: true,
      Tetisu: true,
      Trestia: true,
      Voivodeni: true,
      Braglez: true,
      Poienita: true,
      Chilioara: true,
      Cozla: true,
      Dobrin: true,
      Ceaca: true,
      Capalna: true,
      Sarbi: true,
      Lazuri: true,
      Bozies: true,
      Doh: true,
      Romita: true,
      Sici: true,
      Bodia: true,
      "Valea Loznei": true,
      Jebucu: true,
      Bozna: true,
      Port: true,
      Prodanesti: true,
      "Sancraiu Almasului": true,
      "Fildu de Jos": true,
      Cernuc: true,
      Rastolt: true,
      Lupoaia: true,
      Maladia: true,
      Solona: true,
      Campia: true,
      "Fantanele Rus": true,
      Bezded: true,
      Bulgari: true,
      Chichisa: true,
      Firminis: true,
      "Barsau Mare": true,
      Cuciulat: true,
      Clit: true,
      Husia: true,
      Taudu: true,
      Vadurele: true,
      Muncel: true,
      Adalin: true,
      Borza: true,
      Galaseni: true,
      Cormenis: true,
      Mierta: true,
      "Horoatu Cehului": true,
      Stupini: true,
      Preluci: true,
      Bercea: true,
      Petrinzel: true,
      Brusturi: true,
      Moiad: true,
      "Recea Mica": true,
      Ciglean: true,
      Dabaceni: true,
      Barsa: true,
      Podisu: true,
      Plesca: true,
      Dobrocina: true,
      Purcaret: true,
      Chendremal: true,
      Rastoci: true,
      Sutoru: true,
      "Valea Hranei": true,
      "Perii Vadului": true,
      Ciula: true,
      Toplita: true,
      Ciureni: true,
      "Sancraiu Silvaniei": true,
      Sfaras: true,
      Dolheni: true,
      Baica: true,
      Buzas: true,
      Dumuslau: true,
      Pirosa: true,
      Bocsita: true,
      Ruginoasa: true,
      Soimuseni: true,
      Dolu: true,
      "Valea Lunga": true,
      Chizeni: true,
      Rogna: true,
      Miluani: true,
      Luminisu: true,
      Negreni: true,
      Babiu: true,
      Ugrutiu: true,
      Fetindia: true,
      Sasa: true,
      "Zauan Bai": true,
      "Poiana Ontii": true,
      "Colonia Sighetu Silvaniei": true,
      Ratovei: true,
      Testioara: true,
      Falcusa: true,
      Fabrica: true,
      Naimon: true,
      Cutis: true,
      Vartesca: true,
      Deleni: true,
      Valisoara: true,
      "Marca Huta": true,
      "Bizusa Bai": true,
      Cublesu: true,
      Bic: true,
      "Valea Lesului": true,
      Paduris: true,
      Fantanele: true,
      "Periceiu Mic": true,
      Stoboru: true,
      Huta: true,
      "Valea Ciurenilor": true,
      Magura: true,
      "Poiana Magura": true,
      Fufez: true,
      "Viile Jacului": true,
      Barsauta: true,
      "Francenii de Piatra": true,
      "Gura Vladesei": true,
      Maleni: true,
      Tarmure: true,
      Padureni: true,
    },
    SM: {
      "Satu Mare": true,
      Carei: true,
      "Negresti-Oas": true,
      Tasnad: true,
      Turt: true,
      Livada: true,
      Bixad: true,
      Odoreu: true,
      Ardud: true,
      Vama: true,
      Halmeu: true,
      Sanislau: true,
      Certeze: true,
      Botiz: true,
      Capleni: true,
      "Gherta Mica": true,
      Micula: true,
      Camarzana: true,
      Tarsolt: true,
      Apa: true,
      "Mediesu Aurit": true,
      Berveni: true,
      Racsa: true,
      Turulung: true,
      "Calinesti-Oas": true,
      Batarci: true,
      Lazuri: true,
      Piscolt: true,
      "Tarna Mare": true,
      Foieni: true,
      Tur: true,
      "Orasu Nou": true,
      "Viile Satu Mare": true,
      "Barsau de Sus": true,
      Vetis: true,
      Acas: true,
      Santau: true,
      Boinesti: true,
      Tiream: true,
      Pir: true,
      Petresti: true,
      "Gherta Mare": true,
      "Poiana Codrului": true,
      Porumbesti: true,
      Beltiug: true,
      Oar: true,
      Dorolt: true,
      Camin: true,
      Satmarel: true,
      Trip: true,
      Ciumesti: true,
      "Supuru de Jos": true,
      Urziceni: true,
      Andrid: true,
      "Valea Seaca": true,
      Ghenci: true,
      Dobra: true,
      Moiseni: true,
      Bogdand: true,
      Pomi: true,
      Dara: true,
      Draguseni: true,
      "Moftinu Mic": true,
      Caraseu: true,
      "Huta Certeze": true,
      Cehal: true,
      Doba: true,
      Lucaceni: true,
      Sacaseni: true,
      Potau: true,
      Decebal: true,
      Craidorolt: true,
      Sarauad: true,
      Iojib: true,
      Cidreag: true,
      Domanesti: true,
      Stana: true,
      Agris: true,
      Babta: true,
      Madaras: true,
      "Moftinu Mare": true,
      Hodod: true,
      Dumbrava: true,
      Ambud: true,
      Lechinta: true,
      Coca: true,
      Borlesti: true,
      Ser: true,
      "Valea Vinului": true,
      Amati: true,
      "Giurtelecu Hododului": true,
      Nisipeni: true,
      Cehalut: true,
      Prilog: true,
      Comlausa: true,
      Giorocuta: true,
      Dindesti: true,
      Romanesti: true,
      "Barsau de Jos": true,
      Peles: true,
      "Nadisu Hododului": true,
      Boghis: true,
      Paulesti: true,
      Ghirisa: true,
      "Culciu Mare": true,
      Ratesti: true,
      Chereusa: true,
      Luna: true,
      Cauas: true,
      Lelei: true,
      Crucisor: true,
      "Eriu Sancrai": true,
      Babasesti: true,
      Lipau: true,
      "Culciu Mic": true,
      "Remetea Oasului": true,
      Gerausa: true,
      "Homorodu de Mijloc": true,
      "Baba Novac": true,
      Bocicau: true,
      Iegheriste: true,
      Petin: true,
      Rosiori: true,
      Tataresti: true,
      Hrip: true,
      Terebesti: true,
      Unimat: true,
      "Hurezu Mare": true,
      Bercu: true,
      Irina: true,
      Piscari: true,
      Mihaieni: true,
      Gelu: true,
      Sai: true,
      Corund: true,
      Adrian: true,
      Vezendiu: true,
      Cig: true,
      Soconzel: true,
      Becheni: true,
      Cuta: true,
      Tamaseni: true,
      Ciuperceni: true,
      "Scarisoara Noua": true,
      "Supuru de Sus": true,
      Paulian: true,
      Solduba: true,
      Mesteacan: true,
      Corod: true,
      Resighea: true,
      Ianculesti: true,
      "Orasu Nou-Vii": true,
      "Micula Noua": true,
      Babesti: true,
      Orbau: true,
      Aliceni: true,
      Socond: true,
      "Homorodu de Jos": true,
      Sauca: true,
      "Prilog Vii": true,
      Ghilvaci: true,
      "Homorodu de Sus": true,
      Hodisa: true,
      Someseni: true,
      Marius: true,
      Sirlau: true,
      Atea: true,
      Sanmiclaus: true,
      Racova: true,
      Dobolt: true,
      "Marna Noua": true,
      Necopoi: true,
      Medisa: true,
      Cean: true,
      "Livada Mica": true,
      "Medies Vii": true,
      Noroieni: true,
      Apateu: true,
      Chilia: true,
      Petea: true,
      "Dindestiu Mic": true,
      "Pasunea Mare": true,
      Chegea: true,
      Ruseni: true,
      "Racsa Vii": true,
      "Bercu Nou": true,
      "Medies Raturi": true,
      Pelisor: true,
      "Turulung Vii": true,
      Blaja: true,
      Horea: true,
      Criseni: true,
      Dacia: true,
      Bicau: true,
      Portita: true,
      "Urziceni Padure": true,
      Hotoan: true,
      Giungi: true,
      "Satu Mic": true,
      Martinesti: true,
      Sandra: true,
      Sudurau: true,
      Berea: true,
      "Valea Morii": true,
      Sarvazel: true,
      Aciua: true,
      Cionchesti: true,
      Silvas: true,
      "Ady Endre": true,
      Traian: true,
      Bolda: true,
      Ghilesti: true,
      Radulesti: true,
      Ghirolt: true,
      Chisau: true,
      "Turt Bai": true,
      "Ardud-Vii": true,
      Istrau: true,
      Tireac: true,
      Secheresa: true,
      Berindan: true,
      "Piru Nou": true,
      Ratiu: true,
      Teghea: true,
      Vanatoresti: true,
      "Halmeu Vii": true,
      Aliza: true,
      "Lunca Apei": true,
      Viisoara: true,
      Cucu: true,
      Eteni: true,
      Ganas: true,
      Saratura: true,
      Vagas: true,
    },
    SB: {
      Sibiu: true,
      Medias: true,
      Cisnadie: true,
      Agnita: true,
      Avrig: true,
      Dumbraveni: true,
      Talmaciu: true,
      Rasinari: true,
      "Copsa Mica": true,
      Jina: true,
      "Ocna Sibiului": true,
      "Gura Raului": true,
      "Seica Mare": true,
      Orlat: true,
      Marsa: true,
      "Poiana Sibiului": true,
      Cristian: true,
      Saliste: true,
      Sadu: true,
      Slimnic: true,
      Racovita: true,
      "Sura Mare": true,
      "Axente Sever": true,
      Vurpar: true,
      Darlos: true,
      "Turnu Rosu": true,
      "Miercurea Sibiului": true,
      Brateiu: true,
      Mosna: true,
      Blajel: true,
      Selimbar: true,
      Poplaca: true,
      Bazna: true,
      Vestem: true,
      "Saros pe Tarnave": true,
      Boita: true,
      Boian: true,
      Biertan: true,
      "Sura Mica": true,
      Micasasa: true,
      Agarbiciu: true,
      "Apoldu de Sus": true,
      "Valea Viilor": true,
      Nou: true,
      "Colonia Tarnava": true,
      Talmacel: true,
      Laslea: true,
      Tarnava: true,
      Tilisca: true,
      "Ighisu Nou": true,
      "Arpasu de Sus": true,
      Atel: true,
      Cartisoara: true,
      Rosia: true,
      "Apoldu de Jos": true,
      Altina: true,
      "Seica Mica": true,
      Nocrich: true,
      Ruja: true,
      "Arpasu de Jos": true,
      "Porumbacu de Jos": true,
      Bradu: true,
      Carta: true,
      Hoghilag: true,
      Malancrav: true,
      Alamor: true,
      Smig: true,
      "Porumbacu de Sus": true,
      Rusi: true,
      Barghis: true,
      Alma: true,
      "Sebesu de Sus": true,
      "Sebesu de Jos": true,
      Coves: true,
      Pauca: true,
      Chirpar: true,
      Tapu: true,
      Curciu: true,
      Armeni: true,
      Iacobeni: true,
      Daia: true,
      Bradeni: true,
      "Rau Sadului": true,
      Loamnes: true,
      Merghindeal: true,
      Sacadate: true,
      Scoreiu: true,
      Mohu: true,
      Buzd: true,
      Hosman: true,
      "Bogatu Roman": true,
      Richis: true,
      Sorostin: true,
      Casolt: true,
      Buia: true,
      Dobarca: true,
      Hamba: true,
      Velt: true,
      "Dealu Frumos": true,
      Hasag: true,
      Valchid: true,
      Retis: true,
      Ludos: true,
      Presaca: true,
      Rusciori: true,
      Boarta: true,
      Rod: true,
      Marpod: true,
      Bungard: true,
      Sacel: true,
      Paucea: true,
      Nemsa: true,
      "Nou Sasesc": true,
      Bruiu: true,
      "Copsa Mare": true,
      Cornatel: true,
      Ernea: true,
      Pelisor: true,
      Stejarisu: true,
      Motis: true,
      "Noul Roman": true,
      Sibiel: true,
      Sarata: true,
      Cisnadioara: true,
      Vale: true,
      Brosteni: true,
      Noistat: true,
      Netus: true,
      Mag: true,
      Amnas: true,
      "Ighisu Vechi": true,
      Aciliu: true,
      Sangatin: true,
      Mandra: true,
      Gusu: true,
      Movile: true,
      Gales: true,
      Fofeldea: true,
      "Alma Vii": true,
      Soala: true,
      Vard: true,
      Somartin: true,
      Fantanele: true,
      Giacas: true,
      Mihaileni: true,
      Prod: true,
      Veseud: true,
      Benesti: true,
      "Ghijasa de Sus": true,
      Metis: true,
      Lotrioara: true,
      Glamboaca: true,
      Dupus: true,
      "Valea Lunga": true,
      Apos: true,
      Toparcea: true,
      Ilimbav: true,
      Stenea: true,
      Roandola: true,
      "Colonia Talmaciu": true,
      Sasaus: true,
      Chesler: true,
      Colun: true,
      Teline: true,
      Prislop: true,
      Zlagna: true,
      Moardas: true,
      Ravasel: true,
      Vecerd: true,
      Tichindeal: true,
      Floresti: true,
      "Ghijasa de Jos": true,
      Nucet: true,
      Salcau: true,
      Romanesti: true,
      Petis: true,
      Gherdeal: true,
      Paltinis: true,
      Poienita: true,
      Valeni: true,
      Albi: true,
      Sadinca: true,
      Mighindoala: true,
      Lazaret: true,
      Paltin: true,
      Padureni: true,
      Crint: true,
    },
    SV: {
      Suceava: true,
      Falticeni: true,
      Radauti: true,
      "Campulung Moldovenesc": true,
      "Vatra Dornei": true,
      "Gura Humorului": true,
      "Vicovu de Sus": true,
      Siret: true,
      Marginea: true,
      Dumbraveni: true,
      Cajvana: true,
      Bosanci: true,
      "Vicovu de Jos": true,
      Straja: true,
      Arbore: true,
      Baia: true,
      Volovat: true,
      Liteni: true,
      "Horodnic de Sus": true,
      Dornesti: true,
      Bogdanesti: true,
      "Fratautii Noi": true,
      Ostra: true,
      Bilca: true,
      Patrauti: true,
      Vama: true,
      Dolhasca: true,
      Iaslovat: true,
      Malini: true,
      Brosteni: true,
      Voitinel: true,
      Milisauti: true,
      Ipotesti: true,
      Stulpicani: true,
      Frasin: true,
      Hantesti: true,
      Paltinoasa: true,
      "Fratautii Vechi": true,
      Siminicea: true,
      Radaseni: true,
      Corocaiesti: true,
      Pojorata: true,
      Solca: true,
      Bivolaria: true,
      "Satu Mare": true,
      Plopeni: true,
      Adancata: true,
      Botosana: true,
      "Capu Codrului": true,
      "Horodnic de Jos": true,
      Rasca: true,
      Stroiesti: true,
      "Sfantu Ilie": true,
      Calafindesti: true,
      Salcea: true,
      Sadova: true,
      Putna: true,
      Moldovita: true,
      Iacobeni: true,
      "Vatra Moldovitei": true,
      "Manastirea Humorului": true,
      Frumosu: true,
      "Capu Campului": true,
      "Mitocu Dragomirnei": true,
      Udesti: true,
      Darmanesti: true,
      Mihoveni: true,
      Scheia: true,
      Ilisesti: true,
      "Partestii de Jos": true,
      Rotunda: true,
      Stamate: true,
      Granicesti: true,
      Berchisesti: true,
      Hartop: true,
      "Fundu Moldovei": true,
      "Dolhestii-Mari": true,
      "Poieni-Solca": true,
      Gainesti: true,
      Serbauti: true,
      Maneuti: true,
      Gramesti: true,
      Boroaia: true,
      "Ciprian Porumbescu": true,
      Preutesti: true,
      Burla: true,
      "Partestii de Sus": true,
      Dragoiesti: true,
      Probota: true,
      Crucea: true,
      Slatina: true,
      Gulia: true,
      Paraie: true,
      Costisa: true,
      Balaceana: true,
      Maritei: true,
      Basarabi: true,
      Solonet: true,
      Paltinu: true,
      "Neagra Sarului": true,
      "Valea Moldovei": true,
      Veresti: true,
      Galanesti: true,
      Baisesti: true,
      Todiresti: true,
      Balcauti: true,
      Bucsoaia: true,
      Draguseni: true,
      "Dorna Candrenilor": true,
      Bursuceni: true,
      Badeuti: true,
      Negostina: true,
      Mironu: true,
      Budeni: true,
      Varatec: true,
      Cacica: true,
      Lamaseni: true,
      Bogata: true,
      "Moldova-Sulita": true,
      Costana: true,
      Zamostea: true,
      "Moara Nica": true,
      Sucevita: true,
      Herla: true,
      "Dolhestii Mici": true,
      Clit: true,
      Comanesti: true,
      Breaza: true,
      "Vadu Moldovei": true,
      Tibeni: true,
      Braiesti: true,
      "Gura Putnei": true,
      "Poiana Marului": true,
      Calinesti: true,
      Roscani: true,
      Horodniceni: true,
      Arghira: true,
      Cotargasi: true,
      Voievodeasa: true,
      Falcau: true,
      "Dorna-Arini": true,
      Plutonita: true,
      Parhauti: true,
      Ciocanesti: true,
      Banesti: true,
      "Cornu Luncii": true,
      Prelipca: true,
      Stramtura: true,
      Zvoristea: true,
      Serbanesti: true,
      Fantanele: true,
      Hurjuieni: true,
      Plavalari: true,
      Negrileasa: true,
      Carlibaba: true,
      Mihaiesti: true,
      Argel: true,
      Colacu: true,
      Dumbravita: true,
      Oniceni: true,
      Demacusa: true,
      Humoreni: true,
      "Cotu Baii": true,
      Buda: true,
      "Poiana Negrii": true,
      Manolea: true,
      "Valea Glodului": true,
      "Fantana Mare": true,
      "Izvoarele Sucevei": true,
      Holda: true,
      Leucusesti: true,
      Gemenea: true,
      "Prisaca Dornei": true,
      "Poiana Micului": true,
      "Sasca Mica": true,
      Brodina: true,
      Barasti: true,
      Doroteia: true,
      Zaharesti: true,
      Deia: true,
      Hancea: true,
      Coverca: true,
      Petia: true,
      Dealu: true,
      "Moara Carp": true,
      Danila: true,
      Tisauti: true,
      Slatioara: true,
      Silistea: true,
      "Valea Bourei": true,
      Benia: true,
      "Valeni-Stanisoara": true,
      Soldanesti: true,
      Panaci: true,
      Corni: true,
      "Silistea Noua": true,
      Voronet: true,
      Giurgesti: true,
      Lisaura: true,
      Deleni: true,
      Botus: true,
      Lupcina: true,
      Moisa: true,
      Paiseni: true,
      "Poiana Stampei": true,
      Argestru: true,
      Bradatel: true,
      Plesesti: true,
      Uncesti: true,
      Slobozia: true,
      Calugareni: true,
      Molid: true,
      "Solonetu Nou": true,
      Forasti: true,
      Mitocasi: true,
      Mazanaesti: true,
      Husi: true,
      Stirbat: true,
      "Sasca Mare": true,
      "Dealu Floreni": true,
      Chiliseni: true,
      Beresti: true,
      Boura: true,
      "Tarna Mare": true,
      Sacuta: true,
      Bulai: true,
      "Gura Haitii": true,
      Climauti: true,
      Salageni: true,
      Stanca: true,
      "Vadu Negrilesei": true,
      "Slobozia Sucevei": true,
      Vascauti: true,
      Romanesti: true,
      Nigotesti: true,
      Fetesti: true,
      Iacobesti: true,
      Bunesti: true,
      Manastioara: true,
      "Sarul Dornei": true,
      Bobeica: true,
      Poiana: true,
      Cosna: true,
      Luncusoara: true,
      "Sarisoru Mare": true,
      Giulesti: true,
      Ortoaia: true,
      Balinesti: true,
      Rosu: true,
      Holdita: true,
      "Gura Solcii": true,
      Nicani: true,
      "Valea Poienei": true,
      Botesti: true,
      Ciumulesti: true,
      Lipoveni: true,
      Cozanesti: true,
      Neagra: true,
      Padureni: true,
      Corlata: true,
      "Rusii-Manastioara": true,
      Dumbrava: true,
      Reuseni: true,
      Tolesti: true,
      Rusi: true,
      Ciumarna: true,
      Rotopanesti: true,
      Podeni: true,
      Nisipitu: true,
      Tesna: true,
      Ulma: true,
      "Brodina de Jos": true,
      Botos: true,
      "Carlibaba Noua": true,
      Hreatca: true,
      Ioneasa: true,
      Dragosa: true,
      Grigoresti: true,
      "Poieni-Suceava": true,
      "Saru Bucovinei": true,
      "Botosanita Mare": true,
      Gropeni: true,
      "Podu Cosnei": true,
      Dornisoara: true,
      Osoi: true,
      Magura: true,
      Bainet: true,
      Sadau: true,
      Costileva: true,
      Spataresti: true,
      Brasca: true,
      Antoceni: true,
      "Valea Putnei": true,
      "Breaza de Sus": true,
      Gara: true,
      Mestecanis: true,
      Rosiori: true,
      Meresti: true,
      "Vornicenii Mari": true,
      Glodu: true,
      Bodnareni: true,
      Musenita: true,
      Racova: true,
      Chiril: true,
      Lucacesti: true,
      Lunca: true,
      Jahalia: true,
      Rusca: true,
      Poienari: true,
      Gheorghiteni: true,
      Lungeni: true,
      Pilugani: true,
      Haleasa: true,
      Mesteceni: true,
      Sunatori: true,
      Vicsani: true,
      Cojoci: true,
      Movileni: true,
      "Botosanita Mica": true,
      Iaz: true,
      Mereni: true,
      Ciomartan: true,
      "Parau Negrei": true,
      Dragoiasa: true,
      Pocoleni: true,
      "Plaiu Sarului": true,
      Cumparatura: true,
      "Mariteia Mica": true,
      Sinca: true,
      Ehreste: true,
      Plesa: true,
      Sarisor: true,
      "Calinesti-Vasilache": true,
      Tibau: true,
      Badragi: true,
      "Sasca Noua": true,
      Darmoxa: true,
      "Valea Bancului": true,
      Securiceni: true,
      "Cotu Dobei": true,
      Frumoasa: true,
      Tautesti: true,
      Tataru: true,
      Iedu: true,
      Casoi: true,
      Runcu: true,
      Zalomestra: true,
      Paltin: true,
      Praleni: true,
      Tarnicioara: true,
      Rudesti: true,
      Botusel: true,
      Uidesti: true,
      Cojocareni: true,
      Stancuta: true,
      Dragomirna: true,
      Praxia: true,
      Sarghiesti: true,
      Bancesti: true,
      Verbia: true,
      Camarzani: true,
      Maidan: true,
      "Bahna Arin": true,
      Cununschi: true,
      Jacota: true,
      Corpaci: true,
      Valcelele: true,
      Vercicani: true,
      "Valea Stanei": true,
      "Varfu Dealului": true,
      Delnita: true,
      Pietroasa: true,
      Branistea: true,
      Paltinis: true,
      Rauteni: true,
      Delut: true,
      "Vornicenii Mici": true,
      Codru: true,
      "Trei Movile": true,
      Florinta: true,
      Todireni: true,
      Dubiusca: true,
      Catrinari: true,
      Norocu: true,
      Obcina: true,
      "Smida Ungurenilor": true,
      "Gara Leu": true,
      Sesuri: true,
      Varvata: true,
      Vulturesti: true,
      Artari: true,
      Plai: true,
      "Groapa Vladichii": true,
      Iesle: true,
      Ses: true,
    },
    TR: {
      Alexandria: true,
      "Rosiori de Vede": true,
      "Turnu Magurele": true,
      Zimnicea: true,
      Videle: true,
      Peretu: true,
      Plosca: true,
      Tiganesti: true,
      Islaz: true,
      Bragadiru: true,
      Maldaeni: true,
      Buzescu: true,
      Piatra: true,
      "Draganesti-Vlasca": true,
      Dobrotesti: true,
      Pietrosani: true,
      Contesti: true,
      Cervenia: true,
      Lita: true,
      Poroschia: true,
      Troianul: true,
      Nanov: true,
      Suhaia: true,
      "Orbeasca de Sus": true,
      Izvoarele: true,
      Branceni: true,
      "Silistea-Gumesti": true,
      Mavrodin: true,
      "Ciolanestii din Deal": true,
      "Orbeasca de Jos": true,
      Lunca: true,
      "Slobozia Mandra": true,
      Blejesti: true,
      Scrioastea: true,
      Laceni: true,
      Traian: true,
      Viisoara: true,
      Frasinet: true,
      Babaita: true,
      Fantanele: true,
      Smardioasa: true,
      Zambreasca: true,
      Olteni: true,
      Bujoru: true,
      Magura: true,
      Saelele: true,
      "Valea Ciresului": true,
      Frumoasa: true,
      Nenciulesti: true,
      Storobaneasa: true,
      "Tatarastii de Jos": true,
      Lisa: true,
      Tarnava: true,
      Crangeni: true,
      Beiu: true,
      "Merenii de Jos": true,
      Mosteni: true,
      Seaca: true,
      Udupu: true,
      Calinesti: true,
      Nasturelu: true,
      Galateni: true,
      "Segarcea-Deal": true,
      Cernetu: true,
      Dracea: true,
      Poeni: true,
      Sfintesti: true,
      Bascoveni: true,
      Botoroaga: true,
      Ciuperceni: true,
      Merisani: true,
      Silistea: true,
      Beuca: true,
      Putineiu: true,
      "Vartoapele de Sus": true,
      "Merenii de Sus": true,
      Deparati: true,
      Bacalesti: true,
      Beciu: true,
      "Radoiesti-Deal": true,
      Gratia: true,
      "Perii Brosteni": true,
      Salcia: true,
      Furculesti: true,
      Brancoveanca: true,
      Balaci: true,
      "Tatarastii de Sus": true,
      "Segarcea-Vale": true,
      Spatarei: true,
      Bogdana: true,
      "Draganesti de Vede": true,
      "Talpa-Ograzile": true,
      "Vartoapele de Jos": true,
      Moldoveni: true,
      Baneasa: true,
      Draghinesti: true,
      Purani: true,
      Baciu: true,
      Zimnicele: true,
      "Uda-Paciurea": true,
      Guruieni: true,
      Crangu: true,
      Navodari: true,
      Teleormanu: true,
      Crevenicu: true,
      Calomfiresti: true,
      Baduleasa: true,
      Olteanca: true,
      Calugaru: true,
      Pleasov: true,
      "Trivalea-Mosteni": true,
      Tecuci: true,
      "Calmatuiu de Sus": true,
      Copaceanca: true,
      Cosmesti: true,
      "Tudor Vladimirescu": true,
      "Nicolae Balcescu": true,
      "Uda-Clocociov": true,
      Socetu: true,
      Dracsenei: true,
      Rasmiresti: true,
      Dudu: true,
      Prundu: true,
      "Valea Parului": true,
      Poiana: true,
      Stejaru: true,
      Cucueti: true,
      Garagau: true,
      Sarbeni: true,
      Calmatuiu: true,
      "Ciolanestii din Vale": true,
      Bratasani: true,
      Brebina: true,
      Necsesti: true,
      "Balta Sarata": true,
      "Plopii-Slavitesti": true,
      Vanatori: true,
      "Radoiesti-Vale": true,
      "Puranii de Sus": true,
      Ciurari: true,
      Ulmeni: true,
      Clanita: true,
      Butesti: true,
      Licuriciu: true,
      Slavesti: true,
      Voievoda: true,
      Comoara: true,
      Vitanesti: true,
      Bujoreni: true,
      Albesti: true,
      Marzanesti: true,
      Pauleasca: true,
      Urluiu: true,
      Vedea: true,
      Negreni: true,
      Udeni: true,
      Dulceanca: true,
      Didesti: true,
      "Ciurari-Deal": true,
      "Paru Rotund": true,
      Vacaresti: true,
      "Scurtu Mare": true,
      Radulesti: true,
      Soimu: true,
      Dracsani: true,
      Cetatea: true,
      Dorobantu: true,
      Secara: true,
      Cosoteni: true,
      Meri: true,
      "Satu Nou": true,
      Belciug: true,
      "Talpa-Bascoveni": true,
      Baldovinesti: true,
      "Schitu Poienari": true,
      Dracesti: true,
      Butculesti: true,
      Prunaru: true,
      Saceni: true,
      "Negrenii de Sus": true,
      Smardan: true,
      Caravaneti: true,
      Ionascu: true,
      Cosoaia: true,
      Carlomanu: true,
      Preajba: true,
      Sericu: true,
      Vatasi: true,
      Catunu: true,
      Lada: true,
      Antonesti: true,
      Odobeasca: true,
      "Silistea Mica": true,
      Albeni: true,
      Vaceni: true,
      Rotaresti: true,
      "Sarbenii de Jos": true,
      Florica: true,
      "Scurtu-Slavesti": true,
      Gardesti: true,
      Insuratei: true,
      "Magura cu Liliac": true,
      Plopi: true,
      Vatra: true,
      Brosteanca: true,
      Tunari: true,
      Negrilesti: true,
      Burdeni: true,
      "Valea Postei": true,
      "Linia Costii": true,
      Gradisteanca: true,
      "Negrenii-Osebiti": true,
      Bratcovu: true,
      Ludaneasca: true,
      Dobreni: true,
      Banov: true,
      "Barsestii de Jos": true,
      Stefeni: true,
      "Satul Vechi": true,
      Gresia: true,
      Dulceni: true,
      Zlata: true,
      Bratesti: true,
      Marita: true,
      "Talpa Postei": true,
      Tavarlau: true,
      Obartu: true,
      Viile: true,
      Darvas: true,
    },
    TM: {
      Timisoara: true,
      Lugoj: true,
      "Sannicolau Mare": true,
      Jimbolia: true,
      Deta: true,
      Buzias: true,
      Recas: true,
      Periam: true,
      "Dudestii Vechi": true,
      Giarmata: true,
      Faget: true,
      Gataia: true,
      Varias: true,
      Cenad: true,
      Carpinis: true,
      Jebel: true,
      Sacalaz: true,
      Lovrin: true,
      Ghiroda: true,
      Biled: true,
      Nadrag: true,
      "Comlosu Mare": true,
      Liebling: true,
      Ciacova: true,
      "Peciu Nou": true,
      Tomnatic: true,
      Satchinez: true,
      Sag: true,
      Sanandrei: true,
      Saravale: true,
      Dumbravita: true,
      "Teremia Mare": true,
      "Becicherecu Mic": true,
      Costeiu: true,
      "Iecea Mare": true,
      Ortisoara: true,
      "Dudestii Noi": true,
      Denta: true,
      Cenei: true,
      Sandra: true,
      Giroc: true,
      "Sanpetru Mare": true,
      Pesac: true,
      Voiteg: true,
      Grabat: true,
      Ghilad: true,
      Chisoda: true,
      Checea: true,
      Gottlob: true,
      Bulgarus: true,
      Carani: true,
      Utvin: true,
      Banloc: true,
      Fibis: true,
      "Sanmihaiu Roman": true,
      "Beregsau Mare": true,
      Gavojdia: true,
      Padureni: true,
      Tormac: true,
      Belint: true,
      Lenauheim: true,
      Gelu: true,
      Bacova: true,
      Parta: true,
      Darova: true,
      "Jamu Mare": true,
      Izvin: true,
      "Giarmata-Vii": true,
      Valcani: true,
      Igris: true,
      Rachita: true,
      "Sacosu Mare": true,
      Uivar: true,
      Manastiur: true,
      "Mosnita Veche": true,
      "Topolovatu Mare": true,
      Foeni: true,
      Pischia: true,
      "Mosnita Noua": true,
      "Colonia Fabricii": true,
      "Cheveresu Mare": true,
      Livezile: true,
      "Remetea Mare": true,
      "Iecea Mica": true,
      Hodoni: true,
      Nitchidorf: true,
      Urseni: true,
      Moravita: true,
      Giulvaz: true,
      Bucovat: true,
      Sculia: true,
      Birda: true,
      Margina: true,
      "Beba Veche": true,
      Nerau: true,
      "Sanmartinu Sarbesc": true,
      Alios: true,
      Dinias: true,
      Dumbrava: true,
      Chizatau: true,
      Racovita: true,
      Silagiu: true,
      Cerneteaz: true,
      Bobda: true,
      "Comlosu Mic": true,
      "Stamora Germana": true,
      Bazos: true,
      Hitias: true,
      Sipet: true,
      "Bencecu de Sus": true,
      "Ohaba-Forgaci": true,
      Ianova: true,
      Masloc: true,
      Maguri: true,
      Otelec: true,
      Iohanisfeld: true,
      Clopodia: true,
      Curtea: true,
      "Beregsau Mic": true,
      Bethausen: true,
      Cebza: true,
      Criciova: true,
      Tipari: true,
      Lugojel: true,
      "Sacosu Turcesc": true,
      Petroman: true,
      Pustinis: true,
      Calacea: true,
      Boldur: true,
      Giera: true,
      Fardea: true,
      "Sanmihaiu German": true,
      Uliuc: true,
      Romanesti: true,
      Rudna: true,
      "Petroasa Mare": true,
      Jdioara: true,
      Stiuca: true,
      Opatita: true,
      Temeresti: true,
      Balint: true,
      Bichigi: true,
      Covaci: true,
      Seceani: true,
      Sinersig: true,
      Brestea: true,
      Barateaz: true,
      "Ictar-Budinti": true,
      Cheglevici: true,
      Ferendia: true,
      Sangeorge: true,
      Branesti: true,
      Herendesti: true,
      Iosifalau: true,
      "Sanpetru Mic": true,
      Jena: true,
      Ivanda: true,
      Cladova: true,
      Cornesti: true,
      "Crai Nou": true,
      Soca: true,
      Sintesti: true,
      "Teremia Mica": true,
      Leucusesti: true,
      Dolat: true,
      Jupani: true,
      Sanovita: true,
      Murani: true,
      Obad: true,
      Bodo: true,
      Rauti: true,
      Uihei: true,
      Visag: true,
      Lunga: true,
      Cherestur: true,
      Berini: true,
      "Remetea Mica": true,
      Jabar: true,
      Batesti: true,
      Folea: true,
      Partos: true,
      Cosava: true,
      Cliciova: true,
      "Gladna Romana": true,
      "Luncanii de Jos": true,
      Herneacova: true,
      Ficatar: true,
      Dragsina: true,
      Cruceni: true,
      Dragoiesti: true,
      Butin: true,
      "Victor Vlad Delamarina": true,
      Macedonia: true,
      Stanciova: true,
      Sustra: true,
      "Traian Vuia": true,
      Targoviste: true,
      Vucova: true,
      "Ohaba Lunga": true,
      "Remetea-Lunca": true,
      Susani: true,
      "Surducu Mic": true,
      "Semlacu Mare": true,
      "Rovinita Mare": true,
      Cutina: true,
      Hodos: true,
      "Begheiu Mic": true,
      Tomesti: true,
      Dragomiresti: true,
      Ciresu: true,
      Tapia: true,
      Poganesti: true,
      Sudrias: true,
      Barna: true,
      "Bunea Mare": true,
      Gherman: true,
      Crivina: true,
      Pietroasa: true,
      Salbagel: true,
      "Bencecu de Jos": true,
      Dubesti: true,
      "Stamora Romana": true,
      "Ohaba Romana": true,
      Petrovaselo: true,
      Latunas: true,
      Ofsenita: true,
      Paniova: true,
      Honorici: true,
      Ghizela: true,
      Toager: true,
      Capat: true,
      Albina: true,
      Gruni: true,
      Brestovat: true,
      Olosag: true,
      Sarbova: true,
      Cadar: true,
      Percosova: true,
      Poieni: true,
      Vizejdia: true,
      Babsa: true,
      Zgribesti: true,
      Cerna: true,
      Paru: true,
      Iosif: true,
      Unip: true,
      Otvesti: true,
      Farasesti: true,
      "Bazosu Nou": true,
      Fadimac: true,
      Icloda: true,
      Hezeris: true,
      Duboz: true,
      "Sanmartinu Maghiar": true,
      Cosarii: true,
      Buzad: true,
      Zolt: true,
      Breazova: true,
      Manastire: true,
      Dejan: true,
      Drinova: true,
      Cralovat: true,
      "Crivina de Sus": true,
      Botinesti: true,
      Saceni: true,
      Gad: true,
      "Matnicu Mic": true,
      Jupanesti: true,
      Iersnic: true,
      Granicerii: true,
      Bara: true,
      "Costeiu de Sus": true,
      "Gaiu Mic": true,
      Nevrincea: true,
      Berecuta: true,
      Juresti: true,
      Secas: true,
      Povargina: true,
      "Semlacu Mic": true,
      "Colonia Mica": true,
      Dragsinesti: true,
      Blajova: true,
      Homojdia: true,
      Balosesti: true,
      "Gladna Montana": true,
      Rudicica: true,
      Hauzesti: true,
      Sarazani: true,
      Tes: true,
      Grosi: true,
      "Valea Lunga Romana": true,
      "Topolovatu Mic": true,
      Charlotenburg: true,
      Hisias: true,
      Botesti: true,
      Zorani: true,
      Padurani: true,
      Lucaret: true,
      Pordeanu: true,
      "Colonia Bulgara": true,
      Bogda: true,
      Lapusnic: true,
      Pini: true,
      Bulza: true,
      Crivobara: true,
      Radmanesti: true,
      Cosevita: true,
      Nemesesti: true,
      "Luncanii de Sus": true,
      Comeat: true,
      Dobresti: true,
      "Salciua Noua": true,
      Altringen: true,
      "Rovinita Mica": true,
      Sintar: true,
      Spata: true,
      Vizma: true,
      Topla: true,
      "Bunea Mica": true,
      Cheches: true,
      "Ciresu Mic": true,
      Nadas: true,
    },
    TL: {
      Tulcea: true,
      Macin: true,
      Babadag: true,
      Sulina: true,
      Greci: true,
      Niculitel: true,
      Isaccea: true,
      Carcaliu: true,
      Sarichioi: true,
      Jijila: true,
      Turcoaia: true,
      Luncavita: true,
      Jurilovca: true,
      Baia: true,
      Mahmudia: true,
      "Chilia Veche": true,
      Daeni: true,
      Cerna: true,
      Topolog: true,
      Ostrov: true,
      Vacareni: true,
      Somova: true,
      "Mihail Kogalniceanu": true,
      Peceneaga: true,
      Bestepe: true,
      Izvoarele: true,
      Zebil: true,
      Agighiol: true,
      "Valea Teilor": true,
      "Slava Cercheza": true,
      Casimcea: true,
      "Slava Rusa": true,
      Mineri: true,
      Salcioara: true,
      Murighiol: true,
      Ciucurova: true,
      Grindu: true,
      Garvan: true,
      Lunca: true,
      "Valea Nucarilor": true,
      Traian: true,
      Cataloi: true,
      "Ceamurlia de Jos": true,
      Turda: true,
      Enisala: true,
      Horia: true,
      Nalbant: true,
      Smardan: true,
      Frecatei: true,
      "I.c.bratianu": true,
      "Nicolae Balcescu": true,
      Iazurile: true,
      Malcoci: true,
      Nufaru: true,
      "Sfantu Gheorghe": true,
      Rachelu: true,
      "Ceamurlia de Sus": true,
      Stejaru: true,
      Dorobantu: true,
      "Mina Altan Tepe": true,
      Visina: true,
      Parches: true,
      Razboieni: true,
      Nifon: true,
      Pardina: true,
      "Fagarasu Nou": true,
      "Satu Nou": true,
      Lastuni: true,
      Sabangia: true,
      Randunica: true,
      Telita: true,
      "Mihai Bravu": true,
      "Dunavatu de Jos": true,
      "Vasile Alecsandri": true,
      Posta: true,
      "Fantana Mare": true,
      Plopul: true,
      Beidaud: true,
      "Sambata Noua": true,
      Camena: true,
      "Mircea Voda": true,
      Carjelari: true,
      Neatarnarea: true,
      Revarsarea: true,
      "Sarighiol de Deal": true,
      Sarinasuf: true,
      Visterna: true,
      Corugea: true,
      Caraorman: true,
      Panduru: true,
      Crisan: true,
      Partizani: true,
      Letea: true,
      Trestenic: true,
      Balabancea: true,
      "Mila 23": true,
      Rahman: true,
      Floresti: true,
      Alba: true,
      Iulia: true,
      Magurele: true,
      Hamcearca: true,
      Maliuc: true,
      Periprava: true,
      Cerbu: true,
      Luminita: true,
      "C.a. Rosetti": true,
      Ceatalchioi: true,
      "Tudor Vladimirescu": true,
      "General Praporgescu": true,
      "Dunavatu de Sus": true,
      Caugagia: true,
      Mesteru: true,
      Atmagea: true,
      Calfa: true,
      Sfistofca: true,
      Victoria: true,
      Colina: true,
      Gorgova: true,
      "Baltenii de Sus": true,
      Closca: true,
      Patlageanca: true,
      "Fantana Oilor": true,
      "Cismeaua Noua": true,
      Caprioara: true,
      "Baltenii de Jos": true,
      "Ilganii de Jos": true,
      Vulturu: true,
      "Ilganii de Sus": true,
      Plauru: true,
      Tichilesti: true,
      Salceni: true,
      Tatanir: true,
      Haidar: true,
      Cardon: true,
      Piatra: true,
      Uzlina: true,
      Caslita: true,
      Ardealu: true,
      "Ostrovu Tataru": true,
      Stanca: true,
    },
    VL: {
      "Ramnicu Valcea": true,
      Dragasani: true,
      Brezoi: true,
      Calimanesti: true,
      Babeni: true,
      Horezu: true,
      Vaideeni: true,
      Goranu: true,
      "Dealu Alunis": true,
      Prajila: true,
      Balcesti: true,
      "Valea Mare": true,
      "Jiblea Veche": true,
      Orlesti: true,
      Livadia: true,
      Pietrari: true,
      Stolniceni: true,
      Prundeni: true,
      Barbatesti: true,
      Calina: true,
      Copacelu: true,
      Costesti: true,
      Dobrusa: true,
      Sirineasa: true,
      "Pietrarii de Sus": true,
      Voineasa: true,
      Susani: true,
      "Gura Suhasului": true,
      Cosani: true,
      Dragoesti: true,
      Ramesti: true,
      Glavile: true,
      Otesani: true,
      Olanesti: true,
      Maldaresti: true,
      Ionesti: true,
      Zlatarei: true,
      Mateesti: true,
      Turcesti: true,
      Bistrita: true,
      Lungesti: true,
      Romani: true,
      Salatrucel: true,
      Otetelisu: true,
      Voicesti: true,
      Bodesti: true,
      Bunesti: true,
      "Targu Gangulesti": true,
      Malaia: true,
      Igoiu: true,
      Greblesti: true,
      Cheia: true,
      Ursi: true,
      Cernisoara: true,
      Vladesti: true,
      Slatioara: true,
      "Babeni-Oltetu": true,
      Budesti: true,
      Manailesti: true,
      "Valea Cheii": true,
      Boisoara: true,
      Ghioroiu: true,
      Fumureni: true,
      "Gura Vaii": true,
      Lalosu: true,
      Copaceni: true,
      Galicea: true,
      Stroesti: true,
      Milostea: true,
      "Folestii de Jos": true,
      Gorunesti: true,
      "Romanii de Sus": true,
      Serbanesti: true,
      Stefanesti: true,
      "Jiblea Noua": true,
      Daesti: true,
      Barza: true,
      Priporu: true,
      Buleta: true,
      Olteanca: true,
      Tomsani: true,
      Sinesti: true,
      "Casa Veche": true,
      Borosesti: true,
      Carstanesti: true,
      Mitrofani: true,
      Fedelesoiu: true,
      Zavideni: true,
      Cioboti: true,
      Radacinesti: true,
      Tetoiu: true,
      Romanesti: true,
      Scundu: true,
      Sutesti: true,
      Cazanesti: true,
      Ciresu: true,
      Mlaceni: true,
      Alunu: true,
      Gaujani: true,
      "Cainenii Mici": true,
      Bogdanesti: true,
      Olteni: true,
      Streminoasa: true,
      "Folestii de Sus": true,
      Mrenesti: true,
      "Cainenii Mari": true,
      "Romanii de Jos": true,
      Dobriceni: true,
      Draganu: true,
      "Izvoru Rece": true,
      "Stanesti-Lunca": true,
      Usurei: true,
      Armasesti: true,
      Madulari: true,
      Dragioiu: true,
      Racovita: true,
      Rugetu: true,
      Amarasti: true,
      Pietreni: true,
      Rosia: true,
      Blejani: true,
      Titesti: true,
      Barsoiu: true,
      "Pausesti-Maglasi": true,
      Verdea: true,
      Ciorasti: true,
      Lunca: true,
      "Muereasca de Sus": true,
      Popesti: true,
      Raureni: true,
      Francesti: true,
      Izvoru: true,
      Sascioara: true,
      Procopoaia: true,
      Muereasca: true,
      Mihaesti: true,
      Dezrobiti: true,
      Cueni: true,
      Linia: true,
      Sanbotin: true,
      Diculesti: true,
      Barsesti: true,
      Creteni: true,
      Greci: true,
      Sparleni: true,
      Botorani: true,
      Vetelu: true,
      Coasta: true,
      Dianu: true,
      Spinu: true,
      Stuparei: true,
      Buzdugan: true,
      Troian: true,
      Cocoru: true,
      Margineni: true,
      Stoenesti: true,
      Avramesti: true,
      Olanu: true,
      Negrulesti: true,
      Fauresti: true,
      Voinesita: true,
      Vladuceni: true,
      Berbesti: true,
      Geamana: true,
      Ocracu: true,
      Barbuceni: true,
      Berislavesti: true,
      "Paraienii de Jos": true,
      Ruda: true,
      "Maldarestii de Jos": true,
      Stoiculesti: true,
      Genuneni: true,
      Ocnita: true,
      Predesti: true,
      Rosioara: true,
      Batasani: true,
      Modoia: true,
      "Pausesti-Otasau": true,
      Ceretu: true,
      Poenari: true,
      Mologesti: true,
      Nemoiu: true,
      Calinesti: true,
      Magura: true,
      Zarnesti: true,
      Ciungetu: true,
      Marcea: true,
      Pausesti: true,
      Scaueni: true,
      Dozesti: true,
      "Bratia din Vale": true,
      Gurisoara: true,
      Teiusu: true,
      Tepesti: true,
      Fartatesti: true,
      Bumbuesti: true,
      Catetu: true,
      Benesti: true,
      Baltateni: true,
      Damteni: true,
      "Dealu Launele": true,
      "Valea Raului": true,
      Obarsia: true,
      Silea: true,
      Ulmetu: true,
      Cremenari: true,
      Slatioarele: true,
      Dangesti: true,
      Teiu: true,
      Bantesti: true,
      Palanga: true,
      Cermegesti: true,
      Ursani: true,
      Nenciulesti: true,
      Dobricea: true,
      Grosi: true,
      Bucsani: true,
      Poiana: true,
      Blidari: true,
      Barzesti: true,
      Varatici: true,
      Baroiu: true,
      Meieni: true,
      Balsoara: true,
      Vladulesti: true,
      Delureni: true,
      Roesti: true,
      Ilaciu: true,
      Rusanesti: true,
      Serbaneasa: true,
      Gradistea: true,
      Barlogu: true,
      Hotaroaia: true,
      Gantulei: true,
      "Malu Vartop": true,
      Zgubea: true,
      Coltesti: true,
      Firesti: true,
      Runcu: true,
      Aldesti: true,
      Balota: true,
      Crangu: true,
      Obrocesti: true,
      Marita: true,
      Milesti: true,
      Burdalesti: true,
      Mogosesti: true,
      Sarulesti: true,
      Stanesti: true,
      Balteni: true,
      "Dealu Mare": true,
      Hotarele: true,
      Irimesti: true,
      Poienari: true,
      Mosteni: true,
      Vulpuesti: true,
      Tuturu: true,
      Ciocaltei: true,
      Turburea: true,
      Condoiesti: true,
      Varleni: true,
      "Bratia din Deal": true,
      Negraia: true,
      Scarisoara: true,
      Ulmetel: true,
      Aninoasa: true,
      Beresti: true,
      Tina: true,
      Meresesti: true,
      Stoicanesti: true,
      Gusoianca: true,
      Mogesti: true,
      Suseni: true,
      Chiceni: true,
      Stanculesti: true,
      Buciumeni: true,
      Herasti: true,
      Iacovile: true,
      Lupoaia: true,
      Contea: true,
      Fotesti: true,
      Giulesti: true,
      Auresti: true,
      "Corbii din Vale": true,
      Barcanele: true,
      Livezi: true,
      Prodanesti: true,
      Tighina: true,
      "Dosu Raului": true,
      "Valea lui Stan": true,
      Gageni: true,
      Robaia: true,
      Butanu: true,
      Gainesti: true,
      Govora: true,
      Rosiile: true,
      Urzica: true,
      "Paraienii de Mijloc": true,
      Bercioiu: true,
      Cherasti: true,
      "Linia Hanului": true,
      Chiricesti: true,
      Tepsenari: true,
      Mazili: true,
      "Dealu Bisericii": true,
      Gatejesti: true,
      Perisani: true,
      Carlogani: true,
      "Valea Balceasca": true,
      Brosteni: true,
      Rapanesti: true,
      Curtea: true,
      Ladesti: true,
      Pesceana: true,
      Stirbesti: true,
      Negreni: true,
      Pausa: true,
      Ciutesti: true,
      Oltetani: true,
      Tatarani: true,
      Bratovesti: true,
      Ganesti: true,
      "Lacustenii de Sus": true,
      Parausani: true,
      Mijlocu: true,
      Fiscalia: true,
      "Paraienii de Sus": true,
      Plesoiu: true,
      Hotarasa: true,
      Scaiosi: true,
      "Valea Babei": true,
      "Pojogi-Cerna": true,
      "Valea Viei": true,
      Andreiesti: true,
      Budele: true,
      Cernelele: true,
      Salistea: true,
      Viisoara: true,
      Valeni: true,
      Cucesti: true,
      Surpatele: true,
      Ciucheti: true,
      Scorusu: true,
      Lespezi: true,
      Pripoare: true,
      Rotarasti: true,
      Zavoieni: true,
      "Linia Dealului": true,
      Slavitesti: true,
      Zatreni: true,
      Gusoeni: true,
      Zmeuratu: true,
      Gruieri: true,
      Cerna: true,
      Feteni: true,
      Paduretu: true,
      "Lacustenii de Jos": true,
      Carcadiesti: true,
      Ciocanari: true,
      "Voicestii din Vale": true,
      Bungetani: true,
      Titireci: true,
      Suta: true,
      "Bradu-Clocotici": true,
      Mecea: true,
      Caciulata: true,
      "Dealu Valeni": true,
      "Valea Gradistei": true,
      Bocsa: true,
      Bulagei: true,
      Badeni: true,
      Preotesti: true,
      "Zatrenii de Sus": true,
      Izbasesti: true,
      "Giulestii de Sus": true,
      Lacusteni: true,
      Magureni: true,
      "Capu Dealului": true,
      Seaca: true,
      Dumbrava: true,
      Cucoiu: true,
      Dobresti: true,
      Pietroasa: true,
      Draganesti: true,
      Ursoaia: true,
      "Francesti-Coasta": true,
      Baiasu: true,
      Barbarigeni: true,
      Budurasti: true,
      Ratalesti: true,
      Robesti: true,
      "Coasta Cerbului": true,
      Ghiobesti: true,
      Sotani: true,
      Balaciu: true,
      Stoilesti: true,
      Pasculesti: true,
      Arsanca: true,
      Ciresul: true,
      Pascoaia: true,
      Milcoiu: true,
      Ostroveni: true,
      Portaresti: true,
      Stanomiru: true,
      Balomireasa: true,
      Ifrimesti: true,
      Varateci: true,
      Baiasa: true,
      Colelia: true,
      Munteni: true,
      Padina: true,
      Obogeni: true,
      Maciuceni: true,
      Opatesti: true,
      "Dealu Scheiului": true,
      Oveselu: true,
      Tanasesti: true,
      Afanata: true,
      Racu: true,
      Glodu: true,
      "Gruiu Lupului": true,
      "Piscu Pietrei": true,
      Plesesti: true,
      Manicea: true,
      Obislavu: true,
      "Launele de Jos": true,
      Marcusu: true,
      Bajenari: true,
      Ciumagi: true,
      Gruiu: true,
      Bujoreni: true,
      Giurgiuveni: true,
      Barcanesti: true,
      Cioponesti: true,
      Dimulesti: true,
      Dragulesti: true,
      Telechesti: true,
      "Valea Lunga": true,
      Dejoi: true,
      Pasarei: true,
      Mijati: true,
      "Valea Ursului": true,
      Cornet: true,
      Neghinesti: true,
      "Dealu Malului": true,
      Patesti: true,
      Balutoaia: true,
      "Piscu Mare": true,
      Mangureni: true,
      Gavanesti: true,
      Oltetu: true,
      Pertesti: true,
      Vatasesti: true,
      Diaconesti: true,
      Bondoci: true,
      Podeni: true,
      "Valea Caselor": true,
      Izvorasu: true,
      Aranghel: true,
      Nicolesti: true,
      Bonciu: true,
      Malu: true,
      Babuesti: true,
      Poenita: true,
      "Valea Valeni": true,
      Maneasa: true,
      Dancai: true,
      Suricaru: true,
      Cuculesti: true,
      Surpati: true,
      Trundin: true,
      "Rapa Caramizii": true,
      Galtofani: true,
      Guguianca: true,
      Netesti: true,
      Becsani: true,
      Giuroiu: true,
      Maricesti: true,
      Saioci: true,
      Gropeni: true,
      Buda: true,
      Gibesti: true,
      "Malu Alb": true,
      Proieni: true,
      Nisipi: true,
      Sarbi: true,
      Dumbravesti: true,
      Fundatura: true,
      Tanislavi: true,
      "Tulei-Campeni": true,
      Banesti: true,
      Mierea: true,
      "Valea Scheiului": true,
      Voiculeasa: true,
      Curaturile: true,
      Suiesti: true,
      Varatica: true,
      Mamu: true,
      Cosota: true,
      Udresti: true,
      "Coasta Mare": true,
      Ciortesti: true,
      "Sub Deal": true,
      "Satu Poieni": true,
      "Valea Macesului": true,
      Seciu: true,
      Tutulesti: true,
      Solicesti: true,
      Zarneni: true,
      Sarsanesti: true,
      Mosoroasa: true,
      Cuci: true,
      Jarostea: true,
      "Linia pe Vale": true,
      Surdoiu: true,
      Cetateaua: true,
      Pripoara: true,
      Deleni: true,
      Golotreni: true,
      Blanoiu: true,
      Miresti: true,
      Teica: true,
      Mazararu: true,
      Tisa: true,
      Caligi: true,
      "Rau Vadului": true,
      Comanca: true,
      Pleasa: true,
      Firijba: true,
      Bradisor: true,
      Corbu: true,
      Aricioaia: true,
      "Dealu Corni": true,
      "Dealu Glameia": true,
      Pietrisu: true,
      Garnicet: true,
      "Valea Alunisului": true,
      Snamana: true,
      Chirculesti: true,
      "Piscu Scoartei": true,
      Lupuiesti: true,
      "Gura Crucilor": true,
      Tufanii: true,
      Ghindari: true,
      Garnicetu: true,
      Strachinesti: true,
      Frasina: true,
      Ginerica: true,
      Gurguiata: true,
      Schitu: true,
      Facai: true,
      Priloage: true,
      Priba: true,
      Rosoveni: true,
      Teiul: true,
    },
    VS: {
      Barlad: true,
      Vaslui: true,
      Husi: true,
      Negresti: true,
      Zorleni: true,
      Murgeni: true,
      Vetrisoaia: true,
      Perieni: true,
      Valeni: true,
      Stanilesti: true,
      Falciu: true,
      Ivesti: true,
      Popeni: true,
      Berezeni: true,
      Codaesti: true,
      Ghermanesti: true,
      Feresti: true,
      "Lunca Banului": true,
      Dumesti: true,
      Costesti: true,
      "Satu Nou": true,
      Bacesti: true,
      Rafaila: true,
      Laza: true,
      Brodoc: true,
      Tanacu: true,
      Puscasi: true,
      Vutcani: true,
      Deleni: true,
      Rasesti: true,
      Zapodeni: true,
      Epureni: true,
      Lipovat: true,
      Duda: true,
      Dodesti: true,
      "Muntenii de Jos": true,
      Puiesti: true,
      "Valea Grecului": true,
      "Corni-Albesti": true,
      "Muntenii de Sus": true,
      Blagesti: true,
      Grivita: true,
      Osesti: true,
      Padureni: true,
      Bunesti: true,
      Ivanesti: true,
      Pribesti: true,
      Suletea: true,
      Buda: true,
      Rosiesti: true,
      Chircesti: true,
      Tutova: true,
      Viisoara: true,
      "Moara Domneasca": true,
      Vinderei: true,
      Ranzesti: true,
      Pogonesti: true,
      Trestiana: true,
      Gugesti: true,
      Albesti: true,
      Carja: true,
      "Moara Grecilor": true,
      Fastaci: true,
      Obarseni: true,
      Poganesti: true,
      Banca: true,
      Chitoc: true,
      Bacani: true,
      "Emil Racovita": true,
      Solesti: true,
      Gherghesti: true,
      Badeana: true,
      Rediu: true,
      Botesti: true,
      Garceni: true,
      Sauca: true,
      Bogdanesti: true,
      Halaresti: true,
      Barzesti: true,
      Radeni: true,
      Miclesti: true,
      Vulturesti: true,
      Tarzii: true,
      Iana: true,
      Manjesti: true,
      Doagele: true,
      Fruntiseni: true,
      Pungesti: true,
      Buhaiesti: true,
      Bursuci: true,
      Salceni: true,
      "Valea Mare": true,
      Todiresti: true,
      Draxeni: true,
      Gusitei: true,
      Oprisita: true,
      Otetoaia: true,
      Tacuta: true,
      Simila: true,
      Balteni: true,
      Poienesti: true,
      Silistea: true,
      Floresti: true,
      Balesti: true,
      Barlalesti: true,
      "Obarsenii Lingurari": true,
      Stoisesti: true,
      Vinetesti: true,
      "Alexandru Vlahuta": true,
      Malusteni: true,
      Serbotesti: true,
      Arsura: true,
      Untesti: true,
      Barbosi: true,
      "Cretestii de Sus": true,
      Tomesti: true,
      Ciocani: true,
      Tutcani: true,
      Grajdeni: true,
      Protopopesti: true,
      Tatarani: true,
      Maraseni: true,
      Bogesti: true,
      Delesti: true,
      Raiu: true,
      Ibanesti: true,
      Avramesti: true,
      "Valea lui Darie": true,
      "Gara Banca": true,
      Oteleni: true,
      Danesti: true,
      Rusca: true,
      Ranceni: true,
      Baltati: true,
      Copaceana: true,
      Schineni: true,
      Hurdugi: true,
      Docani: true,
      Bradesti: true,
      Grumezoaia: true,
      "Rediu Galian": true,
      Portari: true,
      Lupesti: true,
      Harsova: true,
      Toporasti: true,
      Fundatura: true,
      Bahnari: true,
      Pogana: true,
      Floreni: true,
      Manzati: true,
      Bogdana: true,
      Fedesti: true,
      Focseasca: true,
      Giurcani: true,
      Hoceni: true,
      Bacaoani: true,
      Bozia: true,
      "Odaia Bursucani": true,
      Mascurei: true,
      Corbu: true,
      Coroiesti: true,
      Pahnesti: true,
      Peicani: true,
      Dragomiresti: true,
      Parpanita: true,
      Huc: true,
      Musata: true,
      Cretesti: true,
      Armasoaia: true,
      Stioborani: true,
      Mireni: true,
      Rebricea: true,
      "Gura Idrici": true,
      Manzatesti: true,
      Broscosesti: true,
      "Ratesu Cuzei": true,
      "Balteni-Deal": true,
      Chersacosu: true,
      "Fundu Vaii": true,
      Crivesti: true,
      Tifu: true,
      Lalesti: true,
      Gardesti: true,
      Oltenesti: true,
      Chetrosu: true,
      Ghergheleu: true,
      Cetatuia: true,
      Benesti: true,
      "Gura Vaii": true,
      "Stefan cel Mare": true,
      Vladia: true,
      Horga: true,
      "Dumestii Vechi": true,
      Popesti: true,
      Slobozia: true,
      Drujesti: true,
      Secuia: true,
      Teisoru: true,
      Dumasca: true,
      Dranceni: true,
      Cepesti: true,
      Cazanesti: true,
      Siscani: true,
      Lunca: true,
      Ulea: true,
      Cristesti: true,
      Armaseni: true,
      Suseni: true,
      Gagesti: true,
      Recea: true,
      Bulboaca: true,
      Voinesti: true,
      Blesca: true,
      Idrici: true,
      "Valea Lunga": true,
      Craciunesti: true,
      Babusa: true,
      Rusi: true,
      Sarateni: true,
      Tupilati: true,
      Brosteni: true,
      Crang: true,
      Latesti: true,
      Docaneasa: true,
      "Odaia Bogdana": true,
      Plotonesti: true,
      Sarbi: true,
      Bousori: true,
      "1 Decembrie": true,
      Cozmesti: true,
      Dragesti: true,
      Plopi: true,
      "Budu Cantemir": true,
      Malaiesti: true,
      "Tufestii de Jos": true,
      Brahasoaia: true,
      Frasinu: true,
      Rasnita: true,
      Cotic: true,
      Vovriesti: true,
      "Poiana lui Alexa": true,
      Cosca: true,
      Dobroslovesti: true,
      "Gara Rosiesti": true,
      Puntiseni: true,
      Telejna: true,
      "Valea Silistei": true,
      Crasna: true,
      Chitcani: true,
      Vadurile: true,
      Mircesti: true,
      Iezer: true,
      Averesti: true,
      Corodesti: true,
      Iaz: true,
      "Poiana Pietrei": true,
      Glodeni: true,
      Leosti: true,
      Calimanesti: true,
      Igesti: true,
      Jigalia: true,
      Stuhulet: true,
      Chilieni: true,
      Borodesti: true,
      Hreasca: true,
      Mitoc: true,
      Urlati: true,
      Rascani: true,
      Capusneni: true,
      "Cursesti-Vale": true,
      Ursoaia: true,
      Dumbraveni: true,
      Urdesti: true,
      Zizinca: true,
      Cosesti: true,
      Curteni: true,
      Suceveni: true,
      Viltotesti: true,
      Marasesti: true,
      "Bartalus-Mocani": true,
      Polocin: true,
      "Dealu Mare": true,
      "Lacu Babei": true,
      Poiana: true,
      Sasova: true,
      "Valea Oanei": true,
      "Podu Oprii": true,
      Davidesti: true,
      Uncesti: true,
      Stroiesti: true,
      "Tibanestii Buhlii": true,
      Bereasa: true,
      "Cursesti-Deal": true,
      Cioatele: true,
      Ghireasca: true,
      Tabalaesti: true,
      Delea: true,
      Baltateni: true,
      Bolati: true,
      Bumbata: true,
      Trohan: true,
      Budesti: true,
      "Halta Dodesti": true,
      Pahna: true,
      Pochidia: true,
      Tunsesti: true,
      Verdes: true,
      Rosiori: true,
      Tatomiresti: true,
      Morareni: true,
      Paltinis: true,
      Carjoani: true,
      "Coroiestii de Sus": true,
      Plopoasa: true,
      Butucaria: true,
      Movileni: true,
      Tulesti: true,
      Cantalaresti: true,
      Stejaru: true,
      Raduiesti: true,
      Sipeni: true,
      Calugareni: true,
      Orgoiesti: true,
      Belzeni: true,
      Racova: true,
      "Valea Targului": true,
      Radesti: true,
      Crasnaseni: true,
      "Bogdana-Voloseni": true,
      Schinetea: true,
      Vizureni: true,
      Bancesti: true,
      "Crangu Nou": true,
      Vulpaseni: true,
      Manastirea: true,
      "Valea Popii": true,
      Hupca: true,
      Ghicani: true,
      Chetresti: true,
      Racovita: true,
      Bobesti: true,
      Ciofeni: true,
      Tomsa: true,
      "Valea lui Bosie": true,
      Coroiu: true,
      Stancaseni: true,
      Focsa: true,
      Macresti: true,
      Sofronesti: true,
      Bogdanita: true,
      Buscata: true,
      "Posta Elan": true,
      Galtesti: true,
      Cartibasi: true,
      Giurgesti: true,
      Harsoveni: true,
      Ciortolom: true,
      Capotesti: true,
      "Gura Albesti": true,
      Dinga: true,
      "Fundatura Mare": true,
      "Gara Talasman": true,
      Codreni: true,
      Fantanele: true,
      Visinari: true,
      Muntenesti: true,
      "Bartalus-Razesi": true,
      Fulgu: true,
      "Putu Olarului": true,
      "Mihail Kogalniceanu": true,
      Zgura: true,
      "Gara Docaneasa": true,
      Belcesti: true,
      "Stramtura-Mitoc": true,
      "Poienesti-Deal": true,
      Babuta: true,
      Cujba: true,
      Iezerel: true,
      Soci: true,
      Parvesti: true,
      Radaesti: true,
      Rotari: true,
      Uricari: true,
      Vladesti: true,
      Lazu: true,
      Gavanu: true,
      Salcioara: true,
      "Lunca Veche": true,
      "Fantana Blanarului": true,
      Horoiata: true,
      Albita: true,
      Condrea: true,
      Rugaria: true,
      Sofieni: true,
      "Fundatura Mica": true,
      Schitu: true,
      Ganesti: true,
      Botoaia: true,
      Valcele: true,
      Mantu: true,
      Saratu: true,
      Talpigeni: true,
      Similisoara: true,
      "Baile Dranceni": true,
      "Valea Seaca": true,
      Ciuperca: true,
      Pacuraresti: true,
      Arsita: true,
      Corobanesti: true,
      Bejenesti: true,
      Moreni: true,
      Soparleni: true,
      Rapsa: true,
      Semenea: true,
      "Podu Petris": true,
      Dragomanesti: true,
      Raducani: true,
      "Dealu Secarii": true,
      Podeni: true,
      "Valea Lupului": true,
      Albina: true,
      Botoi: true,
      Hordila: true,
      Hordilesti: true,
      Plopeni: true,
      Todireni: true,
    },
    VN: {
      Focsani: true,
      Adjud: true,
      Marasesti: true,
      Odobesti: true,
      Panciu: true,
      Paunesti: true,
      Suraia: true,
      Gugesti: true,
      Homocea: true,
      Vulturu: true,
      Gologanu: true,
      Jaristea: true,
      Milcovul: true,
      Urechesti: true,
      Straoane: true,
      Popesti: true,
      Ploscuteni: true,
      Rastoaca: true,
      Movilita: true,
      Tulnici: true,
      Campuri: true,
      Biliesti: true,
      Sihlea: true,
      Negrilesti: true,
      Campineanca: true,
      Balesti: true,
      "Bordeasca Veche": true,
      Vidra: true,
      Fitionesti: true,
      Budesti: true,
      Cornetu: true,
      Ramniceni: true,
      Golesti: true,
      Cotesti: true,
      Dragosloveni: true,
      Ruginesti: true,
      Dumbraveni: true,
      "Vizantea Manastireasca": true,
      "Nereju Mic": true,
      Pufesti: true,
      "Adjudu Vechi": true,
      Unirea: true,
      Gagesti: true,
      Tataranu: true,
      Burca: true,
      Mera: true,
      "Slobozia Ciorasti": true,
      Obrejita: true,
      Paulesti: true,
      Sindrilari: true,
      Candesti: true,
      Paltin: true,
      Jorasti: true,
      Hangulesti: true,
      Voetin: true,
      Nereju: true,
      Rucareni: true,
      Racoasa: true,
      Bordesti: true,
      Ceardac: true,
      "Vadu Rosca": true,
      Anghelesti: true,
      Vartescoiu: true,
      Ciorasti: true,
      Maicanesti: true,
      Lespezi: true,
      Botarlau: true,
      Ciuslea: true,
      Carligele: true,
      "Domnesti-Targ": true,
      Igesti: true,
      Bogza: true,
      Vulcaneasa: true,
      Iresti: true,
      Tamboesti: true,
      "Gura Calitei": true,
      "Mircestii Noi": true,
      "Slobozia Bradului": true,
      Nanesti: true,
      Ciorani: true,
      Tifesti: true,
      Barsesti: true,
      Naruja: true,
      Mihalceni: true,
      Viisoara: true,
      Vanatori: true,
      Olesesti: true,
      "Satu Nou": true,
      Muncelu: true,
      Coza: true,
      Petresti: true,
      Coroteni: true,
      Faraoanele: true,
      "Crucea de Sus": true,
      Tataru: true,
      "Vizantea Razaseasca": true,
      "Calienii Vechi": true,
      Lamotesti: true,
      Haulisca: true,
      Livezile: true,
      Sarbi: true,
      Copacesti: true,
      Colacu: true,
      Verdea: true,
      "Podu Lacului": true,
      Poiana: true,
      "Mandresti-Moldova": true,
      Maluri: true,
      Siscani: true,
      Diochetirediu: true,
      Dumitresti: true,
      Bolotesti: true,
      Martinesti: true,
      Slimnic: true,
      Calimanesti: true,
      "Calienii Noi": true,
      Valeni: true,
      "Andreiasu de Jos": true,
      Pitulusa: true,
      Vitanesti: true,
      Luncile: true,
      Rachitasu: true,
      Bizighesti: true,
      "Vitanestii de Sub Magura": true,
      Vrancioaia: true,
      Brosteni: true,
      Marasti: true,
      Garoafa: true,
      Jiliste: true,
      Dalhauti: true,
      Padureni: true,
      "Bicestii de Sus": true,
      "Slobozia Botesti": true,
      Spinesti: true,
      Neicu: true,
      "Bordestii de Jos": true,
      Faurei: true,
      Pietroasa: true,
      "Bicestii de Jos": true,
      Buda: true,
      Radulesti: true,
      Serbesti: true,
      Caiata: true,
      Vintileasca: true,
      Bahnele: true,
      Putna: true,
      Blidari: true,
      "Salcia Noua": true,
      Arva: true,
      Haret: true,
      Fetesti: true,
      Varnita: true,
      "Valea Cotesti": true,
      Varsatura: true,
      Topesti: true,
      Oreavu: true,
      "Mandresti-Munteni": true,
      Terchesti: true,
      "Valea Sarii": true,
      Muncei: true,
      Prahuda: true,
      Tichiris: true,
      Dumbrava: true,
      Burcioaia: true,
      Neculele: true,
      Galoiesti: true,
      "Piscu Radului": true,
      Poenile: true,
      Spulber: true,
      Beciu: true,
      Lastuni: true,
      "Crucea de Jos": true,
      Jitia: true,
      Ghimicesti: true,
      "Poiana Cristei": true,
      "Lacu lui Baban": true,
      Manastioara: true,
      Rosioara: true,
      "Bordeasca Noua": true,
      Chiricani: true,
      Trotusanu: true,
      Nistoresti: true,
      Bontesti: true,
      Stupina: true,
      Feldioara: true,
      "Podu Narujei": true,
      "Jitia de Jos": true,
      Livada: true,
      Mahriu: true,
      Plopu: true,
      Catauti: true,
      Belciugele: true,
      Mesteacanu: true,
      Sahastru: true,
      Voloscani: true,
      "Gura Vaii": true,
      Ivancesti: true,
      Poduri: true,
      Repedea: true,
      "Golestii de Sus": true,
      "Rotilestii Mari": true,
      Rachitosu: true,
      "Podu Stoica": true,
      Magura: true,
      Argea: true,
      Milcovel: true,
      Scafari: true,
      Boghesti: true,
      "Vetresti-Herastrau": true,
      Romanesti: true,
      "Rotilestii Mici": true,
      Radacinesti: true,
      Costisa: true,
      Taratu: true,
      "Salcia Veche": true,
      Codresti: true,
      "Carsochesti-Corabita": true,
      Podurile: true,
      Reghiu: true,
      "Podu Schiopului": true,
      Vajaitoarea: true,
      "Dumitrestii-Fata": true,
      Tipau: true,
      Spatareasa: true,
      Tanasoaia: true,
      "Dumitrestii de Sus": true,
      "Valea Milcovului": true,
      Calimaneasa: true,
      Doaga: true,
      Tulburea: true,
      Strajescu: true,
      Rasca: true,
      Batcari: true,
      "Vladnicu de Sus": true,
      "Dealu Cucului": true,
      Frecatei: true,
      Prisecani: true,
      Scanteia: true,
      Valcele: true,
      Bradacesti: true,
      Tinoasa: true,
      Cerbu: true,
      Iugani: true,
      Galbeni: true,
      Serbanesti: true,
      Olteni: true,
      Ruget: true,
      Ramniceanca: true,
      Lepsa: true,
      Matacina: true,
      Gogoiu: true,
      "Dealu Sarii": true,
      Petreanu: true,
      Poienita: true,
      Ungureni: true,
      Ursoaia: true,
      Precistanu: true,
      Motnau: true,
      Arsita: true,
      "Balta Ratei": true,
      Holbanesti: true,
      Batinesti: true,
      Prisaca: true,
      Liesti: true,
      Farcas: true,
      Bradetu: true,
      "Costisa de Sus": true,
      Trestia: true,
      Bichesti: true,
      Trestieni: true,
      Plostina: true,
      Raiuti: true,
      Ochesesti: true,
      Ciolanesti: true,
      Siminoc: true,
      Tanasari: true,
      Titila: true,
      Armeni: true,
      Placinteni: true,
      Bodesti: true,
      "Mircestii Vechi": true,
      Covrag: true,
      Fagetu: true,
      Chiojdeni: true,
      Tepa: true,
      Chitcani: true,
      Roscari: true,
      Corbita: true,
      Rebegari: true,
      Valcani: true,
      "Valea Beciului": true,
      Clipicesti: true,
      Largaseni: true,
      "Poiana Stoichii": true,
      "Dealul Lung": true,
      "Boghestii de Sus": true,
      Cocosari: true,
      Lojnita: true,
      Izvoarele: true,
      Patrascani: true,
      Seciu: true,
      Tutu: true,
      Odobasca: true,
      Maracini: true,
      "Andreiasu de Sus": true,
      "Domnesti-Sat": true,
      Pavalari: true,
      Ghebari: true,
      "Dupa Magura": true,
      "Valea Mica": true,
      Jgheaburi: true,
      Plesesti: true,
      Olareni: true,
      Tabucesti: true,
      Fetig: true,
      Lupoaia: true,
      Gresu: true,
      Hotaru: true,
      "Groapa Tufei": true,
      Valcelele: true,
      Modruzeni: true,
      Moraresti: true,
      "Piscu Reghiului": true,
      "Alexandru Vlahuta": true,
      "Tojanii de Sus": true,
      "Vladnicu de Jos": true,
      "Valea Neagra": true,
      Sotarcari: true,
      "Tojanii de Jos": true,
      Balanesti: true,
      Siretu: true,
      Tisita: true,
    },
  },
  startFields: function () {
    try {
      document.querySelector(
        '#_rsi-cod-form-modal-form [data-type="province_country_field"]'
      ).value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();
      document
        .querySelector(
          '#_rsi-cod-form-modal-form [data-type="province_country_field"]'
        )
        .addEventListener(
          "change",
          _CUSTOM_COD_FORM_PROVINCES.onProvinceChange
        );
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector(
      '#_rsi-cod-form-modal-form [data-type="province_country_field"]'
    ).value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + "</option>";
      document.querySelector(
        '#_rsi-cod-form-modal-form [data-type="city_country_field"]'
      ).innerHTML = html;
      document.querySelector(
        '#_rsi-cod-form-modal-form [data-type="city_country_field"]'
      ).value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + "</option>";

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value])
      .sort()
      .forEach(function (item) {
        html += '<option value="' + item + '">' + item + "</option>";
      });

    document.querySelector(
      '#_rsi-cod-form-modal-form [data-type="city_country_field"]'
    ).innerHTML = html;
    document.querySelector(
      '#_rsi-cod-form-modal-form [data-type="city_country_field"]'
    ).value = "";
  },
};

function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }

    var html = "";

    html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + "</option>";

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data)
      .sort()
      .forEach(function (item) {
        html += '<option value="' + item + '">' + item + "</option>";
      });

    document.querySelector(
      '#_rsi-cod-form-modal-form [data-type="province_country_field"]'
    ).innerHTML = html;

    _CUSTOM_COD_FORM_PROVINCES.startFields();
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        var html = "";

        html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + "</option>";

        Object.keys(_CUSTOM_COD_FORM_PROVINCES.data)
          .sort()
          .forEach(function (item) {
            html += '<option value="' + item + '">' + item + "</option>";
          });

        document.querySelector(
          '#_rsi-cod-form-modal-form [data-type="province_country_field"]'
        ).innerHTML = html;

        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    };

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (
      typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function"
    ) {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_PROVINCE_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_PROVINCE_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_PROVINCE_LABEL) {
        _COD_FORM_PROVINCE_LABEL = item.label;
      }
      item.backendFields.options = [
        {
          label: _COD_FORM_PROVINCE_LABEL,
          value: "",
        },
      ];
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [
        {
          value: "",
          label: _COD_FORM_CITY_LABEL,
        },
      ];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}
